var minifix = {};

/* File: main.js */
minifix = {};
//Keep.
"use strict"
var languagesInfo = {
    languages: ["en", "es", "fr"],
    urls: ["http://www.totousa.com", "https://www-totousa-com.translate.goog/?_x_tr_sl=en&_x_tr_tl=es&_x_tr_hl=en&_x_tr_pto=wapp", "https://www-totousa-com.translate.goog/?_x_tr_sl=en&_x_tr_tl=fr-CA&_x_tr_hl=en&_x_tr_pto=wapp"],
    names: ["ENGLISH", "ESPAÑOL", "FRANÇAIS"],
    hovers: ["Please select your language of preference.", "Por favor confirme su idioma de preferencia.", "Veuillez choisir votre langue."]
};
var herePlatform = null;
if (typeof H != 'undefined') {
    herePlatform = new H.service.Platform({
        apikey: __HERE_APPKEY__,
        useHTTPS: !0
    })
}
const mobileCheck = function() {
    let check = !1;
    (function(a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
            check = !0
    }
    )(navigator.userAgent || navigator.vendor || window.opera);
    return check
};
if (mobileCheck())
    document.body.classList.add('mobile');
var mobile_breakpoint = 960;
var tablet_breakpoint = 1200;
var is_mobile = window.innerWidth <= mobile_breakpoint;
var is_tablet = window.innerWidth <= tablet_breakpoint;
var lastModalTriggerElement = [];
var __skippedSlides = [];
$.xhrPool = [];
$.xhrPool.abortAll = function() {
    $(this).each(function(idx, jqXHR) {
        jqXHR.abort()
    })
}
;
$.arrayFlip = function(arr) {
    var key, tmp_ar = {};
    for (key in arr) {
        if (arr.hasOwnProperty(key)) {
            tmp_ar[arr[key]] = key
        }
    }
    return tmp_ar
}
// observeHeaderPosition();
window.addEventListener('DOMContentLoaded', function() {
    $('footer').addClass('open');
    $('.sticky-filters .aside, .sticky-filters aside').stickyAside({
        breakpoints: {
            min: 640
        }
    })
}, !1);
function setCSSvh() {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`)
}
setCSSvh();
window.addEventListener('resize', setCSSvh);
function washletHistory() {
    var scroll = $(window).scrollTop();
    var height = $(window).height();
    $('.timeline .event').each(function() {
        $(this).toggleClass('on', (scroll + (height * 0.9)) >= $(this).offset().top)
    })
}
function changeElementTag(el, new_tag) {
    if (el.tagName.toLowerCase() == new_tag.toLowerCase())
        return el;
    var new_el = $(`<${new_tag}>${el.innerHTML}</${new_tag}>`);
    el.getAttributeNames().forEach(function(n) {
        new_el.attr(n, el.getAttribute(n))
    });
    if (new_tag.toLowerCase() == 'button' && !el.getAttribute('type'))
        new_el.attr('type', 'button');
    el.replaceWith(new_el[0]);
    if (!new_el[0].id) {
        new_el[0].id = 'el-' + Math.round(Math.random() * 1000000)
    }
    return document.getElementById(new_el[0].id)
}

jQuery(document).ready(function($) {
    positionHeader();
    accessibleFixes();
    initImageHotspots();
    checkLiteratureHash();
    initMikMak();
    initBenefitsModule();
    initFourTilesContentModule();
    initCardsSliderContentModule();
    setTimeout(refreshGoogleTranslate, 500);
    $('header .menu-sub-item.on').each(function() {
        var par = $(this).closest('.menu-item.page');
        par.find('.menu-sub-item.on').removeClass('on');
        if (!par.has('has-dropdown')) {
            par.addClass('on')
        }
    });
    buildCleanovationHTML();
    fixUnsupportedModals();
    initTabs();
    if ($.fn.select2)
        $('select.select2').select2({
            width: '100%'
        });
    $('#stars li').on('mouseover', function() {
        var onStar = parseInt($(this).data('value'), 10);
        $(this).parent().children('li.star').each(function(e) {
            if (e < onStar) {
                $(this).addClass('hover')
            } else {
                $(this).removeClass('hover')
            }
        })
    }).on('mouseout', function() {
        $(this).parent().children('li.star').each(function(e) {
            $(this).removeClass('hover')
        })
    });
    $('#stars li').on('click', function() {
        var onStar = parseInt($(this).data('value'), 10);
        var stars = $(this).parent().children('li.star');
        for (i = 0; i < stars.length; i++) {
            $(stars[i]).removeClass('selected')
        }
        for (i = 0; i < onStar; i++) {
            $(stars[i]).addClass('selected')
        }
    });
    $('#custom_module_totopro .accordion-title').each(function() {
        var element = $(this);
        element.on('click', function() {
            if (!element.TotoPro_module)
                element.TotoPro_module = new TotoPro_module(element.next())
        });
    });
    $('#search-button').on('click', function() {
        var _self = $(this);
        if ($(this).hasClass("on")) {
            $('.search_text').stop().slideToggle("slow", function() {
                $(_self).removeClass("on")
            })
        } else {
            $('form.search_form').css('display', 'block');
            $('.search_text').stop().slideToggle();
            $(this).addClass("on")
        }
        $('input.search_text:visible').focus()
    });
    $('header nav > .nav > li').on('click', function(e) {
        if (!$(this).hasClass('on')) {
            e.preventDefault();
            e.stopPropagation();
            $('header nav > .nav > li').removeClass('on');
            $(this).addClass('on')
        } else {
            $(this).removeClass('on')
        }
    });
    $('header').on('mouseleave', function() {
        $('header nav > .nav > li').removeClass('on')
    });
    $(document).on("click", ".search-filters h3", function() {
        $(this).toggleClass("on").next("ul").toggleClass("on")
    });
    $('header nav > .nav > li').each(function() {
        if ($(this).find('.sub').length > 0) {
            $(this).find('span.link').append('<span class="arrow"></span>')
        }
    });
    $('a.featherlight-preventdefault').on('click', function(e) {
        e.preventDefault()
    });
    $('a.bob').on('click', function(e) {
        e.preventDefault();
        let url = $(this).attr("data-href");
        if (!url)
            return;
        let bob_modal = $('#bob-modal');
        if (bob_modal.length)
            bob_modal.remove();
        let iframe = $(`<iframe src="${url}"></iframe>`);
        $.featherlight(iframe, {
            variant: 'bob-modal'
        })
    });
    $(document).on("click", ".compare-close", function() {
        var cb = $("#compare-bar");
        var cc = $(".compare-close");
        var i = cc.find('i');
        if (cb.hasClass("half-on")) {
            cb.removeClass("half-on");
            i.removeClass("fa-chevron-up");
            i.addClass("fa-chevron-down");
            document.cookie = "compare-arrow=up;secure";
            cc.attr('aria-expanded', 'true');
            if (cb.hasClass("grid-active"))
                $('body').addClass('compare-grid-open');
        } else {
            cb.addClass("half-on");
            i.removeClass("fa-chevron-down");
            i.addClass("fa-chevron-up");
            document.cookie = "compare-arrow=down;secure";
            cc.attr('aria-expanded', 'false');
            $('body').removeClass('compare-grid-open')
        }
    });
    $(".search-input").on('submit', function(e) {
        e.preventDefault()
    });
    $(".search-input").keyup(function(e) {
        if (['ArrowDown', 'ArrowUp'].includes(e.key))
            return;
        var input = $(this);
        if (e.key == 'Enter') {
            e.preventDefault();
            let active = $('#quick-search-result li[role="option"].active a, #quick-search-result li[role="option"].active button').first();
            if (active.length) {} else if (input.val().length >= 3) {
                input.closest('form').off('submit').submit()
            }
            return
        }
    });
    function quickSearch() {
        let input = $("header .search-input");
        let query = input.val();
        if (query.length >= 2) {
            $.ajax({
                type: "POST",
                url: '//' + __website + 'ajax/fe_ajax.php?action=quickSearchResults',
                data: "query=" + query,
                dataType: 'json',
                success: function(data) {
                    let res_count_msg = getResultsCountMessage(data.count);
                    $('#search-form .results-count').text(res_count_msg);
                    $("#quick-search-result").attr('data-count', data.count || 0).show();
                    $("#quick-search-result").html(data.html);
                    input.attr("aria-expanded", "true");
                    setTimeout(refreshGoogleTranslate, 500)
                }
            })
        } else {
            $('#search-form .results-count').text("");
            $("#quick-search-result").attr('data-count', '0').html("").hide();
            input.attr("aria-expanded", "false")
        }
    }
    $(".search-input").keyup(function(e) {
        if (['ArrowDown', 'ArrowUp'].includes(e.key))
            return;
        var input = $(this);
        if (e.key == 'Enter') {
            e.preventDefault();
            let active = $('#quick-search-result li[role="option"].active a, #quick-search-result li[role="option"].active button').first();
            if (active.length) {} else if (input.val().length >= 3) {
                input.closest('form').off('submit').submit()
            }
            return
        }
        debounce(quickSearch, 500, !1, 'quicksearch')()
    });
    $(document).on('click', 'button.prodquick', function() {
        let modal = this.dataset.modal ? document.getElementById(this.dataset.modal) : null;
        if (modal) {
            $.featherlight($(modal), {
                afterContent: function() {
                    if (typeof $.featherlight.defaults.afterContent != 'undefined')
                        $.featherlight.defaults.afterContent.apply(this);
                    let slider = $(".img-slider", this.$content);
                    if (slider.length && !slider.hasClass('slick-slider')) {
                        window.slickSlides = $(".img-slider", this.$content).slick({
                            slidesToScroll: 1,
                            autoplay: !1,
                            variant: "prod-modal-reset",
                            dots: !0,
                            prevArrow: "<i class='material-icons s-prev' aria-hidden='true'>chevron_left</i>",
                            nextArrow: "<i class='material-icons s-next' aria-hidden='true'>chevron_right</i>"
                        })
                    }
                }
            })
        }
    });
    $(document).on("click", ".prod-modal .color-picker", function() {
        if (slickSlides)
            slickSlides.slick("slickGoTo", 0);
        $(this).closest(".prod-modal").find(".first-img img").attr("src", "https://assets.totousa.com/" + $(this).attr("data-sku") + "/options/" + $(this).attr("data-img") + "_285_285.webp")
    });
    $(document).on('click', function(e) {
        if (e.target.id != 'quick-search-result' && e.target.id != 'header-search' && !$(e.target).closest('#quick-search-result') && !e.target.classList.contains('search-input')) {
            $(this).find("#quick-search-result").hide();
            $('#search-form .results-count').text("");
            $('.search-input[aria-expanded]').attr("aria-expanded", "false")
        }
    });
    $(document).on('keydown', '.search-input', function(e) {
        let input = $(this);
        if (['ArrowUp', 'ArrowDown'].includes(e.key)) {
            e.preventDefault();
            input.attr('aria-expanded', 'true');
            $("#quick-search-result").show();
            let allOptions = $('#quick-search-result li[role="option"]');
            let active = allOptions.filter('.active');
            let active_i = active.length ? allOptions.index(active) : -1;
            let next_pos = active_i < allOptions.length - 1 ? active_i + 1 : active_i;
            let next = active.length ? $(allOptions[next_pos]) : allOptions.first();
            let prev_pos = active_i > 0 ? active_i - 1 : 0;
            let prev = active.length ? $(allOptions[prev_pos]) : allOptions.first();
            let option = null;
            switch (e.key) {
            case 'ArrowUp':
                option = prev;
                break;
            case 'ArrowDown':
                option = next;
                break
            }
            if (option) {
                if (active.length)
                    active.removeClass('active');
                option.addClass('active');
                input.attr('aria-activedescendant', option[0].id)
            }
        } else if (e.key == 'Enter') {
            e.preventDefault();
            let active = $('#quick-search-result li[role="option"].active a, #quick-search-result li[role="option"].active button').first();
            if (active.length)
                active[0].click();
        } else if (e.key == 'Escape') {
            $("#quick-search-result").hide();
            $('#search-form .results-count').text("");
            input.attr("aria-expanded", "false")
        }
    });
    $(document).on("click", ".prod-modal .color-picker", function() {
        slickSlides.slick("slickGoTo", 0);
        $(this).closest(".prod-modal").find(".first-img img").attr("src", "https://assets.totousa.com/" + $(this).attr("data-sku") + "/options/" + $(this).attr("data-img") + "_285_285.webp")
    });
    
    $(document).on('click', 'span.jsclick', function(e) {
        var clkF = $(this).data('click');
        switch (clkF) {
        case 'HideFilters':
            hideFilters();
            break;
        case 'ShowFilters':
            showFilters();
            break;
        default:
            break
        }
    });
    $("li.openInNewTab>a, .openInNewTab>.module_content>a:first-child, a.openInNewTab").attr("target", "_blank");
    $(window).resize(function(e) {
        setTimeout(function() {
            var fullscreen = ($('#s7basiczoom_div_container').attr("mode") == "fullscreen");
            var overflow = (fullscreen) ? 'hidden' : 'visible';
            $('body').css("overflow", overflow)
        }, 50)
    });
    if ($('body').hasClass('homepage')) {}
    $(document).on('click', '.accordion-title button:not(.tooltip-trigger):not(.close), button.accordion-title', function() {
        var li = $(this).closest('li');
        li.toggleClass('on');
        $(this).attr('aria-expanded', li.hasClass('on') ? 'true' : 'false')
    });
    $(document).on('click', '.accordion-title button.tooltip-trigger', function(e) {
        e.preventDefault();
        e.stopPropagation();
        let par = $(e.target).closest('.tooltip-wrap');
        let button = par.find('.tooltip-trigger');
        let tooltip = par.find(".tooltip");
        tooltip.toggleClass('on');
        let is_on = tooltip.hasClass('on');
        button.attr('aria-expanded', is_on ? 'true' : 'false');
        par.toggleClass('tooltip-open', is_on)
    });
    $(document).on('click', '.accordion-title .tooltip button.close', function(e) {
        e.preventDefault();
        e.stopPropagation();
        let par = $(e.target).closest('.tooltip-wrap');
        let button = par.find('.tooltip-trigger');
        let tooltip = par.find(".tooltip");
        tooltip.removeClass('on');
        button.attr('aria-expanded', 'false');
        par.removeClass('tooltip-open')
    });
    $('.hotspot', '.click-through-image').first().addClass('on');
    $('.click-through-image').on('click', '.target', function() {
        var target = $(this).data('target');
        $('.target').removeClass('on');
        $(this).addClass('on');
        $('.hotspot').removeClass('on');
        $('.hotspot.target-' + target).addClass('on')
    });
    $('.tab-box').on('click', '.tab', function() {
        if ($(this).hasClass('off')) {
            return !1
        }
        var target = $(this).data('target');
        var container = $(this).closest('.tab-box');
        $('.tab-block', container).removeClass('on');
        $('.tab', container).removeClass('on');
        $(this).addClass('on');
        $(target, container).addClass('on')
    });
    $('.what-this, .tooltip-trigger').on('focusin mouseenter click', function() {
        $('button.what-this, button.tooltip-trigger').attr('aria-expanded', 'false').next('.tooltip').removeClass('on');
        $('.what-this:not(button)').next('.tooltip').removeClass('on');
        var _this = $(this);
        var tag = this.nodeName.toLowerCase();
        if (tag == 'button')
            _this.attr('aria-expanded', 'true');
        var container = $(this).parent();
        var tooltip = $('.tooltip', container).addClass('on');
        $(container).one('mouseleave', function() {
            $(tooltip).removeClass('on');
            if (tag == 'button')
                _this.attr('aria-expanded', 'false');
        })
    });
    $('.tooltip .close').on('click', function() {
        var tooltip = $(this).closest('.tooltip');
        $(tooltip).removeClass('on');
        tooltip.prev('[aria-expanded]').attr('aria-expanded', 'false')
    });
    $(document).on('click', '.select .styledSelect, .styled-select', function(e) {
        if ($(e.target).closest('li').length) {
            chooseSelectOption($(e.target).closest('li'), !1)
        } else {
            var t = $(e.target).closest('.select, .styled-select');
            var isSearchLi = t.hasClass('search') || t.closest('li.search').length;
            var placeholderIptWrapper = t.closest('.placeholder-input');
            if (!isSearchLi) {
                if (t.hasClass('on'))
                    closeSelect(t);
                else
                    openSelect(t)
            } else {
                var btn = t.find('button');
                btn.attr('aria-expanded', t.hasClass('on') ? 'true' : 'false');
                if (placeholderIptWrapper.length)
                    placeholderIptWrapper.toggleClass('on', t.hasClass('on'));
            }
        }
    });
    $(document).on('click', function(e) {
        var select = $('.select.on, .styled-select.on');
        if (!$(e.target).closest('.select, .styled-select').length && select.length) {
            closeSelect(select)
        }
    });
    function openSelect(select) {
        select.addClass('on');
        var btn = select.find('button');
        btn.attr('aria-expanded', 'true');
        var placeholderIptWrapper = select.closest('.placeholder-input');
        if (placeholderIptWrapper.length)
            placeholderIptWrapper.addClass('on');
        select.find('.options li:first-child').focus()
    }
    function closeSelect(select) {
        select.removeClass('on');
        select.find('button').attr('aria-expanded', 'false');
        var placeholderIptWrapper = select.closest('.placeholder-input');
        if (placeholderIptWrapper.length)
            placeholderIptWrapper.removeClass('on');
        select.find('.styledSelect, button').focus()
    }
    $(document).on('keydown', '.select .styledSelect, .styled-select', handleTriggerKeypresses);
    function handleTriggerKeypresses(e) {
        if ([" ", "ArrowUp", "ArrowDown", "End", "Escape", "Enter", "Home"].includes(e.key))
            e.preventDefault();
        var select = $(e.target).closest('.select, .styled-select');
        var isExpanded = select.hasClass('on');
        var selectedOption = select.find('.options li[aria-selected="true"]');
        if (!selectedOption.length)
            selectedOption = select.find('.options li:first-child');
        var prevOption = selectedOption.prev();
        var nextOption = selectedOption.next();
        var firstOption = select.find('.options li:first-child');
        var lastOption = select.find('.options li:last-child');
        switch (e.key) {
        case 'ArrowUp':
            if (isExpanded) {
                prevOption.focus();
                chooseSelectOption(prevOption, !0)
            } else {
                openSelect(select)
            }
            break;
        case 'ArrowDown':
            if (isExpanded) {
                nextOption.focus();
                chooseSelectOption(nextOption, !0)
            } else {
                openSelect(select)
            }
            break;
        case 'Home':
            if (isExpanded) {
                chooseSelectOption(firstOption, !0)
            }
            break;
        case 'End':
            if (isExpanded) {
                chooseSelectOption(lastOption, !0)
            }
            break;
        case 'Tab':
            closeSelect(select);
            break;
        case 'Escape':
            if (isExpanded)
                closeSelect(select);
            break;
        case ' ':
        case 'Enter':
            if (isExpanded) {
                closeSelect(select)
            } else {
                openSelect(select)
            }
            break
        }
    }
    function chooseSelectOption(option) {
        var keepOpen = arguments[1] || !1;
        var rel = option.attr('rel');
        var title = (option.html() || "").replace('*', '<span class="form-required" title="This field is required.">*</span>');
        var select = option.closest('.select');
        select = select.length ? select : option.closest('.styled-select');
        var select_field = select.find('select');
        if (!select_field.length)
            select_field = select.next('select');
        select_field.find('option').prop('selected', !1).removeAttr('selected');
        select_field.find('option[value="' + rel + '"]').prop('selected', !0).attr("selected", "selected");
        select_field.val(rel);
        select_field.trigger('change');
        var txt = title || "Select";
        $('.selected-text', select).html(txt);
        select.find('.options li[aria-selected]').removeAttr('aria-selected').removeClass('selected');
        option.attr('aria-selected', 'true').addClass('selected');
        var op_id = option.attr('id');
        if (!op_id) {
            op_id = 'label-' + (Math.round(Math.random() * 100000));
            option.attr('id', op_id)
        }
        select.find('button').attr('aria-activedescendant', op_id);
        if (!keepOpen) {
            closeSelect(select)
        }
    }
    $('.select > .options li:not(.search),.styled-select > .options li:not(.search)').off('click').on('click', function() {
        chooseSelectOption($(this))
    });
    $('.select > .options li.search input, .styled-select > .options li.search input').off('click keyup change').on('keyup change', function() {
        var s = $(this).val().trim();
        var select = $(this).closest('.select');
        var opts = select.find('.options li:not(.search)');
        if (s) {
            opts.addClass('so-hidden');
            opts.each(function() {
                var li = $(this);
                var txt = li.attr('rel') + ' ' + li.text();
                var reg = new RegExp(s,"gi");
                if (reg.test(txt))
                    li.removeClass("so-hidden");
            })
        } else
            opts.removeClass('so-hidden')
    });
    $('.icheckbox_minimal, .icheckbox_minimal [type="checkbox"]').on('click change', function() {
        var _this = $(this.closest('.icheckbox_minimal'));
        var checkbox = $('input[type="checkbox"]', _this);
        var checked = $(checkbox).prop('checked');
        if (checked) {
            $(checkbox).prop('checked', !1);
            _this.css({
                'background-position': '-48px 0px;'
            });
            _this.removeClass('on')
        } else {
            $(checkbox).prop('checked', !0);
            _this.css({
                'background-position': '-24px 0px;'
            });
            _this.addClass('on')
        }
    });
    $('.trigger', 'footer').on('click', function() {
        $('footer').toggleClass('on');
        $("html,body").animate({
            scrollTop: $("body>.wrapper").outerHeight() + 900
        }, 800)
    });
    var warranty_search = {};
    $('#warranty-registration .search-dynamic.search-toto-toilet').css('display', 'none').attr("data-enabled", 0).closest('.placeholder-input').addClass('hidden');
    $('#warranty-registration .search-dynamic.search-toto-neorest-washlet').css('display', 'none').attr("data-enabled", 0).closest('.placeholder-input').addClass('hidden');
    $('#warranty-registration .search-dynamic.search-toto-washlet').css('display', 'none').attr("data-enabled", 0).closest('.placeholder-input').addClass('hidden');
    function checkWRFcountry() {
        var selected_country = $('#warranty-registration select[name="submitted[contact_information][country]"]').val();
        if (selected_country == 'USA' || selected_country == 'Canada') {
            $('#warranty-registration select[name="submitted[contact_information][HidState__c]"]').addClass("required").css("display", "block").closest('.placeholder-input').removeClass('hidden')
        } else {
            $('#warranty-registration select[name="submitted[contact_information][HidState__c]"]').removeClass("required").css("display", "none").closest('.placeholder-input').addClass('hidden')
        }
    }
    checkWRFcountry();
    $('#warranty-registration select[name="submitted[contact_information][country]"]').on("change", checkWRFcountry);
    $('#warranty-registration select[name="submitted[purchase_information][Category__c]"]').on("change", function() {
        $('#warranty-registration .search-dynamic').css('display', 'none').attr("data-enabled", 0).removeClass("required").closest('.placeholder-input').addClass('hidden');
        $('#warranty-registration .search-dynamic select.form-select').removeClass("required");
        var selected_name = $(this).val();
        switch (selected_name.toLowerCase()) {
        case 'one-piece toilet':
        case 'two-piece toilet':
        case 'wall-hung toilet':
            $('#warranty-registration .search-dynamic.search-toto-toilet').css('display', 'block').attr("data-enabled", 1).addClass("required").closest('.placeholder-input').removeClass('hidden');
            $('#warranty-registration .search-dynamic.search-toto-toilet select.form-select').addClass("required");
            break;
        case 'neorest':
            $('#warranty-registration .search-dynamic.search-toto-neorest').css('display', 'block').addClass("required").attr("data-enabled", 1).closest('.placeholder-input').removeClass('hidden');
            $('#warranty-registration .search-dynamic.search-toto-neorest select.form-select').addClass("required");
            break;
        case 'washlet':
            $('#warranty-registration .search-dynamic.search-toto-washlet').css('display', 'block').attr("data-enabled", 1).addClass("required").closest('.placeholder-input').removeClass('hidden');
            $('#warranty-registration .search-dynamic.search-toto-washlet select.form-select').addClass("required");
            break;
        default:
            break
        }
        var selected = $(this).find('option[value="' + selected_name + '"]');
        var option_type = $(selected).attr('data-cat-sid') != undefined ? 'cat' : 'subcat';
        var option_sid = $(selected).attr('data-' + option_type + '-sid');
        if (warranty_search.cat_sid != option_sid) {
            $('#product-search').val('');
            $('#product-sku').val('NONE');
            $('#product-series').val('NONE')
        }
        warranty_search.cat_type = option_type;
        warranty_search.cat_sid = option_sid
    });
    $('#back-to-top').on('click tap', function() {
        $("html, body").animate({
            scrollTop: 0
        }, "slow")
    });
    $(document).on('focus', '#product-search', function(e) {
        $(this).parent().parent().find('.compact-form-label').hide()
    });
    $(document).on('focusout', '#product-search', function(e) {
        if ($(this).val() == "") {
            $(this).parent().parent().find('.compact-form-label').show()
        }
    });
    $(document).on('input', '#product-search', function() {
        $('#product-sku').val('NONE');
        $('#product-series').val('NONE');
        var min_length = 2;
        var len = $(this).val().length;
        if (len >= min_length) {
            warranty_search.search_term = $(this).val();
            product_search(warranty_search)
        } else {
            $('#product-search-wrapper .results').css('display', 'none');
            $('#product-search-wrapper .results-count').text('');
            var input = $('#warranty-registration #product-search');
            input.attr('aria-expanded', 'false').focus()
        }
    });
    $(document).on('click', '#product-search-wrapper .results .result', function() {
        if (!$(this).hasClass("none")) {
            $('#product-search').val($(this).html()).removeClass("error").prop('readonly', !0).prop('disabled', !0);
            $('#product-sku').val($(this).attr('data-sku'));
            $('#product-series').val($(this).attr('data-series'));
            $('#product-search-wrapper').find('.product-error').remove();
            $('#product-search-wrapper').append('<a role="button" href="javascript:;" onclick="$(\'#product-search\').val(\'\').prop(\'readonly\', false).prop(\'disabled\', false).focus() && $(this).remove();" class="clear-product-search" aria-label="Close"><i class="material-icons" aria-hidden="true">close</i></a>');
            $(this).parent().css('display', 'none');
            var input = $('#warranty-registration #product-search');
            input.attr('aria-expanded', 'false');
            $('#product-search-wrapper .results-count').text('')
        }
    });
    $(document).on('focusout', '#product-search', function() {
        $('#product-search-wrapper').find('.product-error').remove();
        $('#product-search-wrapper').find('.has-error').removeClass('has-error');
        setTimeout(function() {
            $('#product-search-wrapper .results').css('display', 'none');
            var input = $('#warranty-registration #product-search');
            input.attr('aria-expanded', 'false');
            $('#product-search-wrapper .results-count').text('')
        }, 500);
        if ($('#product-sku').val() == 'NONE' || $('#product-series').val() == 'NONE') {
            $(this).addClass("error")
        } else {
            $(this).removeClass("error")
        }
    });
    $(document).on('keydown', '#product-search', function(e) {
        let input = $(this);
        if (['ArrowUp', 'ArrowDown'].includes(e.key)) {
            e.preventDefault();
            input.attr('aria-expanded', 'true');
            $('#prod-results').show();
            let active = $('#prod-results li.active');
            let next = active.length ? active.next() : $('#prod-results li').first();
            let prev = active.length && active.prev().length ? active.prev() : $('#prod-results li').first();
            let option = null;
            active.removeClass('active');
            switch (e.key) {
            case 'ArrowUp':
                option = prev;
                break;
            case 'ArrowDown':
                option = next;
                break
            }
            option.addClass('active');
            input.attr('aria-activedescendant', option[0].id)
        } else if (e.key == 'Enter') {
            e.preventDefault();
            let active = $('#prod-results li.active');
            if (active.length)
                active.trigger('click');
        } else if (e.key == 'Escape') {
            input.attr('aria-expanded', 'false');
            $('#prod-results').hide();
            $('#product-search-wrapper .results-count').text('')
        }
    });
    $(document).on('keydown', '#product-search', function(e) {
        let input = $(this);
        if (['ArrowUp', 'ArrowDown'].includes(e.key)) {
            e.preventDefault();
            input.attr('aria-expanded', 'true');
            $('#prod-results').show();
            let active = $('#prod-results li.active');
            let next = active.length ? active.next() : $('#prod-results li').first();
            let prev = active.length && active.prev().length ? active.prev() : $('#prod-results li').first();
            let option = null;
            active.removeClass('active');
            switch (e.key) {
            case 'ArrowUp':
                option = prev;
                break;
            case 'ArrowDown':
                option = next;
                break
            }
            option.addClass('active');
            input.attr('aria-activedescendant', option[0].id)
        } else if (e.key == 'Enter') {
            e.preventDefault();
            let active = $('#prod-results li.active');
            if (active.length)
                active.trigger('click');
        } else if (e.key == 'Escape') {
            input.attr('aria-expanded', 'false');
            $('#prod-results').hide()
        }
    });
    if ($('.subpage.type_general[class*=page-history-of-washlets]').length > 0) {
        $(window).scroll(function(e) {
            washletHistory()
        });
        function __toggleVisibility() {
            let btn = $(this);
            let id = btn.attr('aria-controls');
            let cont = $(`#${id}`);
            let on = btn.attr('aria-expanded') == 'true';
            btn.attr('aria-expanded', on ? 'false' : 'true').text(on ? 'Read More' : 'Close');
            cont.toggleClass('on', !on)
        }
        $('.timeline .event button[aria-controls]', this).on('click', __toggleVisibility)
    }
    function product_search(search) {
        var input = $('#warranty-registration #product-search');
        input.attr('aria-activedescendant', '');
        $.ajax({
            type: "POST",
            url: '//' + __website + 'ajax/fe_ajax.php?action=productSearch',
            dataType: 'json',
            data: search,
            success: function(response) {
                var results = $('#warranty-registration #product-search-wrapper .results');
                var c = response.data.length;
                var res_txt = (c > 0 ? c : 'Zero') + ' result' + (c == 1 ? '' : 's') + ' found';
                $('#product-search-wrapper .results-count').text(res_txt);
                if (response.data.length > 0) {
                    results.html('').css('display', 'block');
                    input.attr('aria-expanded', 'true');
                    $.each(response.data, function(k, v) {
                        results.append('<li id="result-' + v.sid + '" role="option" class="result" data-series="' + response.data[k].item_name.replace(/"/g, "&quot;") + '" data-sku="' + response.data[k].basesku + '">' + response.data[k].basesku + ' - ' + response.data[k].item_name + '</li>')
                    });
                    var c = response.data.length;
                    var r = c == 1 ? 'result' : 'results';
                    $('.prod-results-count').html(`${c} ${r} found`)
                } else {
                    results.html('').css('display', 'block');
                    results.append('<li class="result none">No Results Found</li>');
                    results.css('display', 'none');
                    input.attr('aria-expanded', 'false').focus();
                    $('.prod-results-count').html(`Zero results found`)
                }
                setTimeout(refreshGoogleTranslate, 500)
            }
        })
    }
    $('#warranty-registration select[name="submitted[purchase_information][Category__c]"]').trigger("change");
    $('#warranty-registration').on('submit', function(e) {
        e.preventDefault();
        var validation = validate_form_required("#warranty-registration");
        if (validation) {
            grecaptcha.ready(function() {
                grecaptcha.execute(__reCAPTCHA_SITE_KEY__, {
                    action: 'submit'
                }).then(function(token) {
                    $('#warranty-registration .form-submit').addClass("disabled");
                    var overlay = $('<div class="form-loading-overlay"></div>');
                    $('#warranty-registration').append(overlay);
                    $("html, body").animate({
                        scrollTop: 0
                    }, "slow");
                    $.ajax({
                        type: "POST",
                        url: '//' + __website + 'ajax/fe_form_ajax.php?action=submitWarranty',
                        dataType: 'json',
                        data: $("#warranty-registration").serialize() + '&token=' + token,
                        success: function(response) {
                            if (response.success) {
                                $('#warranty-registration').find('.form-loading-overlay').remove();
                                $('#warranty-registration .message.error').attr('aria-live', 'off').html('');
                                $("html, body").animate({
                                    scrollTop: 0
                                }, "slow");
                                $('#warranty-registration').html('<h4>Your registration has successfully been submitted.</h4>')
                            } else {
                                $('#warranty-registration').find('.form-loading-overlay').remove();
                                $('#warranty-registration .message.error').attr('aria-live', 'polite').html('Unable to submit the form. Please contact us to resolve this issue.').show()
                            }
                        },
                        complete: function() {
                            $('#warranty-registration .form-submit').removeClass("disabled");
                            setTimeout(refreshGoogleTranslate, 500)
                        }
                    })
                }, console.log)
            })
        } else {
            $('#warranty-registration .message.error').attr('aria-live', 'polite').html('Please fill out the required fields.');
            $('html, body').animate({
                scrollTop: $('#warranty-registration').offset().top - 200
            }, 'slow')
        }
    });
    $('input.form-text').focus(function(e) {
        $(this).parent().find('.compact-form-label').hide()
    });
    $('input.form-text').focusout(function(e) {
        if ($(this).val() == "") {
            $(this).parent().find('.compact-form-label').show()
        }
    });
    $('textarea.form-textarea').focus(function(e) {
        $(this).parent().parent().find('.compact-form-label').hide()
    });
    $('textarea.form-textarea').focusout(function(e) {
        if ($(this).val() == "") {
            $(this).parent().parent().find('.compact-form-label').show()
        }
    });
    $('#toto-customer-support-form [name$="[country]"]').on('change', function(e) {
        let country = e.target.value;
        let state_input = $('#webform-component-contact-information--HidState--c');
        state_input.attr('data-country', country);
        let default_label = 'State/Province';
        let label = state_input.find('label');
        let select = state_input.find('select');
        let options = state_input.find('option, [role="option"]');
        let state = select.val();
        options.removeAttr('style');
        options.show();
        switch (country) {
        case 'US':
            options.filter('[data-country="CA"]').hide();
            if (state && select.find(`option[value="${state}"][data-country="CA"]`).length)
                select.val('').trigger('change');
            label.text('State');
            break;
        case 'CA':
            options.not('[data-country="CA"]').hide();
            if (state && select.find(`option[value="${state}"]:not([data-country="CA"])`).length)
                select.val('').trigger('change');
            label.text('Province');
            break;
        default:
            label.text(default_label);
            select.val('').trigger('change');
            state_input.find('li.label[data-country="CA"]').css('margin-top', '20px');
            break
        }
    });
    $('.form-submit.form-support').closest('form').on('submit', function(e) {
        e.preventDefault();
        $('#captcha_code').removeClass("error");
        var form = $("#toto-customer-support-form");
        var validation = validate_form_required("#toto-customer-support-form");
        if (validation) {
            grecaptcha.ready(function() {
                grecaptcha.execute(__reCAPTCHA_SITE_KEY__, {
                    action: 'submit'
                }).then(function(token) {
                    $('button', form).addClass("disabled");
                    $.ajax({
                        type: "POST",
                        url: '//' + __website + 'ajax/fe_form_ajax.php?action=submitSupport',
                        dataType: 'json',
                        data: $("#toto-customer-support-form").serialize() + '&token=' + token,
                        success: function(response) {
                            if (response.success) {
                                $("html, body").animate({
                                    scrollTop: 0
                                }, "slow");
                                $('span.form-success').show();
                                reset_form("#toto-customer-support-form")
                            } else {
                                alert(response.message || "An error occurred!")
                            }
                        },
                        complete: function() {
                            $('button', form).removeClass("disabled");
                            setTimeout(refreshGoogleTranslate, 500)
                        }
                    })
                }, console.log)
            })
        }
    });
    $('.form-submit.form-feedback').closest('form').on('submit', function(e) {
        e.preventDefault();
        var form = $(this);
        form.find('input[name="captcha_code"]').removeClass("error");
        var validation = validate_form_required(form);
        if (typeof location.origin === 'undefined') {
            location.origin = location.protocol + '//' + location.host
        }
        if (validation) {
            grecaptcha.ready(function() {
                grecaptcha.execute(__reCAPTCHA_SITE_KEY__, {
                    action: 'submit'
                }).then(function(token) {
                    $('button', form).addClass("disabled");
                    $.ajax({
                        type: "POST",
                        url: '//' + __website + 'ajax/fe_form_ajax.php?action=submitFeedback',
                        dataType: 'json',
                        data: form.serialize() + '&token=' + token,
                        success: function(response) {
                            if (response.success) {
                                reset_form(".featherlight #toto-customer-feedback-form");
                                alert("Feedback submitted!");
                                window.location.reload()
                            } else {
                                alert(response.message || "An error occurred!")
                            }
                        },
                        complete: function() {
                            $('button', form).removeClass("disabled");
                            setTimeout(refreshGoogleTranslate, 500)
                        }
                    })
                }, console.log)
            })
        }
    });
    $("#write_review_wr").on('click', function(e) {
        $('.technicians-list-wr').html('<div class="div-technician-name fb-50 fb-xs-100"><input type="hidden" name="company_id_wr" value="' + $(this).attr('data-id') + '"><span class="dot"></span><span class="technician-name">' + decodeURIComponent($(this).attr('data-company-name')).replace(/\+/g, ' ') + '</span></div>')
    });
    $("#modal_mt").on('click', function(e) {
        $('#technicians_list').empty();
        var clone;
        $(".page-certified-installer .result-with-data[data-company-id='" + $(this).attr('data-id') + "']").each(function() {
            clone = $('.template.div-technician-name').clone()[0].outerHTML;
            clone = $(clone.replace('d-none', ''));
            $(clone).find('input').val($(this).data('company-id'));
            $(clone).find('.technician-name').text(decodeURIComponent($(this).data('company-name')).replace(/\+/g, ' '));
            clone.removeClass('template');
            $('#technicians_list').append(clone)
        })
    });
    $("#single_email_checked_ci").on('click', function(e) {
        if ($(this).attr('data-id') === undefined || $(this).attr('data-id').length == 0) {
            e.preventDefault();
            $(".pop-up-content").empty();
            $(".pop-up-content").append('Please select one technician from the list.');
            $(".pop-up-alert").addClass("on");
            $(".popup-background").addClass("popup-background-on")
        } else {
            $("#company_id_st").val($("#single_email_checked_ci").attr('data-id'));
            $.featherlight($('#modal_single_technicians'), {})
        }
    });
    $("#single_email_ci").on('click', function(e) {
        $("#company_id_st").val($("#single_email_ci").attr('data-id'))
    });
    $('.form-s.btn-wr').closest('form').on('submit', function(e) {
        e.preventDefault();
        var form = $('.featherlight #toto-customer-write-review-form');
        $('.featherlight #toto-customer-write-review-form #stars').parent().removeClass("required error");
        var validation = validate_form_required(".featherlight #toto-customer-write-review-form");
        if (isNaN(parseInt($('#stars li.selected').last().data('value'), 10))) {
            validation = !1;
            $('.featherlight #toto-customer-write-review-form #stars').parent().addClass("required error")
        }
        if (validation) {
            grecaptcha.ready(function() {
                grecaptcha.execute(__reCAPTCHA_SITE_KEY__, {
                    action: 'submit'
                }).then(function(token) {
                    $('button', form).addClass("disabled");
                    $.ajax({
                        type: "POST",
                        url: '//' + __website + 'ajax/fe_form_ajax.php?action=submitWriteReview',
                        dataType: 'json',
                        data: form.serialize() + '&rating=' + parseInt($('#stars li.selected').last().data('value'), 10) + '&token=' + token,
                        success: function(response) {
                            if (response.success) {
                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push({
                                    'event': 'installer-write-review'
                                });
                                reset_form(".featherlight #toto-customer-write-review-form");
                                alert("Information submitted!");
                                window.location.reload()
                            } else {
                                alert(response.message || "There was an error. Please try again.")
                            }
                        },
                        complete: function() {
                            $('button', form).removeClass("disabled");
                            setTimeout(refreshGoogleTranslate, 500)
                        }
                    })
                }, console.log)
            })
        }
    });
    $('.form-s.btn-mt').closest('form').on('submit', function(e) {
        e.preventDefault();
        var validation = validate_form_required(".featherlight #toto-customer-email-technicians-form");
        if (validation) {
            if ($('.featherlight #toto-customer-email-technicians-form .div-technician-name [name^="company_id_mt"]').val() == '') {
                if ($('.page-certified-installer #toto-customer-email-technicians-form .div-technician-name [name^="company_id_mt"]').val() != '') {
                    $('.featherlight #toto-customer-email-technicians-form .div-technician-name [name^="company_id_mt"]').val($('.page-certified-installer #toto-customer-email-technicians-form .div-technician-name [name^="company_id_mt"]').val())
                } else {
                    validation = !1;
                    alert("Please close this pop-up and try again.")
                }
            }
        }
        if (validation) {
            var form = $(".featherlight #toto-customer-email-technicians-form");
            grecaptcha.ready(function() {
                grecaptcha.execute(__reCAPTCHA_SITE_KEY__, {
                    action: 'submit'
                }).then(function(token) {
                    $('button', form).addClass("disabled");
                    $.ajax({
                        type: "POST",
                        url: '//' + __website + 'ajax/fe_form_ajax.php?action=submitEmailTechnicians',
                        dataType: 'json',
                        data: form.serialize() + '&token=' + token,
                        success: function(response) {
                            if (response.success) {
                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push({
                                    'event': 'installer-receive-info'
                                });
                                reset_form(".featherlight #toto-customer-email-technicians-form");
                                alert("Information submitted!");
                                window.location.reload()
                            } else {
                                alert(response.message || "There was an error. Please try again.")
                            }
                        },
                        complete: function() {
                            $('button', form).addClass("disabled");
                            setTimeout(refreshGoogleTranslate, 500)
                        }
                    })
                }, console.log)
            })
        }
    });
    $('.form-s.btn-st').closest('form').on('submit', function(e) {
        e.preventDefault();
        var validation = validate_form_required(".featherlight #toto-customer-email-single-technicians-form");
        if (validation) {
            if ($('.featherlight #toto-customer-email-single-technicians-form #company_id_st').val() == '') {
                if ($('.page-certified-installer #toto-customer-email-single-technicians-form #company_id_st').val() != '') {
                    $('.featherlight #toto-customer-email-single-technicians-form #company_id_st').val($('.page-certified-installer #toto-customer-email-single-technicians-form #company_id_st').val())
                } else {
                    validation = !1;
                    alert("Please close this pop-up and try again.")
                }
            }
        }
        if (validation) {
            var form = $(".featherlight #toto-customer-email-single-technicians-form");
            grecaptcha.ready(function() {
                grecaptcha.execute(__reCAPTCHA_SITE_KEY__, {
                    action: 'submit'
                }).then(function(token) {
                    $('button', form).addClass("disabled");
                    $.ajax({
                        type: "POST",
                        url: '//' + __website + 'ajax/fe_form_ajax.php?action=submitSingleEmailTechnicians',
                        dataType: 'json',
                        data: form.serialize() + '&token=' + token,
                        success: function(response) {
                            if (response.success) {
                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push({
                                    'event': 'installer-contact'
                                });
                                alert("Information submitted!");
                                window.location.reload()
                            } else {
                                alert(response.message || "There was an error. Please try again.")
                            }
                        },
                        complete: function() {
                            $('button', form).removeClass("disabled");
                            setTimeout(refreshGoogleTranslate, 500)
                        }
                    })
                }, console.log)
            })
        }
    });
    $('form#schedule-a-visit').on('submit', function(e) {
        e.preventDefault();
        var form = $(e.target);
        $('input[name="captcha_code"]', form).removeClass("error");
        var validation = validate_form_required(form);
        if (validation) {
            grecaptcha.ready(function() {
                grecaptcha.execute(__reCAPTCHA_SITE_KEY__, {
                    action: 'submit'
                }).then(function(token) {
                    $('button', form).addClass("disabled");
                    $.ajax({
                        type: "POST",
                        url: '//' + __website + 'ajax/fe_form_ajax.php?action=submitScheduleAVisit',
                        dataType: 'json',
                        data: form.serialize() + '&token=' + token,
                        success: function(response) {
                            if (response.success) {
                                alert("Information submitted!");
                                $.featherlight.close()
                            } else {
                                alert(response.message || "There was an error. Please try again.")
                            }
                        },
                        error: function(xhr, err) {
                            alert("An error occurred" + (err ? ": " + err : "."))
                        },
                        complete: function() {
                            $('button', form).removeClass("disabled");
                            setTimeout(refreshGoogleTranslate, 500)
                        }
                    })
                }, console.log)
            })
        }
    });
    $('form#claim-discount, form#claim-bmsm').on('submit', function(e) {
        e.preventDefault();
        var form = $(e.target);
        $('input[name="captcha_code"]', form).removeClass("error");
        var validation = validate_form_required(form);
        const __error = function() {
            let error_message = arguments[0] ? '<br><br>' + arguments[0] : '';
            let error_el = form.find('.message.error');
            if (!error_el.length)
                error_el = $('<div class="error message" role="alert"></div>').insertAfter(form.find('.form-actions'));
            error_el.html(`
				<i class="material-icons" aria-hidden="true">error</i> There has been an error. Please contact customer service if you continue to receive this message.
				${error_message}
				`);
            error_el.show()
        }
        if (validation) {
            const action = e.target.id === 'claim-discount' ? 'claimDiscount' : 'claimBMSM';
            const event = action === 'claimDiscount' ? 'special-offer-submission' : 'special-offer-submission-BMSM';
            form.find('.message.error').remove();
            grecaptcha.ready(function() {
                console.log('recaptcha ready');
                grecaptcha.execute(__reCAPTCHA_SITE_KEY__, {
                    action: 'submit'
                }).then(function(token) {
                    form.find('button').addClass('disabled');
                    $.ajax({
                        type: "POST",
                        url: '//' + __website + 'ajax/fe_form_ajax.php?action=' + action,
                        dataType: 'json',
                        data: form.serialize() + '&token=' + token,
                        success: function(response) {
                            if (response.success) {
                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push({
                                    'event': event
                                });
                                form.find('.success-message').removeClass("hidden");
                                form.find('.form-section-inner, .foot').addClass("hidden")
                            } else {
                                __error(response.message)
                            }
                        },
                        error: function(xhr, err) {
                            __error('Request ' + xhr.status + ' Error : ' + xhr.statusText)
                        },
                        complete: function() {
                            form.find('button').removeClass('disabled');
                            setTimeout(refreshGoogleTranslate, 500)
                        }
                    })
                }, console.log)
            }, error => console.log('ready error', error))
        }
    });
    if ($("select[name='submitted[inquiry_type][reason2]']").length) {
        $("select[name='submitted[inquiry_type][reason2]']").on("change", function() {
            var value = this.value;
            var code = $("#webform-component-inquiry-type--reason2 ul.options li[rel='" + value + "']").data("code");
            if (!code)
                $("#webform-component-inquiry-type--reason2 ul.options li[rel][data-code]").data("code");
            if (!code)
                code = "";
            var reg = new RegExp(code);
            $("#webform-component-inquiry-type--subreason ul.options li").each(function() {
                var code2 = $(this).data("code");
                if (!code2)
                    return !0;
                if (code2.match(reg))
                    $(this).show();
                else
                    $(this).hide()
            });
            var subreason = $("select[name='submitted[inquiry_type][subreason]']").val();
            if (subreason && $("#webform-component-inquiry-type--subreason ul.options li[rel='" + subreason + "']").length) {
                if (!$("#webform-component-inquiry-type--subreason ul.options li[rel='" + subreason + "']").is(":visible")) {
                    $("#webform-component-inquiry-type--subreason div.select").trigger("click");
                    $($("#webform-component-inquiry-type--subreason ul.options li[rel][data-code]:visible").get(0)).trigger("click")
                }
            }
        });
        if (!$("select[name='submitted[inquiry_type][reason2]']").val()) {
            $("#webform-component-inquiry-type--reason2 div.select").trigger("click");
            $("#webform-component-inquiry-type--reason2 ul.options li[rel][data-code]:first-child").trigger("click")
        }
        if (!$("select[name='submitted[inquiry_type][subreason]']").val()) {
            $("#webform-component-inquiry-type--subreason div.select").trigger("click");
            $($("#webform-component-inquiry-type--subreason ul.options li[rel][data-code]:visible").get(0)).trigger("click")
        }
    }
    setTimeout(function() {
        resize_filters()
    }, 200);
    $(window).on("resize", function() {
        resize_filters();
        featured_product_resize();
        setMobileImages();
        $('.washlet-features-hover-colmid .module.html .pulsating-container').hide();
        checkResponsiveAccordions()
    });
    function compareScrollCallback() {
        is_mobile = window.innerWidth <= mobile_breakpoint;
        is_tablet = window.innerWidth <= tablet_breakpoint
    }
    $(window).on("scroll resize", compareScrollCallback);
    $('body').on("scroll", compareScrollCallback);
    $('.sharethis').each(function(k, el) {
        el = $(el);
        var url = window.location.href
          , title = $('title').html()
          , img = '';
        if ($('.wrapper .main img[src]').length)
            img = $('.wrapper .main img[src]').first().attr('src');
        else {
            $('.wrapper img[src]').each(function() {
                if (img)
                    return !1;
                img = $(this).attr('src');
                if (img.match(/icon_share/i)) {
                    img = ''
                }
            })
        }
        if (img && typeof img == 'string' && img.trim() != '') {
            if (!img.match(/^https?\:\/\/[a-z0-9]{1,}\.totousa.com/i)) {
                if (__CDNBASEURL__) {
                    img = __CDNBASEURL__ + (!__CDNBASEURL__.match(/\/$/i) ? '/' : '') + img.trim().substring(1, img.length)
                } else {
                    img = 'https://' + __website + img.trim().substring(1, img.length)
                }
            }
        } else {
            img = ''
        }
        var switchTo5x = !0;
        var sharethisDom = $('<div class="social page-social">' + '<ul class="sharethis-wrapper">' + '<li><span role="link" aria-label="Share this in email" tabindex="0" st_url="' + url + '" st_title="' + title + '" class="st_email_large" displaytext="email"></span></li>' + '<li><span role="link" aria-label="Share this on Twitter" tabindex="0" st_url="' + url + '" st_title="' + title + '" class="st_twitter_large" displaytext="twitter"></span></li>' + '<li><span role="link" aria-label="Share this on Facebook" tabindex="0" st_url="' + url + '" st_title="' + title + '" class="st_facebook_large" displaytext="facebook"></span></li>' + '<li><span role="link" aria-label="Share this on Pinterest" tabindex="0" st_url="' + url + '" st_title="' + title + '" class="st_pinterest_large" displaytext="pinterest"></span></li>' + '<li><span role="link" aria-label="Share this on Linkedin" tabindex="0" st_url="' + url + '" st_title="' + title + '" class="st_linkedin_large" displaytext="linkedin"></span></li>' + '<!--<li><span role="link"  aria-label="Share this on Instagram" tabindex="0" st_url="' + url + '" st_title="' + title + '" class="st_instagram_large" displaytext="instagram"></span></li>-->' + '</ul>' + '</div>' + '</div>')
          , parent = $(el.parents('.module')[0])
          , tit = $($('.module_content', parent)[0]);
        tit.addClass('pageTitle');
        var otherH1s = tit.closest('.module').find('>.module:not(.pageTitle) h1');
        var otherH2s = tit.closest('.module').find('>.module:not(.pageTitle) h2');
        otherH1s.each(function() {
            $(this).replaceWith('<h2 class="h1">' + $(this).html() + '</h2>')
        });
        if (otherH1s.length) {
            otherH2s.each(function() {
                $(this).replaceWith('<h3 class="h2">' + $(this).html() + '</h3>')
            })
        }
        var clone = el.html(sharethisDom).hide().clone();
        el.remove();
        clone.show();
        $('[st_url]', clone).on('click', function(e) {
            e.preventDefault();
            var s = $(e.currentTarget)
              , dt = s.attr('displaytext')
              , url = encodeURIComponent(s.attr('st_url'))
              , title2 = encodeURIComponent(title)
              , img2 = encodeURIComponent(img);
            switch (dt) {
            case "email":
                window.location.href = 'mailto:?subject=' + title2 + '&body=' + url;
                break;
            case "twitter":
                window.open('https://x.com/intent/post?url=' + url + '&text=' + title2, '_blank', "menubar=no,location=yes,resizable=yes,scrollbars=yes,status=yes");
                break;
            case "facebook":
                window.open('https://www.facebook.com/sharer/sharer.php?u=' + url, '_blank', "menubar=no,location=yes,resizable=yes,scrollbars=yes,status=yes");
                break;
            case "pinterest":
                window.open('https://pinterest.com/pin/create/button/?url=' + url + '&description=' + title2 + '&media=' + img2, '_blank', "menubar=no,location=yes,resizable=yes,scrollbars=yes,status=yes");
                break;
            case "linkedin":
                window.open('https://www.linkedin.com/shareArticle?url=' + url + '&title=' + title2 + '&mini=true', '_blank', "menubar=no,location=yes,resizable=yes,scrollbars=yes,status=yes");
                break
            }
        });
        tit.append(clone)
    });
    featured_product_resize();
    setMobileImages();
    checkWashletBuyOnlineHash();
    $('a:not([data-featherlight]):not(.video-popup):not(.nopopup)').each(function(k, a) {
        a = $(a);
        var href = a.attr('href')
          , clone = a.clone();
        $('img', clone).remove();
        if (typeof href != 'undefined' && (href.indexOf('//youtube.com') >= 0 || href.indexOf('//youtu.be') >= 0)) {
            a.addClass('video-popup').attr('role', 'button')
        }
    });
    $(document).on('mouseenter mouseleave focusin focusout', '.search_form .search_text', function(e) {
        switch (e.type) {
        case 'mouseenter':
        case 'focusin':
            $(e.target).attr('placeholder', 'Product, Collection, SKU,...');
            break;
        case 'mouseleave':
        case 'focusout':
            if (!$(e.target).is(':focus'))
                $(e.target).attr('placeholder', 'Search');
            break
        }
    });
    if ($("#prod-head-slider").length) {
        $("#prod-head-slider").slick({
            slidesToScroll: 1,
            autoplay: !0,
            autoplaySpeed: 4000,
            dots: !1,
            fade: !0,
            cssEase: "linear",
            prevArrow: "<i role='button' aria-label='Previous' class='material-icons s-prev' aria-hidden='true'>chevron_left</i>",
            nextArrow: "<i role='button' aria-label='Next' class='material-icons s-next' aria-hidden='true'>chevron_right</i>"
        })
    }
    $("a").on('click', function(event) {});
    positionMap();
    
    if ($('.dark-tabs').length > 0) {
        var scrollmagic_controller = new ScrollMagic.Controller();
        $(window).scrollTop(0);
        var sm_dark_tabs = new ScrollMagic.Scene({
            triggerElement: '.dark-tabs .tabs',
            triggerHook: 0,
            duration: $('.dark-tabs').height() - $('.dark-tabs .tabs').height(),
            offset: -1 * $('header').height()
        }).setPin('.dark-tabs .tabs', {
            pushFollowers: !1
        }).setClassToggle('.dark-tabs .tabs', 'pinned').addTo(scrollmagic_controller);
        $('.dark-tabs img').each(function() {
            if ($(window).width() >= 960) {
                $(this).on('load', function() {
                    sm_dark_tabs.duration($('.dark-tabs').height() - $('.dark-tabs .tabs').height())
                })
            }
        });
        $(window).on('resize', function() {
            if ($(window).width() >= 960) {
                sm_dark_tabs.duration($('.dark-tabs').height() - $('.dark-tabs .tabs').height())
            }
        });
        setTimeout(function() {
            $(window).scrollTop(0)
        }, 1000)
    }
    $('header .menu-item').each(function() {
        if ($(this).find('.dropdown').length > 0) {
            $(this).addClass('has-dropdown')
        }
    });
    

    $(window).on('scroll resize', function() {
        var trigger = $(window).scrollTop() + ($(window).height() / 2);
        $('.dark-tabs').each(function() {
            var container = $(this);
            $('.tab-section', container).each(function() {
                var index = $(this).index('.tab-section');
                if (trigger >= $(this).offset().top && trigger < $(this).offset().top + $(this).outerHeight(!0)) {
                    $('.tabs .tab', container).eq(index).addClass('on')
                } else {
                    $('.tabs .tab', container).eq(index).removeClass('on')
                }
            })
        })
    });
  
    $('header a[target="_blank"], footer a[target="_blank"]').click(function() {
        event.preventDefault();
        var href = $(this).attr('href');
        var $content = '<h3>You are leaving totousa.com</h3><p>You are being redirected to an external website. Do you wish to continue?</p><a id="redirect" class="button" href="' + href + '" target="_blank" style="display: inline-block;margin-right: 1em;">Continue</a><button type="button" class="button featherlight-close" style="display: inline-block;">Stay on this page</button>';
        $.featherlight($content, {})
    });
    loadTabsHash();
    checkNavigation();
    checkFooterLinks();
    checkResponsiveAccordions()
}).on('mouseenter', 'header .menu-item.has-dropdown', function(e) {
    if (is_tablet)
        return;
    $('header').addClass('overlay');
    let btn = $(e.currentTarget.closest('li')).find(' > button');
    btn.attr('aria-expanded', 'true')
}).on('mouseleave', 'header .menu-item.has-dropdown', function(e) {
    if (is_tablet)
        return;
    $('header').removeClass('overlay');
    let btn = $(e.currentTarget.closest('li')).find(' > button');
    if (!this.classList.contains('on') || !this.classList.contains('open'))
        btn.attr('aria-expanded', 'false');
}).on('click', 'header .menu-item.has-dropdown > a, header .menu-item.has-dropdown > button, header .menu-item.mega ul.submenu li.has-submenu > a, header .menu-item.mega ul.submenu li.has-submenu > button', function(e) {
    var a = $(e.currentTarget);
    var href = a.attr('href');
    var li = a.closest('li').length ? a.closest('li') : a.closest('.menu-item');
    var controlling = li.find('> button');
    var par = li.closest('ul').length ? li.closest('ul') : li.closest('div');
    if (li.hasClass('open') || li.hasClass('on')) {
        if (!href || /^#/.test(href)) {
            e.preventDefault()
        }
        li.removeClass('open on');
        $('header').removeClass('overlay');
        controlling.attr('aria-expanded', 'false')
    } else {
        e.preventDefault();
        if (li.hasClass('has-submenu')) {
            par.find('li').removeClass('open on')
        } else
            $('header li, header .menu-item').removeClass('open on');
        $('header').addClass('overlay');
        li.addClass('open on');
        controlling.attr('aria-expanded', 'true')
    }
}).on('click', function(e) {
    var is_menu = e.target.closest('header') || (e.target.closest('header') && e.target.classList.includes('overlay'));
    if (!is_menu) {
        $('header .has-dropdown.on').removeClass('open on');
        $('header .has-dropdown [aria-expanded]').attr('aria-expanded', 'false');
        $('header').removeClass('overlay')
    }
}).on('mouseenter', '.slider-thumbnail-container .prev-slide', function(e) {
    $(this).closest('.slider-thumbnail-container').addClass('prev-slide-peek')
}).on('mouseleave', '.slider-thumbnail-container .prev-slide', function(e) {
    $(this).closest('.slider-thumbnail-container').removeClass('prev-slide-peek')
}).on('click', '.slider-thumbnail-container .prev-slide', function(e) {
    $(this).parent().find('.main').slick('slickPrev')
}).on('mouseenter', '.slider-thumbnail-container .next-slide', function(e) {
    $(this).closest('.slider-thumbnail-container').addClass('next-slide-peek')
}).on('mouseleave', '.slider-thumbnail-container .next-slide', function(e) {
    $(this).closest('.slider-thumbnail-container').removeClass('next-slide-peek')
}).on('click', '.slider-thumbnail-container .next-slide', function(e) {
    $(this).parent().find('.main').slick('slickNext')
}).on('click', 'footer .close', function(e) {
    var toggleBtn = $(e.currentTarget);
    if ($('footer').hasClass('open')) {
        // $('footer .footer-section:not(.static)').slideUp(1000, 'easeOutExpo');
        $('footer .close .x').html('+');
        $('footer .close .label').html('Open');
        toggleBtn.attr('aria-expanded', 'false');
        toggleBtn.attr('aria-label', 'Open')
    } else {
        // $('footer .footer-section:not(.static)').slideDown(1000, 'easeOutExpo');
        $('footer .close .x').html('&times;');
        $('footer .close .label').html('Close');
        toggleBtn.attr('aria-expanded', 'true');
        toggleBtn.attr('aria-label', 'Close')
    }
    $('footer').toggleClass('open', !$('footer').hasClass('open'))
}).on('click', 'footer .column .heading', function(e) {
    let parent = $(this).parent();
    parent.toggleClass('on');
    let ww = $(window).width();
    if (ww <= mobile_breakpoint)
        $(this).attr('aria-expanded', parent.hasClass('on') ? 'true' : 'false');
}).on('click', 'footer .side-list .title', function(e) {
    e.preventDefault();
    let ww = $(window).width();
    $(this).toggleClass('on');
    if (ww <= mobile_breakpoint)
        $(this).attr('aria-expanded', $(this).hasClass('on') ? 'true' : 'false');
}).off('click keydown', 'header .mobile-menu-toggle').on('click keydown', 'header .mobile-menu-toggle', function(e) {
    if (e.type == 'click' || e.key == 'Enter' || (e.key == 'ArrowDown' && !$('header').hasClass('mobile-on'))) {
        let btn = e.target.closest('button')
        $('header').toggleClass('mobile-on', btn.classList.contains('open-menu'));
        if ($('header').hasClass('mobile-on')) {
            let menu_cont = $('#menu-container');
            menu_cont.attr('tabindex', '-1').focus();
            menu_cont[0].focus();
            let focusableElements = menu_cont.find("[role='button'], button:visible, .close, .featherlight-close, video, iframe, a, input:not([type='hidden'])").not('[tabindex=-1]');
            let last_element = $(focusableElements[focusableElements.length - 1]);
            last_element.on('keydown', function(evt) {
                if (evt.key == 'Tab') {
                    evt.preventDefault();
                    $('header #menu-container .mobile-menu-toggle').focus()
                }
            })
        } else {
            $('#menu-container').removeAttr('tabindex');
            setTimeout( () => $('header nav.split > .mobile-menu-toggle.open-menu').focus(), 0)
        }
    }
}).on('keydown', '#menu-container', function(e) {
    if (e.key == 'Escape') {
        $('header').removeClass('mobile-on');
        $('header nav.split > .mobile-menu-toggle.open-menu').focus();
        $('header nav.split > .mobile-menu-toggle.open-menu')[0].focus()
    }
}).on('focusin focus blur focusout', '#main-search-input', function(e) {}).on('submit', 'header form.searchbox', function(e) {
    var query = $('header form.searchbox #main-search-input').val();
    if (!query)
        e.preventDefault();
}).on('click', 'header .menu-item.search .box', function(e) {
    e.preventDefault();
    if (e.target.closest('form')) {
        return !1
    }
    var par = $(e.target).closest('.search');
    var query = par.find('#main-search-input').val();
    if ($(window).width() > 1200 || !query) {
        $('header').toggleClass('quick-search-on');
        $('header .menu-item.search').toggleClass('on');
        if ($('header .menu-item.search').hasClass('on')) {
            par.find('#main-search-input').focus();
            $('header .menu-item.search > button').attr('aria-expanded', 'true')
        } else {
            $('header .menu-item.search > button').attr('aria-expanded', 'false')
        }
    } else {
        $('header form.searchbox').submit()
    }
}).on('click', 'a[href^="#"]:not([href="#"]):not(.bob)', function(e) {
    e.preventDefault();
    var accordion = null;
    var tm = 0;
    var href = $(this).attr('href').substr(1) || ""
      , src = $('#' + href).length ? $('#' + href) : $('[name=' + href + ']');
    if (src.length > 0) {
        var padding = 20;
        padding += $('header').outerHeight();
        if (src.closest('section').hasClass('dark-tabs')) {
            padding += $('.dark-tabs .tabs').outerHeight()
        }
        if (src.closest('.accordion-content').length) {
            padding += 80;
            accordion = src.closest('li')
        }
        if ($('.awards-menu').length)
            padding += $('.awards-menu').outerHeight();
        if ($('.secondary-menu').length)
            padding += $('.secondary-menu').outerHeight();
        if (accordion && accordion.length) {
            $('.Accordion > li').removeClass('on');
            $('.Accordion > li > .accordion-title button').attr('aria-expanded', 'false');
            accordion.addClass('on');
            accordion.find('.accordion-title button').attr('aria-expanded', 'true');
            src = accordion
        }
        go2(src)
    }
}).on('click', 'header .menu-item a[href*="#"]', function(e) {
    var href = $(e.currentTarget).attr('href') || '';
    var x = href.split('#');
    if (x[0] == location.pathname) {
        window.location.href = href;
        window.location.reload()
    }
}).on('mouseenter', 'header .menu-item.mega li > a', function(e) {
    e.preventDefault();
    if (is_tablet)
        return;
    var a = $(e.currentTarget);
    var el = a.closest('li');
    var controlling = el.find('> button');
    var mega = el.closest('.mega');
    if (el.hasClass('on') || is_tablet)
        return;
    mega.find('li.on').removeClass('on');
    mega.find('li [aria-expanded]').attr('aria-expanded', 'false');
    if (el.hasClass('has-submenu')) {
        el.addClass('on');
        controlling.attr('aria-expanded', 'true')
    }
}).on('mouseleave', 'header .menu-item.mega .submenu-wrap, header .menu-item.mega', function(e) {
    e.preventDefault();
    if (is_tablet)
        return;
    var mega = $(this).hasClass('mega') ? $(this) : $(this).closest('.mega');
    var subm = mega.find('.submenu-wrap');
    var firstLi = subm.find('ul li').first();
    if (!firstLi.hasClass('on')) {
        subm.find('li.on').removeClass('on').find('> button').attr('aria-expanded', 'false');
        if (firstLi.hasClass('has-submenu')) {
            firstLi.addClass('on');
            firstLi.find('> [aria-controls]').attr('aria-expanded', 'true')
        }
    }
}).on('click', '.features-module .feature', function(e) {
    var container = $(this).closest('.features-module');
    var video = $('.side.video', container);
    if ($(this).attr('data-popup')) {
        video.html($(this).attr('data-popup'))
    }
}).on('click', function(e) {
    if (!e.target.closest('.menu-item.search')) {
        $('header .menu-item.search').removeClass('on');
        $('header').removeClass('quick-search-on')
    }
}).on("click", "a[href='#consumer-packet'], a[href='#trade-packet']", function(e) {
    e.preventDefault();
    var a = $(e.target).closest('a')
      , href = a.attr("href").replace('#', '.')
      , form = $(href);
    if (!form.hasClass('on')) {
        $("a[href='#consumer-packet'], a[href='#trade-packet']").removeClass('on');
        a.addClass('on');
        $(".consumer-packet, .trade-packet").removeClass('on').hide();
        form.addClass('on').slideDown();
        go2(form)
    }
}).on("click", ".download-form #download", function(e) {
    e.preventDefault();
    var href = $(e.target).attr('href')
      , par = $(e.target).closest('.download-form')
      , emailInput = par.find('[name=email]')
      , email = emailInput.val();
    if (email && href) {
        emailInput.removeClass("error");
        $('.error-message', par).hide();
        $.post('//' + __website + "ajax/fe_ajax.php?action=download_form", {
            email: email
        }, function(response) {}).always(function() {
            emailInput.val('');
            window.location = href
        })
    } else if (!email) {
        emailInput.addClass("error");
        var err = $('.error-message', par).length ? $('.error-message', par) : $('<div class="error-message">Email Address is required!</div>').prependTo(par);
        err.show()
    }
}).on('click', '.quizmodalinline .button', function(e) {
    setLastModalTrigger(e);
    const parent = $(this).parents('.module.container').last();
    parent.css('z-index', '999999');
    const modal = parent.find('.quizmodalpopup');
    $('.quizmodalpopup_bg,.quizmodalpopup', parent).addClass('on');
    $(document).off('keydown', '.quizmodalpopup').on('keydown', '.quizmodalpopup', gateDialog);
    $('body').addClass('noscroll quizmodal-on');
    $('.quizmodalpopup').attr({
        side: '',
        slide: 'pickaside',
        choices: '',
    }).removeClass('onresult').removeClass('exraheight');
    modal[0].focus();
    __quizChoices = [];
    __skippedSlides = []
}).on('click', '.quizmodalpopup_bg, .quizmodalpopup .header', function() {
    function close() {
        $('.quizmodalpopup_bg,.quizmodalpopup').removeClass('on');
        $('body').removeClass('noscroll quizmodal-on');
        focusLastModalTrigger()
    }
    var modal = $('.quizmodalpopup');
    var side = modal.attr('side');
    var slide = modal.attr('slide');
    var slideNum = parseInt(slide.replace(/[^0-9]/ig, '') || 0);
    var slidesCount = modal.find('.slide[data-side="' + side + '"]').length;
    var isLastSlide = slideNum == slidesCount;
    if (slide && slide != 'pickaside' && !isLastSlide) {
        if (confirm("Are you sure you want to cancel the quiz?"))
            close();
    } else
        close()
}).on('click', '.quizmodalpopup .slide .pick', function() {
    var modal = $('.quizmodalpopup')
      , me = $(this)
      , side = me.data('side')
      , slide = me.data('slide')
      , choice = me.data('choice');
    modal.attr({
        side: side,
        slide: slide
    });
    if (slide != 'slide_1')
        __quizChoices.push(choice.toString());
    var slideNum = parseInt(slide.replace(/[^0-9]/ig, ''));
    var slidesCount = modal.find('.slide[data-side="' + side + '"]').length;
    modal.find('.progress .bar').css('width', (100 * (slideNum / slidesCount)) + '%');
    quizDetermineChoices()
}).on('click', '.quizmodalpopup .goback', function() {
    var modal = $('.quizmodalpopup')
      , side = modal.attr('side')
      , slide = modal.attr('slide');
    if (slide == 'pickaside') {
        $('.quizmodalpopup_bg').trigger('click')
    } else if (slide == 'slide_1') {
        modal.attr({
            side: '',
            slide: 'pickaside',
            choices: ''
        });
        __quizChoices = [];
        __skippedSlides = [];
        modal.find('.progress .bar').css('width', '0%')
    } else {
        slide = parseInt(slide.replace(/[^0-9]/ig, ''));
        slide--;
        modal.attr({
            slide: 'slide_' + slide
        });
        __quizChoices.pop();
        var slidesCount = modal.find('.slide[data-side="' + side + '"]').length;
        modal.find('.progress .bar').css('width', (100 * (slide / slidesCount)) + '%');
        quizDetermineChoices(-1)
    }
}).on('click', '.quizmodalpopup .whatsthediff .label, .quizmodalpopup .whatsthediff .x', function(e) {
    e.preventDefault();
    var wd = $(e.target).closest('.whatsthediff');
    wd.toggleClass('on');
    if (wd.hasClass('on')) {
        setLastModalTrigger(e);
        wd.focus();
        $(document).off('keydown', wd).on('keydown', wd, function(e) {
            if (e.key === "Escape") {
                wd.removeClass('on');
                focusLastModalTrigger()
            } else {
                gateDialog(e)
            }
        })
    } else {
        focusLastModalTrigger()
    }
}).on('change', '.certified-installer-page .results input[name=technicians_selected]', function(e) {
    $('.certified-installer-page .results input[name=technicians_selected]').not(this).prop('checked', !1);
    if ($(this).prop('checked')) {
        $('.certified-installer-page .email-action #single_email_checked_ci').attr('data-id', $(this).parents('.result-with-data').data("company-id"))
    } else {
        $('.certified-installer-page .email-action #single_email_checked_ci').attr('data-id', '')
    }
}).on('filter', 'section.locations', function() {
    var section = $(this);
    var filters = section.data('filters');
    $('.no-results', section).remove();
    $('.location', section).each(function() {
        var location = $(this);
        var show = !0;
        if (filters) {
            if (filters.hasOwnProperty('type') && filters.type != '' && location.attr('data-type') != filters.type) {
                show = !1
            }
            if (filters.hasOwnProperty('state') && filters.state != '' && location.attr('data-state') != filters.state) {
                show = !1
            }
        }
        location.toggle(show)
    });
    $('.location-group', section).show().each(function() {
        var group = $(this);
        group.toggle(group.find('.location:visible').length > 0)
    });
    if ($('.location-group:visible', section).length <= 0) {
        $('.side.main', section).append('<div class="no-results">No locations found!</div>')
    }
}).on('click', 'section.locations .location-type:not(a)', function() {
    var section = $(this).closest('section.locations');
    var type = $(this).attr('data-type');
    $('section.locations .location-type .label').removeClass('active');
    $('.label', this).addClass('active');
    section.find('.window.front').slideUp(800, 'linear');
    section.find('.window.back').slideDown(800, 'linear');
    section.data('filters', $.extend(section.data('filters'), {
        type: type
    })).trigger('filter')
}).on('click', 'section.locations .state', function() {
    var section = $(this).closest('section.locations');
    var state = $(this).attr('data-state');
    var state_text = $(this).find('.label').text();
    section.data('filters', $.extend(section.data('filters'), {
        state: state
    })).trigger('filter');
    if (state != '') {
        $('.select-state .select .value', section).html(state_text)
    } else {
        $('.select-state .select .value', section).html('Select a State or Province')
    }
    section.removeClass('select-state-on')
}).on('click', 'section.locations .select-state .select', function() {
    var section = $(this).closest('section.locations');
    section.toggleClass('select-state-on')
}).on('click', 'section.locations .location .title, section.locations .location .image', function() {
    var section = $(this).closest('section.locations');
    var location = $(this).closest('.location');
    var popup = $(location.attr('data-popup'));
    $.featherlight(popup, {
        afterOpen() {
            if (typeof $.featherlight.defaults.afterOpen != 'undefined')
                $.featherlight.defaults.afterOpen.apply(this);
            var popup = this.$instance;
            var carousel = $('.carousel', popup);
            var carousel_container = $('.carousel-container', popup);
            var slide_count = $('.slide', carousel).length;
            carousel.show().slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: !0,
                dots: !0,
                appendDots: carousel_container,
                prevArrow: $('.arrow.left', popup),
                nextArrow: $('.arrow.right', popup),
            });
            if (slide_count <= 1) {
                $('.arrow', carousel_container).hide();
                $('.slick-dots', carousel_container).hide()
            }
            carousel.css({
                'opacity': 1,
                'max-height': 'none',
            })
        }
    })
}).on('click', '.secondary-menu ul li a', function(e) {
    if ($(this).attr('href').indexOf('#') != -1) {
        var scrollPosition = document.body.scrollTop;
        var hash = $(this).attr('href').split('#')[1];
        var headerH = $('header').outerHeight();
        var secondaryH = $('.secondary-menu').outerHeight();
        var top = $('#' + hash).offset().top - headerH - secondaryH - 20 + scrollPosition;
        $('html,body').animate({
            scrollTop: top
        })
    }
}).on('mouseenter', '.washlet-features-hover-item', function(e) {
    if ($('.washlet-features-hover-colmid').is(':visible')) {
        var sectionHover = $(this).find('h3').text().toUpperCase();
        var windowW = $(window).width();
        var adjustedX = 0;
        var adjustedY = 0;
        var originalW = $('.washlet-features-hover-colmid').find('img').prop('naturalWidth');
        var originalH = $('.washlet-features-hover-colmid').find('img').prop('naturalHeight');
        var img = document.getElementsByClassName('washlet-features-hover-colmid')[0];
        var imgRect = img.getBoundingClientRect();
        var imgW = imgRect.width;
        var imgH = imgRect.height;
        switch (sectionHover) {
        case 'WAND DOOR':
            var originalY = 256;
            var originalX = 216;
            if (windowW >= 1024 && windowW <= 1280) {
                adjustedX = -6;
                adjustedY = -6
            }
            var dotX = Math.floor((originalX / originalW) * imgW) + adjustedX;
            var dotY = Math.floor((originalY / originalH) * imgH) + adjustedY;
            break;
        case 'SEAMLESS SEAT':
            var originalY = 341;
            var originalX = 137;
            var dotX = Math.floor((originalX / originalW) * imgW) + adjustedX;
            var dotY = Math.floor((originalY / originalH) * imgH) + adjustedY;
            break;
        case 'CLEAN RESIN':
            var originalY = 381;
            var originalX = 189;
            var dotX = Math.floor((originalX / originalW) * imgW) + adjustedX;
            var dotY = Math.floor((originalY / originalH) * imgH) + adjustedY;
            break;
        case 'QUICK RELEASE':
            var originalY = 180;
            var originalX = 340;
            var dotX = Math.floor((originalX / originalW) * imgW) + adjustedX;
            var dotY = Math.floor((originalY / originalH) * imgH) + adjustedY;
            break;
        case 'SELF-CLEANING WAND':
            var originalY = 308;
            var originalX = 237;
            if (windowW >= 1024 && windowW <= 1280) {
                adjustedX = -11;
                adjustedY = -14
            }
            var dotX = Math.floor((originalX / originalW) * imgW) + adjustedX;
            var dotY = Math.floor((originalY / originalH) * imgH) + adjustedY;
            break;
        case 'WAND ANGLE':
            var originalY = 320;
            var originalX = 246;
            if (windowW >= 1024 && windowW <= 1280) {
                adjustedX = -11;
                adjustedY = -8
            }
            var dotX = Math.floor((originalX / originalW) * imgW) + adjustedX;
            var dotY = Math.floor((originalY / originalH) * imgH) + adjustedY;
            break
        }
        $('.washlet-features-hover-colmid .module.html').css({
            'left': dotX + 'px',
            'top': dotY + 'px',
        });
        $('.washlet-features-hover-colmid .module.html .pulsating-container').show().addClass('pulsating');
        setTimeout(function() {
            $('.washlet-features-hover-colmid .module.html .pulsating-container').removeClass('pulsating')
        }, 3000)
    }
}).on("click", ".card-click:not(.clicked)", function(e) {
    $(this).addClass('clicked');
    let anchor = $(this).find('a').first();
    if (anchor.length)
        anchor[0].click();
    setTimeout( () => {
        $(this).removeClass('clicked')
    }
    , 500)
}).on('click', '.retails-list > div .image', function(e) {
    let card = e.target.closest('li');
    let a = card ? card.querySelector('a') : null;
    if (a)
        a.click();
}).on('click', '.download-all-specs[data-sid]', function(e) {
    e.preventDefault();
    downloadProductSpecs(this.dataset.sid)
});
function checkFooterLinks() {
    var headings = $('footer.main .side-list h4.title, footer.main .side-list h2.title, footer.main .column h3.heading');
    var ww = $(window).width();
    if (headings.length) {
        if (ww <= mobile_breakpoint) {
            headings.each(function() {
                let h4 = $(this);
                let opts = h4.next('.side-list-options, .links');
                let optid = opts.attr('id') || 'opts-' + (Math.round(Math.random() * 10000));
                opts.attr('id', optid);
                h4.attr('role', 'button').attr('tabindex', '0').attr('aria-controls', optid).attr('aria-expanded', h4.hasClass('on') || (h4.hasClass('heading') && h4.closest('.column').hasClass('on')) ? 'true' : 'false')
            })
        } else {
            headings.removeAttr('role').removeAttr('tabindex').removeAttr('aria-controls').removeAttr('aria-expanded')
        }
    }
}
$(window).on('resize scroll', checkFooterLinks);
function checkNavigation() {
    is_tablet = window.innerWidth <= tablet_breakpoint;
    if (is_tablet) {
        $('header .menu-item.search a').removeAttr('aria-expanded').removeAttr('aria-controls').attr('aria-hidden', 'true');
        $('header nav.split #menu-container').attr('role', 'dialog').attr('aria-modal', 'true').attr('aria-label', 'menu')
    } else {
        if (!$('header .menu-item.search a').attr('aria-controls')) {
            $('header .menu-item.search a').attr('aria-controls', 'search-form').attr('aria-expanded', 'false').removeAttr('aria-hidden')
        }
        $('header nav.split #menu-container').removeAttr('role').removeAttr('aria-modal').removeAttr('aria-label');
        $('header').removeClass('mobile-on')
    }
}
function getTranscriptButtonPosition() {
    var dialog = arguments[0] || $('.featherlight.video-modal');
    var header = dialog.find('.header');
    var header_h = header.length ? header[0].offsetHeight : 0;
    var btn_top = header_h + 87;
    return btn_top
}
$(window).on('resize scroll', checkNavigation);
$(window).on('resize', function() {
    var transcript_btn = $('.featherlight.video-modal .transcript-toggle');
    if (transcript_btn.length) {
        transcript_btn.css('top', getTranscriptButtonPosition() + 'px')
    }
});
function quizDetermineChoices(dir) {
    if (typeof dir == 'undefined')
        dir = 1;
    var modal = $('.quizmodalpopup')
      , side = modal.attr('side')
      , slide = modal.attr('slide');
    slide = parseInt(slide.replace(/[^0-9]/ig, ''));
    var q_num_el = modal.find('.slide[data-side="' + side + '"].slide_' + slide + ' .q-num');
    var q_num = slide - __skippedSlides.filter(function(s) {
        return Number(s) < Number(slide)
    }).length;
    q_num_el.text(q_num);
    var Labels = __quizLabels;
    var label = Labels[side][q_num - 1] || 'Question <span class="q-num">' + q_num + '</span>';
    modal.find('.slide[data-side="' + side + '"].slide_' + slide + ' .question .sub').html(label);
    var possibleChoices = [];
    for (var key in __quizData[side].p) {
        var canChoose = !0
          , value = __quizData[side].p[key][slide - 1];
        for (var i = 0; i < slide - 1; i++) {
            if (__quizChoices[i].toLowerCase() != __quizData[side].p[key][i].toLowerCase()) {
                canChoose = !1;
                break
            }
        }
        if (canChoose) {
            if (typeof value == 'object') {
                possibleChoices.push(value)
            } else {
                value = value.toLowerCase();
                if (!possibleChoices.includes(value)) {
                    possibleChoices.push(value)
                }
            }
        }
    }
    var picks = modal.find('.slide.slide_' + slide + '[data-side="' + side + '"] .pick');
    if (picks.length) {
        var picksLimit = 2;
        var picksShown = 0;
        picks.hide().each(function() {
            var text = $(this).attr('data-choice').toLowerCase()
              , canShow = !1;
            for (var key in possibleChoices) {
                if (text == possibleChoices[key]) {
                    canShow = !0;
                    break
                }
            }
            if (canShow && picksShown < picksLimit) {
                var prevAnswer = __quizChoices.length ? __quizChoices[__quizChoices.length - 1] : '';
                $(this).attr('data-prevanswer', prevAnswer).show();
                picksShown++
            }
        });
        if (picksShown < 2)
            modal.find('.slide.slide_' + slide + ' .whatsthediff').hide();
        else
            modal.find('.slide.slide_' + slide + ' .whatsthediff').not('.hidden').show();
        if (possibleChoices.length == 1 && possibleChoices.includes('skip question')) {
            if (dir == 1) {
                __skippedSlides.push(slide);
                picks.filter(':visible').trigger('click')
            } else {
                modal.find('.goback').trigger('click')
            }
        } else {
            __skippedSlides = __skippedSlides.filter(function(s) {
                return Number(s) != Number(slide)
            })
        }
        modal.removeClass('onresult').removeClass('exraheight')
    } else {
        var results = possibleChoices;
        var block = modal.find('.slide.slide_' + slide + '[data-side="' + side + '"] .result');
        block.find('.item:not(:first-child)').remove();
        var resCount = 0;
        if (results && results.length) {
            results.forEach(function(result, i) {
                var product = result ? result[0] : null
                  , similar = result ? result[1] : null;
                if (result && product) {
                    resCount++;
                    var last = results.length - 1 == i;
                    var item = block.find('.item:first-child');
                    var _block = resCount == 1 ? item : item.clone();
                    _block.find('img').attr('src', product.image);
                    _block.find('.title').html(product.name);
                    _block.find('.button').attr('href', product.url_seo);
                    _block.find('.similar').html('');
                    if (similar.length) {
                        _block.find('.similar,.alsolike').show();
                        var i = 0;
                        var limit = 4;
                        for (var key in similar) {
                            i++;
                            if (i > limit)
                                break;
                            product = similar[key];
                            _block.find('.similar').append(`
				<a href="${product.url_seo}">
					<div class="img" style="background-image: url('${product.image}')"></div>
					<div class="side">
						<div class="title">${product.name}</div>
						<div class="sku">SKU: ${product.sku}</div>
					</div>
				</a>
				`)
                        }
                        if (last) {
                            if (similar.length <= 2 && resCount == 1)
                                modal.removeClass('exraheight');
                            else
                                modal.addClass('exraheight')
                        }
                        if (resCount > 1) {
                            block.append(_block)
                        }
                    }
                } else if (i == 0) {
                    block.find('.similar,.alsolike').hide()
                }
            })
        }
        modal.addClass('onresult')
    }
    if (__quizChoices.length)
        modal.attr('choices', __quizChoices.join(','));
}
;$(window).resize(function() {
    positionMap()
});
function positionMap() {
    var ww = $(window).width();
    if (ww < 960) {
        if (!$('#searchForm #map').length) {
            $('.online-retailers .map-wrap').appendTo('#searchForm .dw100')
        }
    } else {
        if (!$('.online-retailers #map').length) {
            $('#searchForm .map-wrap').appendTo('.online-retailers')
        }
    }
}
function loadTabsHash() {
    let tabs_nav = arguments[0];
    let hash = window.location.hash.substring(1);
    let tab = hash && hash.indexOf('=') < 0 && $('.tabs-nav a[href=#' + hash + '], .tabs-nav button[data-tab=' + hash + ']').length ? (tabs_nav ? $('a[href=#' + hash + '], button[data-tab=' + hash + ']', tabs_nav) : $('.tabs-nav a[href=#' + hash + '], button[data-tab=' + hash + ']')) : null;
    if (tab && !tab.hasClass('active')) {
        let par = tabs_nav || tab.closest('.tabs-nav');
        $('a, button', par).removeClass('active').attr('aria-selected', 'false').attr('tabindex', '-1');
        par.nextAll(".tab-content").removeClass('active').hide();
        tab.addClass('active').attr("aria-selected", "true").attr('tabindex', '0');
        par.nextAll(".tab-content." + hash).addClass('active').fadeIn()
    }
}
window.addEventListener('popstate', function(e) {
    loadTabsHash()
});
function initTabs() {
    function _selectTab(tab) {
        if (tab.length) {
            let tabsNav = tab.closest('.tabs-nav, [role="tablist"]');
            tabsNav.find("a.active, [role='tab'].active, button.active").removeClass('active').removeAttr('aria-expanded').attr('aria-selected', 'false').attr('tabindex', '-1');
            tabsNav.siblings(".tab-content").removeClass('active').hide();
            var ll = window.location.href.split('#')[0]
              , href = (tab.attr("href") || "").substring(1) || tab.data('tab');
            window.history.pushState(href, document.title, ll + '#' + href);
            tab.addClass("active").attr('aria-selected', 'true').attr('tabindex', '0');
            var cont = tabsNav.siblings(".tab-content." + href);
            cont.addClass('active').fadeIn();
            if (tabsNav.hasClass('scroll-to-tab-content'))
                go2(cont);
            tabsNav.trigger('change', [tab[0], cont])
        }
    }
    $(".tabs-nav").each(function() {
        let tab = $(this);
        tab.attr('role', 'tablist');
        tab.find("a, button").attr('role', 'tab').removeAttr('aria-expanded').attr('aria-selected', 'false').attr('tabindex', '-1').each(function() {
            let tabid = $(this).attr("id") || 'tab-' + (Math.round(Math.random() * 1000000));
            $(this).attr('id', tabid);
            let href = ($(this).attr("href") || "").substring(1) || $(this).attr("data-tab");
            let cont = tab.nextAll(`.tab-content.${href}`);
            let id = cont.attr('id') || 'cont-' + (Math.round(Math.random() * 1000000));
            cont.attr('id', id).attr('role', 'tabpanel').attr('aria-labelledby', tabid).attr('tabindex', '0');
            $(this).attr("aria-controls", id)
        });
        let active_tab = $('.tabs-nav a.active, .tabs-nav button.active');
        if (!active_tab.length) {
            loadTabsHash(tab);
            active_tab = $('.tabs-nav a.active, .tabs-nav button.active');
            if (active_tab.length)
                return;
            active_tab = $(".tabs-nav a, .tabs-nav button").first()
        }
        _selectTab(active_tab)
    });
    $(document).on("click", ".tabs-nav a:not(.active), .tabs-nav button:not(.active)", function(e) {
        e.preventDefault();
        let a = $(e.target).closest('a, button');
        if (!a.length)
            a = $(e.target).closest('[role="tab"]');
        _selectTab(a)
    });
    $(document).on("keydown", ".tabs-nav a, .tabs-nav button, .simple-tabs [role='tab'], [role='tab']", function(e) {
        if ([' ', 'Enter', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) {
            e.preventDefault();
            let tablist = e.target.closest('[role="tablist"]');
            let tabs = tablist ? tablist.querySelectorAll('[role="tab"]') : [];
            let first = tabs ? tabs[0] : null;
            let last = tabs ? tabs[tabs.length - 1] : null;
            let prev = e.target.previousSibling || (tabs ? tabs[Math.max(Array.from(tabs).indexOf(e.target) - 1, 0)] : null);
            let next = e.target.nextSibling || (tabs ? tabs[Math.min(Array.from(tabs).indexOf(e.target) + 1, tabs.length - 1)] : null);
            switch (e.key) {
            case 'Enter':
            case ' ':
                e.target.click();
                break;
            case 'ArrowLeft':
                if (prev)
                    prev.focus();
                break;
            case 'ArrowRight':
                if (next)
                    next.focus();
                break;
            case 'Home':
                if (first) {
                    first.click();
                    first.focus()
                }
                break;
            case 'End':
                if (last) {
                    last.click();
                    last.focus()
                }
                break
            }
        }
    })
}
function checkWashletBuyOnlineHash() {
    if ($('.page-washlet').length) {
        var hash = window.location.hash.substring(1);
        if (hash == 'buy-online') {
            window.location.hash = "";
            history.pushState("", document.title, window.location.pathname);
            setTimeout(function() {
                go2($("#" + hash))
            }, 1000)
        }
    }
}
function checkLiteratureHash() {
    var hash = window.location.hash.substring(1);
    if (hash == 'consumer-packet' || hash == 'trade-packet') {
        $("a[href='#consumer-packet'], a[href='#trade-packet']").removeClass('on');
        $(".consumer-packet, .trade-packet").removeClass('on').hide();
        $('a[href=#' + hash + ']').addClass('on');
        $("." + hash).addClass('on').slideDown();
        go2($("." + hash))
    }
}
function setMobileImages() {
    var mobileBreakpoint = 640;
    var windowWidth = $("body").innerWidth();
    if (windowWidth <= mobileBreakpoint) {
        $('.imgmo').each(function() {
            if ($(this).attr("data-imgmo") != undefined && $(this).attr("data-imgmo") != "") {
                $(this).css('background-image', 'url(' + $(this).attr("data-imgmo") + ')')
            }
        })
    } else {
        $('.imgmo').each(function() {
            if ($(this).attr("data-img") != undefined && $(this).attr("data-img") != "") {
                $(this).css('background-image', 'url(' + $(this).attr("data-img") + ')')
            }
        })
    }
}
function featured_product_resize() {
    $('.module.choose-toto').each(function() {
        var max_h = 0;
        $(this).find('.featured-product .module_content').css("height", "auto");
        $(this).find('.featured-product .module_content').each(function() {
            if ($(this).outerHeight() > max_h) {
                max_h = $(this).outerHeight()
            }
        });
        $(this).find('.featured-product .module_content').outerHeight(max_h)
    })
}

function resize_filters() {
    var filter_subcategories_h = 0;
    $('ul.filter-subcategories li').css("min-height", filter_subcategories_h + "px");
    $('ul.filter-subcategories li').each(function(k, v) {
        if ($(this).outerHeight() > filter_subcategories_h) {
            filter_subcategories_h = $(this).outerHeight()
        }
    });
    $('ul.filter-subcategories li').css("min-height", filter_subcategories_h + "px")
}
function reset_form(elementSelector) {
    var form = $(elementSelector);
    form.find("input").each(function(i) {
        $(this).val("")
    });
    form.find("textarea").each(function(i) {
        $(this).val("")
    });
    form.find("select").each(function(i) {
        $(this).val($('option:first', this).val());
        $(this).parent().find('.styledSelect').html($('option:first', this).val())
    })
}
function validate_form_required(elementSelector) {
    var form = typeof elementSelector == 'string' ? $(elementSelector) : elementSelector;
    var validation = !0;
    var errors = [];
    var errorElement = form.find('.error.message');
    errorElement.html("");
    var first_errored_input = null;
    form.find('[name],input,textarea,select').each( (idx, ipt) => ipt.setAttribute('data-idx', idx));
    function _set_first_errored(field) {
        if ((!first_errored_input || Number(field.attr('data-idx')) < Number(first_errored_input.attr('data-idx'))) && field.attr('type') != 'hidden')
            first_errored_input = field
    }
    form.find("input").each(function(i) {
        var cont = $(this);
        if ($(this).closest('.input, .checkbox').length)
            cont = $(this).closest('.input, .checkbox');
        var field = $(this);
        var is_checkbox = ['radio', 'checkbox'].includes(field.attr('type'));
        var fieldID = field[0].id || 'field-' + Math.round(Math.random() * 1000000);
        field[0].id = fieldID;
        var type = field.attr('type');
        var name = field.attr('name');
        if (is_checkbox && cont[0].tagName == 'INPUT')
            cont = field.closest('div');
        var val = is_checkbox ? (cont.find(`[name="${name}"]:checked`).val() || "") : $(this).val();
        var req = $(this).hasClass("required") || $(this).prop("required") || $(this).attr('aria-required') == 'true';
        var req_when = $(this).attr('data-required-when');
        var error_msg = field.data("error-message");
        var label = field.data('label') || (((field[0].id ? $('[for="' + field[0].id + '"]').text() : '') || (field.attr('name').replace(/[^a-zA-Z0-9]+/g, ' '))) + " field");
        var error_el = field.attr('aria-errormessage') ? $('#' + field.attr('aria-errormessage')) : null;
        var wrap = field.closest('.placeholder-input, .nice.input, .checkbox, .icheckbox_minimal');
        var is_email = $(this).hasClass("form-email");
        if (req_when) {
            var condParts = req_when.split(":").map(function(p) {
                return $.trim(p)
            });
            var condVal = $(`[name="${condParts[0]}"]`, form).val();
            if (condVal == condParts[1]) {
                req = !0
            } else if (condVal)
                req = !1
        }
        if (!is_email) {
            if (req) {
                if (val == "") {
                    validation = !1;
                    cont.addClass("error");
                    var msg = '<div id="error-message-' + fieldID + '">' + (error_msg || label + ' is required') + '</div>';
                    errors.push(msg)
                } else {
                    cont.removeClass("error")
                }
            } else {
                cont.removeClass("error")
            }
        }
        if (is_email) {
            if (validate_email_address($(this).val()) == !1) {
                validation = !1;
                cont.addClass("error");
                var msg = '<div id="error-message-' + fieldID + '">' + (error_msg || label + ' is required') + '</div>';
                errors.push(msg)
            } else {
                cont.removeClass("error")
            }
        }
        if (cont.hasClass('error')) {
            field.attr("aria-invalid", "true");
            if (error_el)
                error_el.removeClass('sr-only');
            wrap.addClass('has-error');
            if (errorElement.length && (!field.attr('aria-errormessage') || (field.attr('aria-errormessage') && !$('#' + field.attr('aria-errormessage')).length)))
                field.attr('aria-errormessage', 'error-message-' + fieldID);
            _set_first_errored(field)
        } else {
            field.attr("aria-invalid", "false");
            if (error_el)
                error_el.addClass('sr-only');
            wrap.removeClass('has-error')
        }
        if ($(this).attr("type") == "hidden" && $(this).is("#product-sku")) {
            var searchInput = $(form).find('#product-search');
            searchInput.removeClass("error");
            if ($(this).val() == "NONE" && searchInput.val().trim() == '') {
                validation = !1;
                searchInput.addClass("error");
                var msg = '<div id="error-message-' + fieldID + '">' + (error_msg || label + ' is required') + '</div>';
                errors.push(msg);
                field.attr("aria-invalid", "true");
                if (error_el)
                    error_el.removeClass('sr-only');
                wrap.addClass('has-error');
                if (errorElement.length && (!field.attr('aria-errormessage') || (field.attr('aria-errormessage') && !$('#' + field.attr('aria-errormessage')).length)))
                    field.attr('aria-errormessage', 'error-message-' + fieldID);
                _set_first_errored(field)
            } else {
                field.removeAttr("aria-invalid");
                if (error_el)
                    error_el.addClass('sr-only');
                wrap.removeClass('has-error')
            }
        }
        if ($(this).attr("type") == "hidden" && $(this).is("#product-series")) {
            var searchInput = $(form).find('#product-search');
            searchInput.removeClass("error");
            if ($(this).val() == "NONE" && searchInput.val().trim() == '') {
                validation = !1;
                searchInput.addClass("error");
                var msg = '<div id="error-message-' + fieldID + '">' + label + ' is required</div>';
                errors.push(msg);
                field.attr("aria-invalid", "true");
                if (error_el)
                    error_el.removeClass('sr-only');
                wrap.addClass('has-error');
                if (errorElement.length && (!field.attr('aria-errormessage') || (field.attr('aria-errormessage') && !$('#' + field.attr('aria-errormessage')).length)))
                    field.attr('aria-errormessage', 'error-message-' + fieldID);
            } else {
                field.removeAttr("aria-invalid");
                if (error_el)
                    error_el.addClass('sr-only');
                wrap.removeClass('has-error')
            }
        }
    });
    if ($(elementSelector).find('.form-checkbox.required:not(input)').length > 0) {
        if ($(elementSelector).find('.form-checkbox.required input[type=checkbox]:checked').length == 0) {
            var checkbox = $(elementSelector).find('.form-checkbox.required input[type=checkbox]');
            checkbox.parent().parent().addClass("error");
            validation = !1;
            if (!first_errored_input && field.attr('type') != 'hidden')
                first_errored_input = checkbox.first();
        } else {
            $(elementSelector).find('.form-checkbox.required input[type=checkbox]').parent().parent().removeClass("error")
        }
    }
    form.find("textarea").each(function(i) {
        var cont = $(this);
        if ($(this).closest('.input').length)
            cont = $(this).closest('.input');
        var field = $(this);
        var fieldID = field[0].id || 'field-' + Math.round(Math.random() * 1000000);
        field[0].id = fieldID;
        var error_msg = field.data("error-message");
        var label = (field[0].id ? $('[for="' + field[0].id + '"]').text() : field.attr('name').replace(/^[a-zA-Z0-9]+/g, ' ')) + " field";
        var error_el = field.attr('aria-errormessage') ? $('#' + field.attr('aria-errormessage')) : null;
        var wrap = field.closest('.placeholder-input, .nice.input');
        var req = $(this).hasClass("required") || $(this).prop("required") || $(this).attr('aria-required') == 'true';
        if (req) {
            if ($(this).val() == "") {
                validation = !1;
                cont.addClass("error");
                var msg = '<div id="error-message-' + fieldID + '">' + (error_msg || label + ' is required') + '</div>';
                errors.push(msg);
                field.attr("aria-invalid", "true");
                if (error_el)
                    error_el.removeClass('sr-only');
                wrap.addClass('has-error');
                if (errorElement.length && (!field.attr('aria-errormessage') || (field.attr('aria-errormessage') && !$('#' + field.attr('aria-errormessage')).length)))
                    field.attr('aria-errormessage', 'error-message-' + fieldID);
                _set_first_errored(field)
            } else {
                cont.removeClass("error");
                field.removeAttr("aria-invalid");
                if (error_el)
                    error_el.addClass('sr-only');
                wrap.removeClass('has-error')
            }
        }
    });
    form.find("select").each(function(i) {
        var cont = $(this);
        if ($(this).closest('.input').length)
            cont = $(this).closest('.input');
        var field = $(this);
        var fieldID = field[0].id || 'field-' + Math.round(Math.random() * 1000000);
        field[0].id = fieldID;
        var error_msg = field.data("error-message");
        var label = (field[0].id ? $('[for="' + field[0].id + '"]').first().text() : field.attr('name').replace(/^[a-zA-Z0-9]+/g, ' ')) + " field";
        var error_el = field.attr('aria-errormessage') ? $('#' + field.attr('aria-errormessage')) : null;
        var wrap = field.closest('.placeholder-input, .nice.input');
        var selectedOption = $(this).find('option:selected');
        var val = $(this).val();
        var req = $(this).hasClass("required") || $(this).prop("required") || $(this).attr('aria-required') == 'true';
        var req_when = $(this).attr('data-required-when');
        if (req_when) {
            var condParts = req_when.split(":").map(function(p) {
                return $.trim(p)
            });
            var condVal = $(`[name="${condParts[0]}"]`, form).val();
            if (condVal == condParts[1]) {
                req = !0
            } else if (condVal)
                req = !1
        }
        if (req) {
            if (val) {
                field.removeAttr("aria-invalid");
                cont.removeClass("error");
                wrap.removeClass('has-error');
                if (error_el)
                    error_el.addClass('sr-only');
                if ($(this).next().hasClass('styledSelect')) {
                    $(this).next().removeClass("error")
                }
            } else if ($(selectedOption).attr('data-default') == "1") {
                if ($(this).hasClass("search-dynamic") && parseInt($(this).attr("data-enabled")) == 0) {
                    field.removeAttr("aria-invalid");
                    cont.removeClass("error");
                    wrap.removeClass('has-error');
                    if (error_el)
                        error_el.addClass('sr-only');
                    if ($(this).next().hasClass('styledSelect')) {
                        $(this).next().removeClass("error")
                    }
                } else {
                    validation = !1;
                    cont.addClass("error");
                    var msg = '<div id="error-message-' + fieldID + '">' + (error_msg || label + ' is required') + '</div>';
                    errors.push(msg);
                    field.attr("aria-invalid", "true");
                    if (error_el)
                        error_el.removeClass('sr-only');
                    wrap.addClass('has-error');
                    if (errorElement.length && (!field.attr('aria-errormessage') || (field.attr('aria-errormessage') && !$('#' + field.attr('aria-errormessage')).length)))
                        field.attr('aria-errormessage', 'error-message-' + fieldID);
                    if ($(this).next().hasClass('styledSelect')) {
                        $(this).next().addClass("error")
                    }
                    _set_first_errored(field)
                }
            } else if (selectedOption.length > 0 && selectedOption.first().val()) {
                field.removeAttr("aria-invalid");
                cont.removeClass("error");
                wrap.removeClass('has-error');
                if (error_el)
                    error_el.addClass('sr-only');
                if ($(this).next().hasClass('styledSelect')) {
                    $(this).next().removeClass("error")
                }
            } else {
                validation = !1;
                cont.addClass("error");
                var msg = '<div id="error-message-' + fieldID + '">' + label + ' is required</div>';
                errors.push(msg);
                field.attr("aria-invalid", "true");
                wrap.addClass('has-error');
                if (errorElement.length && (!field.attr('aria-errormessage') || (field.attr('aria-errormessage') && !$('#' + field.attr('aria-errormessage')).length)))
                    field.attr('aria-errormessage', 'error-message-' + fieldID);
                if (error_el)
                    error_el.removeClass('sr-only');
                if ($(this).next().hasClass('styledSelect')) {
                    $(this).next().addClass("error")
                }
                _set_first_errored(field)
            }
        }
    });
    if (errorElement.length || form.hasClass('force-message')) {
        if (!errorElement.length)
            errorElement = $('<div class="message error" role="alert"></div>').prependTo(form);
        if (!validation) {
            errorElement.attr("aria-live", "off").html(errors.join('')).show().attr("aria-live", "polite")
        } else {
            errorElement.html("").attr("aria-live", "off").hide()
        }
    }
    if (!validation && first_errored_input && first_errored_input.length) {
        if (first_errored_input.is(':visible'))
            first_errored_input.focus();
        else {
            var button = first_errored_input.next('button');
            if (button.length)
                button.focus();
        }
    }
    return validation
}
function validate_email_address(email) {
    var re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(email)
}
function hideFilters() {
    $('span.hide_filters[data-click="HideFilters"]').removeClass("on");
    $('span.hide_filters[data-click="ShowFilters"]').addClass("on");
    $('.filter-section').hide()
}
function showFilters() {
    $('span.hide_filters[data-click="HideFilters"]').addClass("on");
    $('span.hide_filters[data-click="ShowFilters"]').removeClass("on");
    $('.filter-section').show()
}
function product_quick_home_block() {
    var selected = $('#product_type_list_quick').val();
    if (!empty(selected)) {
        window.location = '/products/' + selected
    }
}
function find_a_showroom_home_block() {
    var product_type = $('#product_type_list').val();
    var zipcode = $('#showroom_zip_code').val();
    if (!empty(product_type)) {
        var url = '/find-a-showroom?distance[postal_code]=' + zipcode + '&distance[country]=us&distance[search_distance]=25&field_toto_gallery_value=All&field_product_types_value=' + product_type;
        window.location = url
    }
}
function resetBoxHeight(container, element) {
    var h = 0;
    $(element, container).css('height', 'auto');
    $(element, container).each(function() {
        if ($(this).height() > h) {
            h = $(this).outerHeight()
        }
    });
    $(element, container).height(h)
}
function slide_to_section(obj, page) {
    if (!obj.length)
        return;
    $('html, body').animate({
        scrollTop: parseInt(obj.offset().top - 260)
    })
}
function empty(e) {
    return "" == e || "undefined" == e || null == e || "NULL" == e ? !0 : !1
}
function isJSONSTR(e) {
    var a = !1;
    try {
        a = typeof e === 'object' ? e : JSON.parse(e)
    } catch (n) {
        return !1
    }
    return a
}
function is_on_screen(obj) {
    if (!obj.length)
        return;
    var win = jQuery(window);
    var viewport = {
        top: win.scrollTop(),
        left: win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();
    var bounds = obj.offset();
    bounds.right = bounds.left + obj.outerWidth();
    bounds.bottom = bounds.top + obj.outerHeight();
    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom))
}
;function isTouchDevice() {
    return !0 == ("ontouchstart"in window || window.DocumentTouch && document instanceof DocumentTouch)
}
function init_homepageVideo() {
    var isiPad = navigator.userAgent.match(/iPad/i) != null;
    if (isiPad) {
        $('.content-slides').addClass('ipad')
    }
    var i = !0;
    window.setTimeout(function() {
        var video1 = document.getElementById('video1');
        var video2 = document.getElementById('video2');
        video1.addEventListener('ended', slide1);
        video2.addEventListener('ended', slide2);
        var m_toggle_left = document.getElementById('mobile-left');
        var m_toggle_right = document.getElementById('mobile-right');
        var m_toggle_ableft = document.getElementById('mobile-ableft');
        var m_toggle_abright = document.getElementById('mobile-abright');
        m_toggle_ableft.addEventListener('click', function() {
            clearInterval(slideTimer);
            slideTimer = window.setInterval(slide, 6000);
            slide()
        });
        m_toggle_abright.addEventListener('click', function() {
            clearInterval(slideTimer);
            slideTimer = window.setInterval(slide, 6000);
            slide()
        });
        slide1()
    }, 500);
    var aslide1 = document.getElementById('slide1');
    var aslide2 = document.getElementById('slide2');
    function slide1() {
        aslide1.className = '';
        aslide2.className = 'on';
        video2.play()
    }
    function slide2() {
        aslide2.className = '';
        aslide1.className = 'on';
        video1.play()
    }
    function slide() {
        if (i) {
            aslide2.className = '';
            aslide1.className = 'on'
        } else {
            aslide1.className = '';
            aslide2.className = 'on'
        }
        i = !i
    }
    var width = window.innerWidth;
    if (width <= 768 || isiPad) {
        video1.removeEventListener('ended', slide1);
        video2.removeEventListener('ended', slide2);
        var slideTimer = window.setInterval(slide, 6000)
    }
}
function init_search_results(type, query) {
    var query_input = $("#search_query").val();
    if (typeof query_input != "undefined" && query_input != "") {
        $("#clear_search_filters").show()
    }
    var $scope = {
        action: '//' + __website + 'ajax/fe_ajax.php',
        type: type,
        filters: {},
        selected_filters: {},
        query: query_input,
        curr_page: 1,
        error_msg: 'There was a problem with your request. Please try again.',
        loadingResults: null,
        lastType: null,
    }
    var nonProductArray = ["Discontinued Products", "Videos", "Product Education", "Brand Fundamentals", "Downloads", "Features & Certification", "Innovation & Technologies", "Resources"];
    loadSearchResults();
    $('.filters').on('click', '.filter-val', function() {
        var type = $(this).parent('ul').attr('data-filter');
        var value = $(this).attr('data-value');
        $("#clear_search_filters").show();
        if ($scope.selected_filters.hasOwnProperty(type)) {
            var index = $scope.selected_filters[type].indexOf(value);
            if (index > -1) {
                $scope.selected_filters[type].splice(index, 1)
            } else {
                $scope.selected_filters[type].push(value)
            }
        } else {
            if ($scope.lastType != type && $scope.lastType != null) {
                if (($.inArray(type, nonProductArray) == -1 && $.inArray($scope.lastType, nonProductArray) != -1) || ($.inArray(type, nonProductArray) != -1 && $.inArray($scope.lastType, nonProductArray) == -1)) {}
            }
            $scope.selected_filters[type] = [];
            $scope.selected_filters[type].push(value);
            $scope.lastType = type
        }
        loadSearchResults()
    });
    $('ul', '.current-search').on('click', 'li', function() {
        var item = $(this);
        var type = $(item).data('type');
        var value = $(item).data('value');
        if (type == "searchquery") {
            var index = $scope.selected_filters[type].indexOf(value);
            $scope.selected_filters[type].splice(index, 1);
            $scope.query = "";
            $("#search_query").val("")
        }
        if ($scope.selected_filters.hasOwnProperty(type)) {
            var index = $scope.selected_filters[type].indexOf(value);
            if (index > -1) {
                $scope.selected_filters[type].splice(index, 1)
            }
            if ($('.current-search li').length == 1) {
                $("#clear_search_filters").hide()
            }
        }
        if (!$scope.query) {
            let empty = !0;
            for (let t in $scope.selected_filters) {
                if ($scope.selected_filters[t] && $scope.selected_filters[t].length)
                    empty = !1
            }
            if (empty)
                $('.search-filters .current-search').hide();
        }
        loadSearchResults()
    });
    $('.results').on('click', '.prev, .next', function(e) {
        var target = $(e.target)
          , page = target.attr('data-page')
          , disabled = target.hasClass('disabled');
        if (!disabled) {
            loadSearchResults(page)
        }
    });
    $("#clear_search_filters").on("click", function() {
        $('ul', '.current-search').empty();
        $('.current-search').hide();
        $("#search_query").val("");
        $("#search_query").closest('.placeholder-input').removeClass('has-value');
        $scope.query = '';
        $scope.selected_filters = {};
        loadSearchResults();
        $(this).hide()
    });
    $("#search_query_form").on("submit", function() {
        $scope.query = $("#search_query").val();
        loadSearchResults();
        return !1
    });
    function loadSearchResults() {
        var args = arguments
          , url = $scope.action + '?action=loadSearchResults&type=' + $scope.type + '&query=' + $scope.query
          , page = 1;
        if (args.length)
            page = args[0];
        var PostDATA = {
            filters: $scope.selected_filters,
            query: $scope.query,
            page: page
        }
        if ($scope.query || (Object.keys($scope.selected_filters || {}).length && Object.values($scope.selected_filters || {}).filter(function(v) {
            return v && v.length
        }).length)) {
            $('.current-search').show()
        } else
            $('.current-search').hide();
        if (!is_on_screen($('.current-search'))) {
            slide_to_section($('.current-search'))
        }
        var wrapper = $('.results');
        var search_wrapper = wrapper.find('.searchWrap');
        wrapper.prepend('<div class="loading ajax-loader"><img src="' + __CDNBASEURL__ + '/images/ajax-loader.gif" /> Loading...</div>');
        search_wrapper.css("opacity", ".5");
        $.post(url, PostDATA, function(response) {
            var data = isJSONSTR(response);
            if (data) {
                var results = data.results;
                $scope.filters = data.filters;
                $scope.curr_page = 1;
                if ($('.results.productresults').length) {
                    $('.results.productresults').show().html(results);
                    $('.search_page').first().addClass('on');
                    $('.results.techbarn').hide().html(data.techbarn);
                    loadResultFilters();
                    if (data.techbarn) {
                        $('<a>Replacement Parts</a>').on('click', function(e) {
                            e.preventDefault();
                            $('.results.productresults').hide();
                            $('.results.techbarn').show()
                        }).appendTo($('.results.productresults .cats'));
                        $('.results.techbarn .returntoresults').on('click', function() {
                            $('.results.productresults').show();
                            $('.results.techbarn').hide()
                        })
                    }
                } else {
                    console.log(results);
                    $('.module_content > .results').show().html(results);
                    $('.search_page').first().addClass('on');
                    loadResultFilters()
                }
            }
        }).always(function() {
            wrapper.find('.loading.ajax-loader').remove();
            search_wrapper.css("opacity", "1");
            if (LazyInstance)
                LazyInstance.init();
            setTimeout(refreshGoogleTranslate, 500)
        })
    }
    function loadResultFilters() {
        $('.filters').empty();
        for (var i in $scope.filters) {
            if ($scope.filters.hasOwnProperty(i)) {
                var filter = $scope.filters[i];
                var type = $('<div></div>').append('<h3>' + i + '</h3>');
                var f = $('<ul data-filter="' + i + '"></ul>');
                var isCats = i.toLowerCase().replace(/ +/, '') == 'productcategories';
                if (isCats)
                    f.addClass('showingFilters');
                for (var j in filter) {
                    if (filter.hasOwnProperty(j)) {
                        var count = '';
                        if (filter[j].hasOwnProperty('count')) {
                            var count = '(' + filter[j].count + ')';
                            var value = filter[j].value
                        } else {
                            var value = filter[j]
                        }
                        $(f).append('<li role="button" tabindex="0" data-value="' + j + '" class="filter-val"><span class="value">' + value + '</span> ' + count + '</li>')
                    }
                }
                $(type).append(f);
                $('.filters').append(type)
            }
        }
        $('ul', '.current-search').empty();
        var list = $('ul', '.current-search');
        for (var i in $scope.selected_filters) {
            if ($scope.selected_filters.hasOwnProperty(i) && i != 'searchquery') {
                var type = i;
                if ($scope.selected_filters[type].length > 0) {
                    for (var j = 0; j < $scope.selected_filters[type].length; j++) {
                        var value = $scope.selected_filters[type][j];
                        var text_value = $('li[data-value="' + value + '"] > .value', '.filters').first().text();
                        if (text_value != "") {
                            var item = $('<li>' + text_value + '</li>').data('type', type).data('value', value);
                            list.append(item)
                        }
                    }
                }
            }
        }
        var query_input = $("#search_query").val();
        if (query_input != "") {
            $scope.selected_filters.searchquery = [];
            $scope.selected_filters.searchquery.push(query_input);
            list.append($('<li>Keyword: ' + query_input + '</li>').data('type', "searchquery").data('value', query_input));
            $("#clear_search_filters").show()
        }
        showMoreLess()
    }
}
function init_discontinued() {
    var $scope = {
        action: '//' + __website + 'ajax/fe_ajax.php',
        selected_filters: [],
        query: '',
        curr_page: 1,
        error_msg: 'There was a problem with your request. Please try again.',
        loadingResults: null,
    }
    loadSearchResults();
    $('#data-collection').on('click', '.prev', function() {
        if ($scope.curr_page > 1) {
            $scope.curr_page--;
            $('.search_page').removeClass('on');
            $('.search_page[data-page="' + $scope.curr_page + '"]').addClass('on');
            $('.pagination .current').text($scope.curr_page)
        }
    });
    $('#data-collection').on('click', '.next', function() {
        var max = $('.search_page').last().data('page');
        if ($scope.curr_page < max) {
            $scope.curr_page++;
            $('.search_page').removeClass('on');
            $('.search_page[data-page="' + $scope.curr_page + '"]').addClass('on');
            $('.pagination .current').text($scope.curr_page)
        }
    });
    $('.submit-search > .submit').on('click', function() {
        var query = $('.search', '.submit-search').val();
        $scope.query = query;
        loadSearchResults()
    });
    $('.submit-search').on('keypress', function(e) {
        if (e.which === 13) {
            var query = $('.search', '.submit-search').val();
            $scope.query = query;
            loadSearchResults()
        }
    });
    $('#filter-details').on('click change', 'li, input[type=checkbox]', function() {
        if ($(this).hasClass('off')) {
            return !1
        }
        var type = $(this).data('type') || $(this).val();
        var opt = $(this);
        $(this).addClass('off').toggleClass('on');
        if ($(this).hasClass('on')) {
            setFilter(type, !0)
        } else {
            setFilter(type, !1)
        }
        setTimeout(function() {
            $(opt).removeClass('off')
        }, 500)
    });
    $('.clear_all_filters').on('click', function() {
        $scope.selected_filters.length = 0;
        $scope.query = '';
        $('.search, .submit-search').val('');
        $('#filter-details input[type=checkbox]').prop('checked', !1).removeClass('on');
        loadSearchResults()
    })
    $('.display-filter-summary').on('click', '.trigger', function() {
        var item = $(this).parent('li');
        var type = $(item).data('type');
        setFilter(type, !1)
    });
    function setFilter(type, is_on) {
        clearTimeout($scope.loadingProducts);
        if (is_on) {
            $scope.selected_filters.push(type)
        } else {
            var index = $scope.selected_filters.indexOf(type);
            if (index > -1) {
                $scope.selected_filters.splice(index, 1)
            }
        }
        var count = 0;
        $scope.loadingProducts = setTimeout(function() {
            loadSearchResults()
        }, 750)
    }
    function showCurrentFilters() {
        $('li', '#filter-details').removeClass('on');
        $('.display-filter-summary').empty();
        for (var i = 0; i < $scope.selected_filters.length; i++) {
            var type = $scope.selected_filters[i];
            var item = $('li[data-type="' + type + '"], input[type=checkbox][value="' + type + '"]', '#filter-details');
            var name = $('h3', item).text() || item.next('label').text();
            var li = $('<li><span class="trigger">&times;</span><span class="name">' + name + '</span></li>').data('type', type);
            $('.display-filter-summary').append(li);
            $(item).addClass('on')
        }
    }
    function loadSearchResults() {
        var url = $scope.action + '?action=loadDiscontinuedProducts';
        var PostDATA = {
            filters: $scope.selected_filters,
            query: $scope.query,
        }
        $.post(url, PostDATA, function(response) {
            var data = isJSONSTR(response);
            if (data) {
                var results = data.results;
                $scope.curr_page = 1;
                $('#data-collection').html(results);
                $('.search_page').first().addClass('on');
                showCurrentFilters()
            } else {}
            setTimeout(refreshGoogleTranslate, 500)
        })
    }
}
function Pager(container) {
    var self = this;
    this.container = $(container);
    this.pageitems = this.container.data('pageitems') || 5;
    this.children = this.container.find('.toto-pro-products').length ? this.container.find('.toto-pro-products').children() : this.container.children();
    this.pageCurrent = 0;
    this.pageTotal = Math.ceil(this.children.length / this.pageitems);
    this.container.append('<nav aria-label="navigation" class="pager-navi"> <button type="button" class="prev">Prev</button><div class="current-display"><span class="current">1</span> of <span class="total">1</span></div><button type="button" class="next">Next</button> </nav>')
    this.navi = this.container.find('.pager-navi');
    this.naviPrev = this.container.find('.pager-navi .prev');
    this.naviPrev.on('click', function() {
        self.pagePrev()
    })
    this.naviNext = this.container.find('.pager-navi .next');
    this.naviNext.on('click', function() {
        self.pageNext()
    })
    this.naviPage = this.container.find('.pager-navi span.current');
    this.naviTotal = this.container.find('.pager-navi span.total');
    self.pageNext()
}
Pager.prototype.pageNext = function() {
    this.pageCurrent++;
    this.page()
}
Pager.prototype.pagePrev = function() {
    this.pageCurrent--;
    this.page()
}
Pager.prototype.page = function() {
    var lo = (this.pageitems * (this.pageCurrent - 1));
    var hi = lo + this.pageitems;
    this.children.each(function(i, e) {
        if (i >= lo & i < hi)
            $(e).fadeIn();
        else
            $(e).hide()
    })
    this.updateUI()
}
Pager.prototype.updateUI = function() {
    this.navi.toggle(this.pageTotal > 1);
    const enable = el => el.removeClass('disabled').prop('disabled', !1).removeAttr('aria-tabindex');
    const disable = el => el.addClass('disabled').prop('disabled', !0).attr('aria-tabindex', '-1');
    if (this.pageCurrent < this.pageTotal)
        enable(this.naviNext);
    else
        disable(this.naviNext);
    if (this.pageCurrent > 1)
        enable(this.naviPrev);
    else
        disable(this.naviPrev);
    this.naviPage.text(this.pageCurrent);
    this.naviTotal.text(this.pageTotal)
}
function TotoPro_module(container) {
    var self = this;
    this.container = $(container);
    this.category = this.container.data('category');
    this.productData = {};
    this.productList = [];
    this.ABCs = this.container.find('.totopro-header .totopro-alpha-filter button');
    this.ABCs.each(function() {
        $(this).on('click', function() {
            self.filter($(this).data('letter'))
        })
    })
    this.sortBox = this.container.find('.totopro-header select');
    this.sortBox.on('change', function() {
        self.sort()
    });
    this.searchBox = this.container.find('.totopro-header input[type="text"]');
    this.searchBox.on('keypress', function(e) {
        if (e.which === 13) {
            self.query()
        }
    });
    this.searchButton = this.container.find('.totopro-header .search-wrapper button');
    this.searchButton.on('click', function() {
        self.query()
    })
    this.contentContainer = this.container.find('.totopro-content');
    this.query()
}
TotoPro_module.prototype.sort = function() {
    var order = this.sortBox.val() == 'az' ? 1 : -1;
    this.productList = this.productList.sort(function(a, b) {
        var aName = a.name.toLowerCase();
        var bName = b.name.toLowerCase();
        return (aName.localeCompare(bName) * order)
    });
    this.updateUI()
}
;
TotoPro_module.prototype.filter = function(letter) {
    this.productList = [];
    this.ABCs.each(function() {
        var highlighted = $(this).data('letter') == letter;
        $(this).toggleClass('highlighted', highlighted).attr("aria-current", highlighted ? 'true' : 'false')
    });
    if (letter && letter.match(/[A-Z]/)) {
        for (var key in this.productData)
            if (this.productData[key].name.substr(0, 1).toLowerCase() == letter.toLowerCase())
                this.productList.push(this.productData[key])
    } else
        for (var key in this.productData)
            this.productList.push(this.productData[key])
    this.sort();
}
;
TotoPro_module.prototype.query = function() {
    var self = this;
    var url = '//' + __website + 'ajax/fe_ajax.php?action=loadProResults&type=' + this.category
    var PostDATA = {
        query: this.searchBox.val()
    }
    this.contentContainer.append('<img class="loader" src="' + __CDNBASEURL__ + '/images/ajax-loader.gif"/>');
    $.post(url, PostDATA, function(response) {
        var data = isJSONSTR(response);
        if (data) {
            self.productData = data.results;
            self.filter()
        } else {}
        setTimeout(refreshGoogleTranslate, 500)
    })
}
TotoPro_module.prototype.updateUI = function() {
    this.contentContainer.empty();
    if (this.productList.length > 0) {
        let products_list = $('<ul class="toto-pro-products"></ul>');
        for (var i = 0; i < this.productList.length; i++) {
            products_list.append(this.buildProduct(this.productList[i]))
        }
        this.contentContainer.append(products_list)
    } else {
        this.contentContainer.find('.toto-pro-products').append('No Records Found')
    }
    this.contentContainer.pager = new Pager(this.contentContainer)
}
;
TotoPro_module.prototype.buildProduct = function(product) {
    var html = '';
    html += '<li class="product">';
    html += '<div role="group" aria-label="product">';
    html += '  <div class="description">';
    html += '    <div class="thumbnail">';
    if (product.thumbnail != '')
        html += '<img src="' + product.thumbnail + '" alt="">';
    html += '</div>';
    html += '    <div class="text">';
    html += '      <h4><a class="name" href="' + product.productUrl + '">' + product.name + '</a></h4>';
    html += '      <div class="sku">SKU: ' + product.sku + '</div>';
    html += '      <div class="actions">';
    html += '	      <button class="compare prodcompare" data-click="AddToCompare" data-sid="' + product.sid + '" data-imgname="https://assets.totousa.com/' + product.sku + '/images/' + product.scene7_images + '_285_285.webp" data-prodname="' + product.name + '">COMPARE</button>';
    html += '      	<button class="wheretobuy" onclick="$(this).next().toggle();$(this).attr(\'aria-expanded\', $(this).attr(\'aria-expanded\') == \'true\' ? \'false\' : \'true\')" aria-controls="wtb-form-' + product.sid + '" aria-expanded="false">WHERE TO BUY</button>';
    html += '				<form id="wtb-form-' + product.sid + '" action="' + location.protocol + '//www.totousa.com/find-a-showroom" method="get" target="_blank">';
    html += '					<h5><span>WHERE TO BUY</span></h5>';
    html += '					<input type="hidden" name="sku" value="' + product.sku + '">';
    html += '					<label for="wtb-zip-' + product.sid + '">Enter Zip Code for Showroom Location</label>';
    html += '					<div class="input-wrapper">';
    html += '					<input autocomplete="postal-code" id="wtb-zip-' + product.sid + '" type="text" name="distance[postal_code]" value="" placeholder="Zip Code">';
    html += '					<input type="submit" value="GO">';
    html += '					</div>';
    html += '				</form>'
    html += '			 </div>';
    html += '    </div>';
    html += '  </div>';
    if (product.files) {
        var dl1 = [];
        for (var key in product.files)
            if (product.files.hasOwnProperty(key))
                dl1.push({
                    url: key,
                    filename: product.files[key]
                });
        dl1 = dl1.sort(function(a, b) {
            return a.filename.localeCompare(b.filename)
        })
        html += '  <div class="downloads">';
        html += '	<div class="heading">';
        html += '    	<h5>Available Downloads & Specs</h5>';
        html += '    	<button type="button" class="download-all-specs" data-sid="' + product.sid + '"><i class="material-icons" aria-hidden="true">download</i>Download All</button>';
        html += '	</div>';
        html += '<ul class="columns specs-list">';
        for (var i = 0; i < dl1.length; i++) {
            html += '<li><a href="' + dl1[i].url + '" role="group" aria-label="spec">' + dl1[i].filename + '</a></li>'
        }
        html += '  </ul>';
        html += '  </div>'
    }
    html += '	<div style="clear:both;"></div>';
    html += '</div>';
    html += '</li>';
    return html
}
function showMoreLess() {
    $('.filters ul[data-filter]').each(function(k, ul) {
        ul = $(ul);
        if ($('li', ul).length > 5 && ul.attr('data-filter') != 'Product Categories') {
            ul.addClass('hiddenFilters').removeClass('showingFilters');
            $('li', ul).each(function(_k, li) {
                li = $(li);
                if (_k >= 5) {
                    li.css("display", "none")
                }
            });
            var lk = '<li class="toggleFilters showMore"><p class="sr-only">Activating the button below will reveal more items before it.</p><a role="button" href="#" onclick="showMoreFilters(this); return false;">Show more <span></span></a></li>';
            ul.append(lk)
        }
    })
}

function showMoreFilters(el) {
    el = $(el);
    var ul = $(el.parents('ul')[0]);
    if ($('li', ul).length > 5) {
        ul.removeClass('hiddenFilters');
        ul.addClass('showingFilters');
        $('li:not(.toggleFilters)', ul).each(function(_k, li) {
            li = $(li);
            if (_k >= 5) {
                li.slideDown(function() {
                    var lk = $('.toggleFilters', ul);
                    lk.removeClass('showMore');
                    lk.addClass('hideMore');
                    lk.attr('onclick', "hideFilters(this); return false;");
                    $('a', lk).html('Show fewer <span></span>')
                })
            }
        })
    }
}
function gateDialog(e) {
    var dialog = $(e.target).closest('[role="dialog"], .gate');
    if (!dialog.length)
        return;
    if (!dialog.attr('aria-label') && !dialog.attr('aria-labelledby')) {
        let label = getLastModalTrigger().text();
        if (label)
            dialog.attr('aria-label', label);
    }
    if (!dialog[0].contains(e.target)) {
        dialog.attr('tabindex', '-1');
        dialog[0].focus()
    }
    let focusableElements = dialog.find("[role='button'], button:visible, .close, .featherlight-close, video, iframe, a, input:not([type='hidden'])").not('[tabindex=-1]');
    let firstFocusableElement = focusableElements[0];
    let lastFocusableElement = focusableElements[focusableElements.length - 1];
    if (e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
        e.preventDefault();
        lastFocusableElement.focus()
    } else if ((e.target == lastFocusableElement && e.key == 'Tab' && !e.shiftKey) || (e.target == dialog[0] && e.key == 'Tab' && e.shiftKey)) {
        e.preventDefault();
        firstFocusableElement.focus()
    }
}
$.fn.blink = function() {
    this.animate({
        opacity: 0.1
    }, 500).animate({
        opacity: 1
    }, 500)
}
$.fn.stickyAside = function() {
    var args = arguments
      , options = args.length ? args[0] : {}
      , defaults = {
        resetCss: {},
        main: null,
        addMainMargins: !0,
        bottomOffset: 0,
        breakpoints: null
    };
    options = $.extend(!0, {}, defaults, options);
    this.each(function(k, element) {
        element = $(element);
        var parent = element.parent()
          , main = options.main || element.next()
          , headerHeight = $('header').outerHeight()
          , elementWidth = element.width()
          , elementOuterWidth = element.outerWidth()
          , elementOriginalHeight = element.height()
          , elementHeight = element.height()
          , elementOuterHeight = element.outerHeight()
          , legalWidth = !0
          , ww = $(window).innerWidth()
          , wh = $(window).innerHeight()
          , safeHeight = wh - headerHeight
          , customScrollbar = null
          , mouseIn = !1
          , is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        simpleScrollInit();
        parent.css({
            position: "relative"
        });
        checkWidth();
        element.on('mouseenter mouseleave', function(e) {
            if (e.type == 'mouseenter') {
                mouseIn = !0
            } else {
                mouseIn = !1
            }
        });
        $(window).on('resize', checkWidth).on('scroll', stick);
        $('body').on('scroll', stick);
        function checkWidth() {
            elementWidth = parent.width();
            ww = $(window).innerWidth();
            if (options.breakpoints) {
                if (options.breakpoints.min && ww <= options.breakpoints.min) {
                    legalWidth = !1;
                    $(window).trigger('scroll')
                } else {
                    legalWidth = !0;
                    $(window).trigger('scroll')
                }
            }
        }
        function simpleScrollInit() {
            if (typeof SimpleBar != 'undefined' && !customScrollbar) {
                var cont_wrapper = $('.inner-cont', element);
                if (!cont_wrapper.length)
                    return;
                cont_wrapper.css({
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    "overflow-x": "hidden",
                    "box-sizing": "border-box"
                });
                customScrollbar = new SimpleBar(cont_wrapper[0],{
                    autoHide: !1
                });
                $(customScrollbar.el).find('.simplebar-track.vertical').css({
                    'right': '5px'
                });
                $(customScrollbar.el).find('.simplebar-content').css({
                    'margin-right': '20px'
                });
                $(customScrollbar.getScrollElement()).on('scroll touchmove mousewheel', function(e) {
                    var box = $(this);
                    var max = (box[0].scrollHeight - box.height());
                    if (e.originalEvent.deltaY > 0 && max <= box.scrollTop() || (box.scrollTop() == 0 && e.originalEvent.deltaY < 0)) {
                        e.preventDefault();
                        e.stopPropagation();
                        return !1
                    }
                })
            } else {
                if (is_safari)
                    $(document).trigger('DOMSubtreeModified');
                if (typeof SimpleBar != 'undefined')
                    customScrollbar.recalculate();
            }
        }
        function stick() {
            if (!main.length)
                return;
            elementHeight = element.height();
            elementOuterHeight = element.outerHeight();
            if (elementHeight > elementOriginalHeight)
                elementOriginalHeight = elementHeight;
            var topPos = main.offset().top
              , scrollHeight = $(document).scrollTop()
              , elementScrollHeight = topPos - scrollHeight
              , parentScrollHeight = main.offset().top - scrollHeight
              , parentHeight = parent.height()
              , parentBottomPos = parentHeight + parentScrollHeight - wh;
            var elementCss = {
                position: "fixed",
                top: headerHeight,
                width: elementWidth,
                "overflow-y": "hidden",
                "overflow-x": "hidden",
                "z-index": 100,
                background: "white",
                bottom: (parentBottomPos < 0 ? parentBottomPos * -1 : 0) + options.bottomOffset
            }
              , resetCss = $.extend(!0, {}, {
                position: "relative",
                top: "auto",
                bottom: "auto",
                overflow: "hidden",
                "z-index": 1
            }, options.resetCss);
            if (!legalWidth) {
                if (element.hasClass('sticked')) {
                    element.removeClass('sticked').css(resetCss).removeAttr('style');
                    if (options.addMainMargins) {
                        main.css({
                            "margin-left": 0
                        })
                    }
                }
                if (customScrollbar) {
                    if (customScrollbar && typeof customScrollbar.unMount != 'undefined')
                        customScrollbar.unMount();
                    $('.simplebar-track', element).remove();
                    $('.simplebar-content > *, .simplebar-scroll-content > *', element).unwrap();
                    customScrollbar = null
                }
                return
            } else {
                simpleScrollInit()
            }
            if (elementScrollHeight <= headerHeight) {
                element.addClass('sticked').css(elementCss);
                if (options.addMainMargins) {
                    main.css({
                        "margin-left": elementOuterWidth
                    })
                }
            }
            var prodSliderH = parseFloat($('#prod-head-slider').outerHeight());
            if (safeHeight < (elementOuterHeight + prodSliderH) || parentBottomPos < 0) {
                var ecss = elementCss;
                element.addClass('sticked').css(ecss);
                if (options.addMainMargins) {
                    main.css({
                        "margin-left": elementOuterWidth
                    })
                }
            }
            if (elementScrollHeight > (headerHeight + prodSliderH) && safeHeight > (elementOriginalHeight + prodSliderH)) {
                element.removeClass('sticked').css(resetCss);
                if (options.addMainMargins) {
                    main.css({
                        "margin-left": 0
                    })
                }
            } else if (elementScrollHeight > headerHeight) {
                element.css({
                    top: elementScrollHeight
                })
            }
            if (customScrollbar) {
                customScrollbar.recalculate()
            }
        }
    })
}
function go2(element) {
    var _no_focus = arguments[1];
    element = $(element);
    if (!element.length)
        return !1;
    var headerH = $('header').outerHeight()
      , secondaryH = ($('.secondary-menu').length ? $('.secondary-menu').outerHeight() : ($('.tabs-nav').length ? $('.tabs-nav').outerHeight() : 0))
      , top = element.offset().top - headerH - secondaryH - 20;
    if (!_no_focus) {
        element.attr('tabindex', '-1');
        element.focus();
        element[0].focus()
    }
    $('html,body').animate({
        scrollTop: top
    }, {
        easing: "linear"
    })
}
function capitalize(string) {
    var lower = string.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.substr(1)
}
var onYouTubeIframeAPIReadyCallbacks = [];
var youtubePlayers = [];
function _setupYoutubeScript() {
    _youtubeReplaceScript(!0);
    setInterval(_youtubeReplaceScript, 250)
}
;function _youtubeReplaceScript(firstLoad) {
    if (typeof firstLoad == "undefined")
        firstLoad = !1;
    if (!firstLoad) {
        $(".hytPlayerWrap[data-ytid] iframe.youtubesearched").each(function() {
            if ($(".hytPlayerWrap[data-ytid='" + $(this).closest(".hytPlayerWrap").data("ytid") + "'] iframe.youtubesearched").length > 1) {
                $(this).addClass("ytcloned")
            }
        });
        $("iframe.youtubesearched.ytcloned").each(function() {
            $(this).removeClass("youtubesearched").removeClass("ytcloned").unwrap().unwrap()
        })
    }
    $("iframe:not(.youtubesearched)").each(function() {
        $(this).addClass("youtubesearched");
        var src = $(this).attr("src");
        if (!src)
            src = "";
        if (src.match(/youtu\.?be/i)) {
            if (!src.match(/\?/i))
                src += "?";
            src += "&enablejsapi=1";
            $(this).attr({
                src: src
            }).wrap("<div class='hytPlayerWrap'></div>").parent().wrap("<div class='hytPlayerWrapOuter'></div>");
            var playerFrame = this;
            var wrap = $(this).parent();
            if (typeof window.hideYTActivated == "undefined") {
                $("<script src='https://www.youtube.com/iframe_api' />").appendTo("head");
                window.YTScriptReady = !1;
                window.onYouTubeIframeAPIReady = function() {
                    window.YTScriptReady = !0;
                    for (var key in onYouTubeIframeAPIReadyCallbacks)
                        onYouTubeIframeAPIReadyCallbacks[key]();
                }
                window.hideYTActivated = !0
            }
            if (firstLoad || !window.YTScriptReady) {
                onYouTubeIframeAPIReadyCallbacks.push(function() {
                    wrap.attr("data-ytid", youtubePlayers.length);
                    youtubePlayers.push(new YT.Player(playerFrame,{
                        events: {
                            'onStateChange': onPlayerStateChange
                        }
                    }))
                })
            } else {
                wrap.attr("data-ytid", youtubePlayers.length);
                youtubePlayers.push(new YT.Player(playerFrame,{
                    events: {
                        'onStateChange': onPlayerStateChange
                    }
                }))
            }
            wrap.on("click", function() {
                var ytid = $(this).attr("data-ytid");
                var player = youtubePlayers[ytid];
                var playerState = player.getPlayerState();
                if (playerState == YT.PlayerState.ENDED)
                    player.seekTo(0);
                else if (playerState == YT.PlayerState.PAUSED)
                    player.playVideo();
            })
        }
    })
}
;var _onPlayerStateChangeHandle = {};
function onPlayerStateChange(event) {
    var playerWrap = $(event.target.a).parent();
    var ytid = playerWrap.attr("data-ytid");
    clearTimeout(_onPlayerStateChangeHandle[ytid]);
    if (event.data == YT.PlayerState.ENDED) {
        playerWrap.addClass("ended")
    } else if (event.data == YT.PlayerState.PAUSED) {
        playerWrap.addClass("paused")
    } else if (event.data == YT.PlayerState.PLAYING) {
        _onPlayerStateChangeHandle[ytid] = setTimeout(function() {
            playerWrap.removeClass("ended");
            playerWrap.removeClass("paused")
        }, 200)
    }
}
;function toto_slide_animation(slider, next, transition, delay) {
    if (slider.hasClass('no-animation'))
        return;
    return;
    var slide = slider.find('.slide').eq(next);
    var dot = slider.find('.slick-dots > li').eq(next);
    $('.graphic .image', slide).css('animation', 'null 0s linear');
    setTimeout(function() {
        $('.graphic .image', slide).css('animation', 'slider-zoom ' + (transition + delay) + 'ms linear')
    }, transition);
    $('.slick-dots button', slider).css('animation', 'null 0s linear');
    $('button', dot).css('animation', 'slider-dot ' + (delay) + 'ms linear')
}
function buildCleanovationHTML() {
    if ($('body[class*="page-cleanovation"]').length) {
        $('.cleanovation-hero .squares > .module_content, [class*=page-cleanovation] .tabs > .module_content').remove();
        $('.cleanovation-hero .squares').prepend('<div class="svg-container">\n' + '<div class="svg-wrapper">\n' + '<svg class="c01" viewBox="0 0 760 760"><circle class="circle circle01" cx="380" cy="380" r="378" /></svg>\n' + '<svg class="c02" viewBox="0 0 760 760"><circle class="circle circle02" cx="380" cy="380" r="378" /></svg>\n' + '<svg class="c03" viewBox="0 0 760 760"><circle class="circle circle03" cx="380" cy="380" r="378" /></svg>\n' + '<svg class="c04" viewBox="0 0 760 760"><circle class="circle circle04" cx="380" cy="380" r="378" /></svg>\n' + '<svg class="c05" viewBox="0 0 760 760"><circle class="circle circle05" cx="380" cy="380" r="378" /></svg>\n' + '<svg class="c06" viewBox="0 0 760 760"><circle class="circle circle06" cx="380" cy="380" r="378" /></svg>\n' + '</div>\n' + '</div>');
        let tiles = $('.cleanovation-hero .squares .tile');
        let grid = $('<div class="cleanovation-grid"></div>');
        if (tiles.length > 6)
            grid.addClass('large');
        tiles.wrapAll(grid);
        $('[class*=page-cleanovation] .tabs, [class*=page-cleanovation] .tab-section').wrapAll('<section class="dark-tabs"></section>');
        $('[class*=page-cleanovation] .tabs .tab').wrapAll('<div class="wrapper"><div class="split"></div></div>');
        $('[class*=page-cleanovation] .tab-block.process').each(function() {
            $(this).find('.use').wrapAll('<div class="split"></div>')
        });
        $('[class*=page-cleanovation] .dark-tabs .tabs .tab').each(function() {
            var t = $(this)
              , c = (t.find('a').attr('href') || "").substring(1);
            if (c && $('[class*=page-cleanovation] .tab-section.' + c).length)
                $('[class*=page-cleanovation] .tab-section.' + c).attr("id", c);
        })
    }
}
$(document).ready(function() {
    initRetailersFinder();
    initAwardsPage();
    initNeorest();
    initSelectInputs();
    $('.marquee-slider').each(function() {
        new MarqueeSlider($(this))
    });
    $('.suite-selector ul li a').on('click', function(e) {
        e.preventDefault();
        var a = $(e.currentTarget)
          , wrap = a.closest('.suite-selector')
          , li = a.closest('li')
          , link = a.attr('href')
          , title = a.data('title');
        if (!li.hasClass('active')) {
            wrap.find('li.active').removeClass('active');
            li.addClass('active');
            wrap.find('.main-link').attr('href', link).find('strong').html(title)
        }
    });
    $.fn.styledSelect = function() {
        if (!this.length)
            return !1;
        this.each(function(k, select) {
            select = $(select);
            var val = select.val()
              , selectedTitle = $('option[value="' + val + '"]').html()
              , options = $('option', select)
              , html = ''
              , oid = 'select-' + (Math.round(Math.random() * 100000))
              , labelledby = select.attr("aria-labelledby")
              , label = select.attr("data-label")
              , lid = 'label-' + (Math.round(Math.random() * 100000))
              , lid2 = 'label-' + (Math.round(Math.random() * 100000));
            var opts_html = '';
            var foid = '';
            options.each(function(k, opt) {
                opt = $(opt);
                var _oid = 'opt-' + (Math.round(Math.random() * 100000));
                if (!foid)
                    foid = _oid;
                opts_html += '<li role="option" id="' + _oid + '" class="option' + (opt.attr('value') == val ? ' selected' : '') + '" data-value="' + opt.attr('value') + '" rel="' + opt.attr('value') + '"' + (opt.attr('value') == val ? ' aria-selected="true"' : '') + '>' + opt.html() + '</li>'
            });
            if (labelledby) {
                lid = labelledby
            } else if (label) {
                html += '<span id="' + lid + '" class="sr-only">' + label + '</span>'
            } else {
                lid = ''
            }
            html += '<div class="styled-select">' + '<button type="button" aria-activedescendant="' + foid + '" aria-labelledby="' + $.trim((lid ? lid + ' ' : '') + lid2) + '" role="combobox" aria-haspopup="listbox" aria-controls="' + oid + '" aria-expanded="false"><span id="' + lid2 + '" class="selected-display selected-text">' + selectedTitle + '</span><span class="arrow-wrap" aria-hidden="true"></span></span></button>';
            html += '<ul class="options" id="' + oid + '" role="listbox" >';
            html += opts_html;
            html += '</ul>';
            html += '</div>';
            var htmlSelect = $(html);
            var select_width = parseInt(select.css('width'));
            var min_width = 120;
            var width = Math.max(select_width + 82, min_width);
            htmlSelect.css({
                width: width + 'px'
            });
            select.hide().before(htmlSelect)
        })
    }
    $('select.styled').styledSelect();
    $(document).on('click', '.module.scroll-down a[href="#"]', function(e) {
        e.preventDefault();
        go2($(e.target.closest('.module')).next('.module'))
    })
});
function initAwardsPage() {
    if ($('.paralax-images').length) {
        $('.paralax-images > .module_content').remove();
        var slides = $('.paralax-images > div');
        slides.first().addClass('active');
        var play = function() {
            var curr = $('.paralax-images > div.active');
            var next = $('.paralax-images > div.active').next();
            next = next.length ? next : $('.paralax-images > div').first();
            curr.removeClass('active');
            next.addClass('active')
        }
        setInterval(function() {
            play()
        }, 5000)
    }
    var logos = $('.main-content-area .section > .module:not(.products-grid):not(.products-grids) img');
    if (logos.length) {
        function logosScroll() {
            var topSpace = ($('header').outerHeight() || 0) + ($('.awards-menu').outerHeight() || 0);
            var stuck = !1;
            logos.each(function() {
                var offtop = $(this).offset().top
                  , top = offtop - window.pageYOffset
                  , stick = top < topSpace + 50;
                if (stick) {
                    stuck = !0;
                    $(this).css('opacity', 0);
                    var sticking = $('.sticking').length ? $('.sticking') : $('<div class="sticking"></div>').appendTo($('body'));
                    sticking.html($(this).clone().css({
                        opacity: 1,
                        width: $(this).width()
                    })[0].outerHTML);
                    sticking.css('top', topSpace)
                } else {
                    $(this).css('opacity', 1)
                }
            });
            if (!stuck && $('.sticking').length)
                $('.sticking').remove();
        }
        $(window).on("scroll", logosScroll);
        $('body').on("scroll", logosScroll)
    }
}
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;secure"
}

function initNeorest() {
    $('.neorest-carousel').each(function() {
        var carousel = $(this);
        var module_content = $('>.module_content', carousel)
        carousel.attr('role', 'region').attr('aria-label', 'carousel');
        carousel.addClass('ready');
        carousel.prepend('<p class="slick-instructions slick-sr-only">This is a carousel. Use the "GO TO" buttons to navigate the carousel.</p>');
        var initBGImage = carousel.css('background-image');
        var style2 = carousel.hasClass('style-2');
        if (style2)
            carousel.addClass('gradient-section');
        var slides = carousel.find('> .module').addClass('slide');
        slides.wrapAll('<div class="slides"></div>');
        var slides_div = carousel.find('.slides');
        $('<div class="slider-nav"><div class="wrapper"><a role="button" href="#" class="prev" tabindex="0"></a></div></div>').insertBefore(slides_div);
        $('<div class="slider-nav"><div class="wrapper"><a role="button" href="#" class="next" tabindex="0"></a></div></div>').insertAfter(slides_div);
        if (!style2)
            carousel.append('<div class="gradient"></div>');
        var slider_nav = carousel.find('.slider-nav');
        var transition = 1000;
        var delay = 6000;
        var SE = $('.slides', carousel);
        var slidesCount = SE.find(' > .module').length;
        SE.on('init', function() {
            SE.removeAttr('role').removeAttr('aria-label')
        });
        var S = SE.slick({
            arrows: !1,
            dots: !1,
            fade: !0,
            limitTabindex: !0
        });
        function updateSliderNav(slide) {
            if (slider_nav.length) {
                var prevSlide = slide > 0 ? slide - 1 : slidesCount - 1;
                var prevSlideE = SE.find('.slide:eq(' + prevSlide + ')');
                var nextSlide = slide < slidesCount - 1 ? slide + 1 : 0;
                var nextSlideE = SE.find('.slide:eq(' + nextSlide + ')');
                var prevNav = slider_nav.find('.prev');
                var nextNav = slider_nav.find('.next');
                var currSlide = SE.find('.slide:eq(' + slide + ')');
                var bgImage = currSlide.attr('data-image') || currSlide.css('background-image');
                if (bgImage == 'none')
                    bgImage = '';
                if (bgImage) {
                    currSlide.attr('data-image', bgImage);
                    currSlide.css('background-image', 'none');
                    carousel.css('background-image', bgImage)
                } else {
                    carousel.css('background-image', initBGImage)
                }
                if (prevSlideE.length) {
                    var title = prevSlideE.find('h3').text() || prevSlideE.find('h2').text();
                    prevNav.attr('data-slide', prevSlide).html(`<span class="sr-only">Go to</span> ` + title + `<i aria-hidden="true"></i>`);
                    if (prevSlide == slide)
                        prevNav.hide();
                    else
                        prevNav.show()
                }
                if (nextSlideE.length) {
                    var title = nextSlideE.find('h3').text() || nextSlideE.find('h2').text();
                    nextNav.attr('data-slide', nextSlide).html(`<span class="sr-only">Go to</span> ` + title + `<i aria-hidden="true"></i>`);
                    if (nextSlide == slide)
                        nextNav.hide();
                    else
                        nextNav.show()
                }
            }
        }
        updateSliderNav(0);
        S.on('beforeChange', function(event, slick, current, next) {
            updateSliderNav(next)
        });
        if (slider_nav.length) {
            slider_nav.find('a').on("click", function(e) {
                e.preventDefault();
                var a = $(e.target).closest('a');
                var isPrev = a.hasClass("prev");
                var currentSlide = S.slick('slickCurrentSlide');
                var prevSlide = currentSlide > 0 ? currentSlide - 1 : slidesCount - 1;
                var nextSlide = currentSlide < slidesCount - 1 ? currentSlide + 1 : 0;
                var slide = isPrev ? prevSlide : nextSlide;
                if (slide != currentSlide) {
                    S.slick('slickGoTo', slide)
                }
            })
        }
    })
}
function NEOSlider(element) {
    this.element = $(element);
    this.parent = this.element.closest('section, [aria-label="carousel"]');
    this.nav_prev = this.parent.find('>.prev');
    this.nav_next = this.parent.find('>.next');
    this.slides = this.element.find('.slide');
    this.slide = 0;
    this.currentSlide = null;
    this.prev = 0;
    this.previousSlide = null;
    this.next = 0;
    this.nextSlide = null;
    this.tm = null;
    this.focusable = 'a, input, button, select, [role="button"], [tabindex="0"]';
    this.init()
}
NEOSlider.prototype = {
    init: function() {
        this.refresh(1);
        this.initEvents()
    },
    refresh() {
        let fresh = arguments[0];
        this.currentSlide = $(this.slides[this.slide]);
        var from = this.currentSlide.hasClass('prev') ? 'left' : 'right';
        var lastCurrent = this.element.find('.current');
        this.element.find('.next').removeClass('next');
        this.element.find('.prev').removeClass('prev');
        this.element.find('.current').addClass('was-current').removeClass('current from-left from-right');
        this.slides.not(`:eq(${this.slide})`).removeAttr('aria-current').attr('aria-hidden', 'true').find(this.focusable).attr('tabindex', '-1');
        this.currentSlide.addClass("prepare from-" + from);
        setTimeout((function() {
            this.currentSlide.removeClass('was-current prepare').addClass("current").removeAttr('aria-hidden').attr('aria-current', 'true').find('[tabindex]').attr('tabindex', '0');
            if (!fresh)
                this.currentSlide.find(this.focusable).first().focus();
            if (this.slides.length > 1) {
                this.prev = this.slide > 0 ? this.slide - 1 : this.slides.length - 1;
                this.previousSlide = $(this.slides[this.prev]);
                this.next = this.slide < this.slides.length - 1 ? this.slide + 1 : 0;
                this.nextSlide = $(this.slides[this.next]);
                if (this.slides.length == 2) {
                    if (this.prev > this.slide || this.slide == this.prev)
                        this.previousSlide = null;
                    if (this.next < this.slide || this.slide == this.next)
                        this.nextSlide = null
                }
                let prev_title = this.previousSlide ? this.previousSlide.attr('data-title') + ' ' + this.previousSlide.attr('data-subtitle') : '';
                let next_title = this.nextSlide ? this.nextSlide.attr('data-title') + ' ' + this.nextSlide.attr('data-subtitle') : '';
                if (this.previousSlide) {
                    this.previousSlide.addClass('prev').removeClass('animate').find('.arrow').attr('tabindex', '0');
                    this.nav_prev.find('.t').html(prev_title).removeAttr('aria-hidden')
                }
                if (this.nextSlide) {
                    this.nextSlide.addClass('next').removeClass('animate').find('.arrow').attr('tabindex', '0');
                    this.nav_next.find('.t').html(next_title).removeAttr('aria-hidden')
                }
                this.endOfAnimation()
            }
        }
        ).bind(this), 200)
    },
    endOfAnimation: function() {
        var callback = arguments[0] || function() {}
        ;
        if (this.tm)
            clearTimeout(this.tm);
        this.tm = setTimeout((function() {
            callback();
            this.element.find('.next, .prev').removeClass('was-current')
        }
        ).bind(this), 1200)
    },
    initEvents: function() {
        this.element.on("click", ".slide.next", this.goToNext.bind(this));
        this.nav_next.on("click", this.goToNext.bind(this));
        this.element.on("click", ".slide.prev", this.goToPrev.bind(this));
        this.nav_prev.on("click", this.goToPrev.bind(this));
        this.element.on('keydown', (function(e) {
            switch (e.key) {
            case 'ArrowLeft':
                e.preventDefault();
                this.goToPrev();
                break;
            case 'ArrowRight':
                e.preventDefault();
                this.goToNext();
                break;
            default:
                break
            }
        }
        ).bind(this))
    },
    goToNext: function() {
        this.slide = this.next;
        this.refresh()
    },
    goToPrev: function() {
        this.slide = this.prev;
        this.refresh()
    }
};
function formatPhoneNumber(phone) {
    var p = String(phone).replace(/[^0-9]/g, '');
    if (p.length == 10)
        phone = `(${p.substring(0, 3)}) ${p.substring(3, 6)}-${p.substring(6, 10)}`;
    return phone
}
$(document).ready(function() {
    initSecondaryMenu();
    initFloatingMenu();
    initSidePanelSection();
    initStickyNav();
    initNiceInput();
    initPlaceholderFields();
});

function initSecondaryMenu() {
    var secondary = $('.secondary-menu:not(nav)');
    if (secondary.length) {
        if (secondary[0].nodeName == 'DIV') {
            secondary = $(changeElementTag(secondary[0], 'nav'));
            secondary.attr('aria-label', 'Secondary')
        }
        if (secondary.find('.right-area ul li').length > 3) {
            secondary.find('.right-area ul').prepend('<li class="submenu-sandwich"><a href="javascript:;" role="button" aria-label="Toggle Submenu"><i class="material-icons open notranslate" aria-hidden="true">menu</i><i class="material-icons close" aria-hidden="true">close</i></a></li>');
            secondary.find('.submenu-sandwich a').on('click', function(e) {
                secondary.toggleClass('on')
            })
        }
    }
}

function initFloatingMenu() {
    $('<a name="top"></a>').insertAfter($('.skip-link'));
    var fm = $('.floating-menu');
    if (fm.length) {
        let cont = fm.find('> .module_content');
        let cont_id = cont[0].id || 'rand_' + Math.round(Math.random() * 100000);
        cont[0].id = cont_id;
        fm.prepend('<button type="button" class="menu-toggle" aria-controls="' + cont_id + '" aria-expanded="false"><span class="text">MENU</span> <i><span></span><span></span></i></button>');
        $('.menu-toggle', fm).on('click', function(e) {
            e.preventDefault();
            fm.toggleClass('on');
            if (fm.hasClass('on')) {
                $(e.currentTarget).attr('aria-expanded', 'true').find('.text').text('CLOSE')
            } else {
                $(e.currentTarget).attr('aria-expanded', 'false').find('.text').text('MENU')
            }
        });
        fm.find('a').on('click', function() {
            fm.removeClass('on');
            fm.find('.menu-toggle .text').text('MENU');
            fm.find('.menu-toggle').attr('aria-expanded', 'false').find('.text').text('MENU')
        })
    }
    function checkMenuToggle() {
        var fm = $('.floating-menu');
        if (!fm.length)
            return;
        var wh = $(window).height();
        var sh = window.scrollY;
        if (sh > wh - 100) {
            $('.menu-toggle', fm).addClass('dark')
        } else
            $('.menu-toggle', fm).removeClass('dark')
    }
    checkMenuToggle();
    $(window).scroll(function() {
        checkMenuToggle()
    })
}
function initVideoHero() {
    var vh = $('.module.videoHero');
    if (vh.length) {
        $('.scroll', vh).on('click', function(e) {
            e.preventDefault();
            go2(vh.next('div'))
        })
    }
}
function initMessageModule() {
    $('.message-section').each(function() {
        var el = $(this);
        var content = '<div class="content">' + el.find('.read-more-modal .module_content').html() + '</div>';
        el.find('a').on("click", function(e) {
            e.preventDefault();
            if (!$('#message-modal').length) {
                $('<div class="message-modal awesome-modal" id="message-modal"></div>').appendTo('body')
            }
            $.featherlight($('#message-modal').html(content), {})
        })
    })
}
function initSidePanelSection() {
    var section = $('.side-panel-section');
    if (!section.length)
        return;
    section.append('<div class="panel"><div class="head"></div><div class="content"></div></div>');
    $(' > .module + .module > .module > .module_content', section).on('click', function(e) {
        var el = $(e.currentTarget);
        if (el.hasClass('selected'))
            return;
        if (section.find('.content video').length)
            section.find('.content video').stop();
        var title = el.html();
        var content = el.next('.module').find('> .module_content').html();
        section.find('.head').html(title);
        section.find('.content').html(content);
        section.find('.selected').removeClass('selected');
        el.addClass('selected');
        section.addClass('on');
        if (section.find('.content video').length)
            section.find('.content video').prop("autoplay", !0);
        var ww = $(window).width();
        if (ww <= 720) {
            go2(section.find('.panel'))
        }
    })
}

function refreshStyledSelect(select) {
    var par = select.closest('.select, .styled-select');
    if (!par.length)
        par = select.prev('.select, .styled-select');
    if (!par.length)
        return;
    var val = select.val();
    var opt = par.find('ul.options li[rel="' + val + '"]');
    if (!opt.length)
        opt = par.find('ul li:first-child');
    var opt_val = opt.attr('rel');
    var title = opt.html();
    par.find('.selected-text').html(title);
    par.find('.options > li[aria-selected]').removeAttr('aria-selected').removeClass('selected');
    opt.attr('aria-selected', 'true').addClass('selected')
}
function initSelectInputs() {
    $('.select').each(function() {
        var select = $(this);
        filterSelect(select);
        if (select.attr('data-filter-field') && select.attr('data-filter-attr')) {
            var fv = select.attr('data-filter-field');
            $(document).on('change', '[name="' + fv + '"]', function(e) {
                filterSelect(select, $(e.target).val())
            })
        }
        var selectInput = select.find('select');
        if (!selectInput.length)
            return;
        var node = (select.find('.styledSelect')[0] || {}).nodeName;
        if (node != 'BUTTON') {
            var html = select.find('.styledSelect').html();
            var txt = select.find('.styledSelect').text().replace('*', '');
            select.find('.styledSelect').replaceWith('<button class="styledSelect" type="button" role="combobox" aria-haspopup="listbox" aria-expanded="false" ><span class="selected-text" id="selected-text-' + (Math.round(Math.random() * 100000)) + '">' + html + '</span><i aria-hidden="true"></i></button>');
            select.find('.styledSelect .form-required').attr('aria-hidden', 'true').insertAfter(select.find('.selected-text'))
        }
        var required = selectInput.attr("aria-required") == "true" || selectInput.prop("required");
        var val = selectInput.val();
        var selID = selectInput[0].id;
        var label = $('[for="' + selectInput[0].id + '"]');
        var labelID = '';
        if (label.length) {
            labelID = label[0].id;
            if (!labelID) {
                labelID = selID + '-label';
                label[0].id = labelID
            }
        }
        var selectedTextID = select.find('.selected-text').attr('id');
        let label_id = $.trim(labelID + (selectedTextID ? ' ' + selectedTextID : ''));
        select.find('ul').attr('role', 'listbox').attr('aria-labelledby', label_id);
        select.find('button').attr('aria-labelledby', label_id);
        select.find('ul li').attr('role', 'option').removeAttr('aria-selected');
        select.find('ul li[rel="' + val + '"]').attr('aria-selected', 'true');
        select.find('button').attr("required", "required")
    })
}
function filterSelect(select) {
    var opts = $(".options li:not('.search'):not('.default')", select);
    var val = arguments[1] ? arguments[1] : '';
    if (opts.length && select.attr('data-filter-field') && select.attr('data-filter-attr')) {
        opts.removeClass('hidden');
        var form = select.closest('form').length ? select.closest('form') : $(document);
        var ipt = $('[name="' + select.attr('data-filter-field') + '"]', form);
        var fv = val || ipt.val();
        var av = select.attr('data-filter-attr');
        select.attr('data-attr-value', fv);
        if (fv)
            $(`.options li:not(.search):not(.default):not([${av}="${fv}"])`, select).addClass('hidden');
    }
}
function initStickyNav() {
    var nav = $('.sticky-nav');
    if (!nav.length)
        return;
    function updateActive() {
        $('ul li.active', nav).removeClass('active');
        $('[href^=#]', nav).each(function(e) {
            var id = $(this).attr('href');
            var el = $(id);
            if (el.length) {
                var rect = el[0].getBoundingClientRect();
                var y = rect.y;
                var y2 = y + el.height();
                var li = $(this).closest('li');
                var wh = $(window).height();
                if ((y > 0 || y2 >= wh) && !$('ul li.active', nav).length) {
                    li.addClass('active')
                } else
                    li.removeClass('active')
            }
        })
    }
    function stick() {
        var top = $('.stick-placeholder').length ? $('.stick-placeholder')[0].getBoundingClientRect().y : nav[0].getBoundingClientRect().y;
        var nh = nav.height() || 0;
        var nmb = parseInt(nav.css('margin-bottom')) || 0;
        var hh = $('header').height();
        if (top <= hh) {
            if (!$('.stick-placeholder').length) {
                var sh = nh + nmb;
                $(`<div class="stick-placeholder" style="height:  ${sh}px"></div>`).insertAfter(nav)
            }
            nav.addClass('sticked').css("top", hh)
        } else {
            $('.stick-placeholder').remove();
            nav.removeClass('sticked').css("top", "unset")
        }
    }
    updateActive();
    stick();
    function scrollCallback() {
        updateActive();
        stick()
    }
    $(window).on("scroll", scrollCallback);
    $('body').on("scroll", scrollCallback)
}
var debounceTimeout = {};
function debounce(func, wait) {
    let immediate = arguments[2] || !1;
    let handle = arguments[3] || 'default';
    return function() {
        let context = this
          , args = arguments;
        let later = function() {
            debounceTimeout[handle] = null;
            if (!immediate)
                func.apply(context, args);
            clearTimeout(debounceTimeout[handle])
        };
        let callNow = immediate && !debounceTimeout[handle];
        if (callNow)
            func.apply(context, args);
        else {
            if (debounceTimeout[handle])
                clearTimeout(debounceTimeout[handle]);
            debounceTimeout[handle] = setTimeout(later, wait)
        }
    }
}
function initRetailersFinder() {
    var par = $('.online-retailers-finder');
    if (!par.length)
        par = $('.online-retailers-wrapper');
    if (!par.length)
        par = $('.module.online-retailer-logos-section');
    if (par.length) {
        var module = par.closest('.module');
        if (module.length)
            module.addClass("online-retailers-container-module");
        par.find('.tab-content.active [name^="country"]').first().prop('checked', !0);
        par.find('.tabs-nav').on('change', function(e, tab, cont) {
            cont.find('[name^="country"]').first().prop('checked', !0).trigger('change')
        })
        $('.category input', par).on('change', function(e) {
            var cat = $(e.currentTarget.closest('.category'));
            var cats = $(this).val().split('|');
            $('.category.active', par).removeClass('active');
            cat.addClass('active');
            $('.step-3').fadeOut().find('.retails-list').html('');
            cat.find('.search-olay').addClass('on');
            $.post('//' + __website + "ajax/fe_ajax.php", {
                action: "get_retailers_products",
                category: cats
            }, function(resp) {
                if (resp.success == !0) {
                    window.prodReviewCalls = [];
                    var html = (resp.data || {}).html;
                    if ($('.products.row', par).hasClass('slick-slider'))
                        $('.products.row', par).slick("unslick");
                    $('.products.row', par).html(html);
                    $('.step-2').fadeIn();
                    $('.products.row', par).slick({
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        arrows: !0,
                        responsive: [{
                            breakpoint: 960,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3
                            }
                        }, {
                            breakpoint: 640,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        }, {
                            breakpoint: 460,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }]
                    });
                    cat.find('.search-olay').removeClass('on');
                    $('.ean').each(function(i, el) {
                        if ($(el).text() !== '') {
                            prodReviewCalls.push($(el).text())
                        }
                    });
                    setTimeout(refreshGoogleTranslate, 500)
                } else if (resp.message) {
                    alert(resp.message)
                }
            }, "json")
        });
        par.on('click keydown', '.product:not(.active)', function(e) {
            if (e.type == 'keydown' && ![' ', 'Enter'].includes(e.key))
                return;
            e.preventDefault();
            window.prodReviewCalls = [];
            var prod = $(e.currentTarget);
            var sid = prod.attr('data-sid');
            var title = prod.find('h3').html();
            var country = par.find('[name=country]:checked').val() || 'US';
            $('.finder .retails-list', par).attr('data-country', country);
            $('.product.active', par).removeClass('active').attr('aria-checked', 'false');
            prod.addClass('active').attr('aria-checked', 'true');
            prod.find('.search-olay').addClass('on');
            $.post('//' + __website + "ajax/fe_ajax.php", {
                action: "get_retailers",
                product: sid
            }, function(resp) {
                if (resp.success == !0) {
                    var html = (resp.data || {}).html;
                    $('.finder .retails-list', par).removeClass("no-results-US no-results-CA").html(html);
                    $('.step-3 .retailers-heading .selected-product-name').html(title);
                    $('.step-3').fadeIn();
                    if (!$('.finder .retails-list [country="US"]:not(.no-results)', par).length) {
                        $('.finder .retails-list', par).addClass("no-results-US");
                        if (!$('.finder .retails-list .no-results[data-country=US]', par).length)
                            $('.finder .retails-list', par).append('<div data-country="US" class="no-results">No Authorized retailers found for United States. Please find a <a href="/find-a-showroom">showroom</a> near you.</div>');
                    }
                    if (!$('.finder .retails-list [country="CA"]:not(.no-results)', par).length) {
                        $('.finder .retails-list', par).addClass("no-results-CA");
                        if (!$('.finder .retails-list .no-results[data-country=CA]', par).length)
                            $('.finder .retails-list', par).append('<div data-country="CA" class="no-results">No Authorized retailers found for Canada. Please find a <a href="/find-a-showroom">showroom</a> near you.</div>');
                    }
                    prod.find('.search-olay').removeClass('on');
                    go2('.step-3:not(.step-separator)');
                    $('.retails-list li:not([country="' + country + '"])', par).attr('aria-hidden', 'true');
                    $('.retails-list li[country="' + country + '"]', par).removeAttr('aria-hidden')
                } else if (resp.message) {
                    alert(resp.message)
                }
                setTimeout(refreshGoogleTranslate, 500)
            }, "json")
        });
        par.on('change', '.countries [name^="country"]', function(e) {
            var checked = par.find('[name^="country"]:checked');
            var country = checked.val() || 'US';
            $('.retails-list li:not([country="' + country + '"])', par).attr('aria-hidden', 'true');
            $('.retails-list li[country="' + country + '"]', par).removeAttr('aria-hidden');
            $('.retails-list ', par).attr('data-country', country);
            $('.retails-list ', par).each(function() {
                let rl = $(this);
                let heading = rl.prev('.authorized-retailers-heading');
                let main_heading = par.find('.retailers-heading');
                let preferred = rl.hasClass('preferred-retails-list');
                let empty = !rl.find('li[country="' + country + '"]').length;
                if (empty) {
                    heading.hide();
                    rl.hide();
                    if (preferred && main_heading.length)
                        main_heading.addClass('empty');
                } else {
                    heading.show();
                    rl.css('display', 'flex');
                    if (main_heading.length && preferred)
                        main_heading.removeClass('empty');
                }
            })
        })
    }
}
function initNiceInput() {
    refreshNiceInput();
    $(document).off('click', '.nice.input.quantity button').on('click').on('click', '.nice.input.quantity button', function(e) {
        e.preventDefault();
        let input = $(e.target).closest('.nice.input').find('input');
        let v = parseInt(input.val() || 0);
        let nv = e.currentTarget.classList.contains('increase') ? v + 1 : (v > 0 ? v - 1 : 0);
        input.val(nv).trigger('change')
    })
}
function refreshNiceInput() {
    let container = arguments[0] || document;
    let inputs = $(container).find('.nice.input:not(.is-select2) [name]');
    if (inputs.length) {
        inputs.each(function() {
            var ipt = $(this);
            ipt.off('change blur focusin click keyup').on('change blur focusin keyup', function(e) {
                checkInput(e.target)
            });
            checkInput(ipt)
        });
        function checkInput(input) {
            input = $(input);
            var val = input.val();
            var has_placeholder = !!input.attr('placeholder');
            var focused = input[0] == document.activeElement;
            input.closest('.input').toggleClass('has-value', !!val).toggleClass('focused', focused).toggleClass('has-placeholder', has_placeholder)
        }
    }
}
function initNewsletterForm() {
    var form = $('.newsletter-form');
    if (form.length) {
        $(form[0].description).on('change', function(e) {
            if (!this.value || /consumer/i.test(String(this.value))) {
                form.find('#s-company-wrapper').addClass('disabled').find('#s-company').removeAttr('aria-required').removeClass('required').prop('disabled', !0).val('');
                form.find('#s-company-wrapper .star').addClass('hidden')
            } else {
                form.find('#s-company-wrapper .star').removeClass('hidden');
                form.find('#s-company-wrapper').removeClass('disabled').find('#s-company').attr('aria-required', 'true').addClass('required').prop('disabled', !1)
            }
        });
        form.on("submit", function(e) {
            e.preventDefault();
            $('.message', form).remove();
            form.addClass('force-message');
            if (validate_form_required(form)) {
                grecaptcha.ready(function() {
                    grecaptcha.execute(__reCAPTCHA_SITE_KEY__, {
                        action: 'submit'
                    }).then(function(token) {
                        $('button', form).addClass("disabled");
                        $.ajax({
                            type: "POST",
                            url: '//' + __website + 'ajax/fe_form_ajax.php?action=submitNewsletter',
                            dataType: 'json',
                            data: $(".newsletter-form").serialize() + '&token=' + token,
                            success: function(response) {
                                if (response.success) {
                                    form.append('<div class="message success" role="alert"><span aria-hidden="true"></span>Thank you for signing up for the newsletter! Your request has been received.</div>').show();
                                    reset_form(".newsletter-form")
                                } else {
                                    form.append('<div class="message error" role="alert">' + (response.message || "Unknown error!") + '</div>')
                                }
                            },
                            complete: function() {
                                $('button', form).removeClass("disabled")
                            }
                        })
                    }, function(error) {
                        console.log('ERROR', error)
                    })
                })
            }
        });
        form.on("submit", function(e) {
            e.preventDefault();
            form.addClass('force-message');
            submitNewsletterForm(form)
        })
    }
}
function submitNewsletterForm(form) {
    return new Promise( (resolve, reject) => {
        form = $(form);
        $('.message', form).remove();
        if (validate_form_required(form)) {
            grecaptcha.ready(function() {
                grecaptcha.execute(__reCAPTCHA_SITE_KEY__, {
                    action: 'submit'
                }).then(function(token) {
                    $('button', form).addClass("disabled");
                    $.ajax({
                        type: "POST",
                        url: '//' + __website + 'ajax/fe_form_ajax.php?action=submitNewsletter',
                        dataType: 'json',
                        data: form.serialize() + '&token=' + token,
                        success: function(response) {
                            if (response.success) {
                                form.append('<div class="message success" role="alert"><span aria-hidden="true"></span>Thank you for signing up for the newsletter! Your request has been received.</div>').show();
                                reset_form(form);
                                resolve()
                            } else {
                                form.append('<div class="message error" role="alert">' + (response.message || "Unknown error!") + '</div>');
                                reject()
                            }
                        },
                        error: function() {
                            form.append('<div class="message error" role="alert">We were unable to process your request!</div>');
                            reject()
                        },
                        complete: function() {
                            $('button', form).removeClass("disabled")
                        }
                    })
                }, function(error) {
                    console.log('ERROR', error);
                    reject()
                })
            })
        } else
            reject()
    }
    )
}
async function getProductReviews(EAN) {
    return new Promise(function(resolve, reject) {
        if (EAN != '' && EAN != null && EAN != undefined) {
            var jqXHR = $.ajax({
                type: "POST",
                url: '//' + __website + 'ajax/fe_ajax.php?action=getProductReviews',
                data: "EAN=" + EAN,
                dataType: 'json',
                beforeSend: function(jqXHR) {
                    $.xhrPool.push(jqXHR)
                },
                success: function(data) {
                    if (data.success === !0) {
                        $("span.ean:contains('" + EAN + "')").next().replaceWith(data.html)
                    }
                    resolve()
                },
                error: function() {
                    reject()
                },
                complete: function(jqXHR, textStatus) {
                    $.xhrPool.splice($.xhrPool.indexOf(jqXHR), 1)
                }
            })
        } else
            resolve()
    }
    )
}
function initPlaceholderFields() {
    function checkInputs() {
        $('.placeholder-input, .form-item.checkbox').each(function() {
            var ipt = $(this);
            var field = ipt.find('[name]');
            var type = field.attr('type');
            var name = field.attr('name');
            var val = ['checkbox', 'radio'].includes(type) ? (ipt.find(`[name="${name}"]:checked`).val() || "") : field.val();
            var error_el = ipt.find('.error-msg');
            var label = $('[for="' + field[0].id + '"]') || field.closest('label');
            var label_id = label.length ? (label.attr('id') || 'label-' + Math.round(Math.random() * 100000000)) : '';
            label.attr('id', label_id);
            var has_value = ['checkbox', 'radio'].includes(type) ? field.prop('checked') : val;
            if (has_value)
                ipt.addClass('has-value');
            else
                ipt.removeClass('has-value');
            ipt.addClass('is-' + (field[0].nodeName.toLowerCase()));
            if ((field[0].hasAttribute('required') || field[0].hasAttribute('aria-required')) && !error_el.length) {
                field.attr("aria-invalid", "false");
                var error_id = field.attr("aria-errormessage");
                if (!error_id) {
                    error_id = 'error-' + Math.round(Math.random() * 100000000);
                    if (label_id && !label.length)
                        field.attr("aria-labelledby", label_id);
                    field.attr("aria-errormessage", error_id);
                    var error_msg = field.data('error-message');
                    var label = (field[0].id ? $('[for="' + field[0].id + '"]').text() : field.attr('name').replace(/^[a-zA-Z0-9]+/g, ' ')) + " field";
                    let msg = error_msg ? error_msg : `${label} is required`;
                    ipt.append(`<div aria-live="off" class="error-msg sr-only" id="${error_id}">${msg}</div>`)
                }
                error_el = ipt.find('.error-msg')
            }
            if (field.attr('id') == 'product-search' && val != '') {
                field.removeClass('error');
                ipt.removeClass('error')
            }
            if (error_el.length) {
                if (field.hasClass('error') || ipt.hasClass('error')) {
                    field.attr("aria-invalid", "true");
                    error_el.removeClass('sr-only');
                    ipt.addClass('has-error')
                } else {
                    field.attr("aria-invalid", "false");
                    error_el.addClass('sr-only');
                    ipt.removeClass('has-error')
                }
            }
        })
    }
    checkInputs();
    $(document).on('change keyup keydown focus focusout', checkInputs)
}
function accessibleFixes() {
    $('a[href="#"], [rel="modal:open"], a[href^="javascript"], a.video-popup, .video-popup a, [data-featherlight], .featherlight-close').each(function() {
        var role = $(this).attr("role");
        var idx = $(this).attr("tabindex");
        var no_role = $(this).hasClass('no-role');
        var no_tabindex = $(this).hasClass('no-tabindex');
        if (!no_role) {
            if (!role)
                $(this).attr("role", "button");
            if (!idx && !no_tabindex)
                $(this).attr('tabindex', '0');
        }
        $(this).find('img:not([alt])').each(function() {
            $(this).attr("alt", "")
        })
    });
    $('img:not([alt])').each(function() {
        $(this).attr("alt", "")
    });
    $('svg:not([role])').each(function() {
        $(this).attr("role", "image")
    });
    function buttonEnterEvt(e) {
        if (e.key == 'Enter' || e.key == ' ') {
            e.preventDefault();
            $(this).trigger('click')
        }
    }
    $(document).off('keydown', '[role="button"]:not([href]):not(button)', buttonEnterEvt);
    $(document).on('keydown', '[role="button"]:not([href]):not(button):not(.mobile-menu-toggle)', buttonEnterEvt);
    $('.default-btn.pdf').each(function() {
        $(this).prepend('<div class="sr-only">This button opens a PDF file.</div>')
    });
    $('.spaced-grid, .product-grid, .washlet-buy-online-items-container').each(function() {
        var g = $(this);
        var ul = $('<ul></ul>');
        g.find('>.module').each(function() {
            let el = $(changeElementTag(this, 'li'));
            let label = el.attr('aria-label') || 'item';
            el.removeAttr('role').removeAttr('aria-label');
            let children = el.find(" > *");
            if (label == 'item')
                return !0;
            if (children.length == 1 && children[0].tagName != 'A')
                children.attr('role', 'group').attr('aria-label', label);
            else
                children.wrapAll(`<div role="group" aria-label="${label}"></div>`)
        })
        g.find('.grid-line').each(function() {
            $(this.closest('li')).addClass('grid-line').attr('aria-hidden', 'true')
        });
        g.find('>li').appendTo(ul);
        g.append(ul)
    });
    $('.features-grid .tile a + .module').each(function() {
        $(this).html('')
    });
    $('.material-icons, .fas').attr("aria-hidden", "true").addClass('notranslate');
    $('.module.evolution-section, .module.experience-toto-washlet-icons-container').each(function() {
        $(this).find('>.module_content').remove();
        $(this).find('>.module').each(function() {
            let el = $(changeElementTag(this, 'li'));
            let children = el.find(" > *");
            if (children.length == 1 && 0)
                children.attr('role', 'group').attr('aria-label', 'item');
            else if (children.length > 1) {
                children.wrapAll(`<div></div>`)
            }
        });
        changeElementTag(this, 'ul')
    });
    if ($.featherlight) {
        $.featherlight.defaults.afterOpen = function() {
            var inst = this.$instance;
            var id = inst.attr('id') || 'id-' + (Math.round(Math.random() * 100000));
            inst.attr('id', id);
            var label = inst.find('h2, h3').first().text() || 'Modal';
            var label_id = inst.find('h2, h3').first().attr('id');
            inst.attr('role', 'dialog').attr('aria-modal', 'true').attr('tabindex', '-1');
            if (label_id)
                inst.attr('aria-labelledby', label_id);
            else if (label)
                inst.attr('aria-label', label);
            $(document).off('keydown', `#${id}`).on('keydown', `#${id}`, gateDialog);
            changeElementTag(inst.find('.featherlight-close')[0], 'button');
            inst.find('.featherlight-close').attr('tabindex', '0').attr('aria-label', 'Close').attr('type', 'button').addClass('notranslate');
            inst.focus();
            if (LazyInstance) {
                LazyInstance.runHiddenElementsQueue();
                inst.find('[data-lazy]').each( (_, el) => LazyInstance.reObserve(el))
            }
        }
        $.featherlight.defaults.beforeClose = function() {
            focusLastModalTrigger()
        }
    }
    var blocksWraps = $('.module.image-hover-blocks, .module.washlet-latest-items-container');
    if (blocksWraps.length) {
        blocksWraps.each(function() {
            var par = $(this);
            par.find('>.module_content').remove();
            var blocks = par.find('>.module');
            blocks.each(function() {
                var block = $(this);
                var moduleContentEl = block.find('> a > .module_content, > .module_content').first();
                var firstEl = block.find('> a > .module, > .module').first();
                firstEl.addClass('description-element');
                var bgImg = (firstEl.css('background-image') || '').replace(/^url ?\(("|')/, '').replace(/("|')\)$/, '');
                var lastEl = block.find('> a > .module, > .module').last();
                lastEl.addClass('title-element');
                var titleEl = lastEl.find('> .module_content');
                var title = titleEl.html();
                if (!/<h[1-6] +?([^>]+)>/.test(title)) {
                    titleEl.html('<h3>' + title + '</h3>')
                }
                lastEl.insertBefore(moduleContentEl);
                let el = $(changeElementTag(block[0], 'li'));
                el.removeAttr('role').removeAttr('aria-label');
                let children = el.find(" > *");
                if (children.length == 1)
                    children.addClass('inner');
                else if (children.length > 1)
                    children.wrapAll(`<div class="inner"></div>`);
            });
            changeElementTag(par[0], 'ul')
        })
    }
    var smartToiletTechs = $('.module.smart-toilet-tech .video-popup .module_content');
    if (smartToiletTechs.length) {
        smartToiletTechs.each(function() {
            var img = $(this).find('img');
            var txt = $(this).text();
            if (txt && img && !img.attr('alt'))
                img.attr('alt', "");
        })
    }
    var featuredProds = $('.homepage-featured-products .desktopcontent');
    if (featuredProds.length) {
        featuredProds.each(function() {
            var feat = $(this);
            feat.css({
                "text-align": "center"
            });
            var href = feat.find('a').first().attr('href');
            var title = feat.find('h3').text() || feat.find('h4').text();
            var img = feat.find('img');
            if (img.length && title && !img.attr('alt'))
                img.attr('alt', title);
            feat.find('a').each(function() {
                var inner = this.innerHTML;
                $(this).replaceWith(inner)
            });
            feat.html('<a href="' + href + '">' + feat[0].innerHTML + '</a>')
        })
    }
    $('.video-popup a, a.video-popup, [data-featherlight]').each(function() {
        if (!$(this).hasClass('no-role'))
            $(this).attr('role', 'button');
        $(this).on('click', function(e) {
            e.preventDefault();
            setLastModalTrigger(e)
        })
    });
    $('.modal').each(function() {
        $(this).attr('role', 'dialog').attr('aria-modal', 'true').attr('tabindex', '-1')
    });
    var accordions = $('.Accordion').not('.custom');
    if (accordions.length) {
        accordions.each(function() {
            $(this).attr('role', 'presentation');
            var title = $(this).find('> li > .accordion-title');
            var btn = title.find('button');
            var content = $(this).find('> li > .accordion-content');
            var expanded = btn.length ? btn.attr('aria-expanded') : title.attr('aria-expanded') || 'false';
            if (content.length) {
                var id = content[0].id || 'accordion-' + Math.round(Math.random() * 99999);
                content[0].id = id
            }
            if (btn.length)
                btn.attr('aria-controls', id).attr('aria-expanded', expanded);
            else
                title.attr('aria-controls', id).attr('role', 'button').attr('tabindex', '0').attr('aria-expanded', expanded)
        })
    }
    initVideoHero();
    $('.tech-header img').each(function() {
        var img = $(this);
        var alt = img.attr("alt");
        var title = $('.tech-header + .module > .module_content + .module > .module_content h1').text() || $('h1.main-title').text();
        if (!alt)
            img.attr("alt", "");
    });
    $('.new-left-image-content .module_content, .cta-banner .module_content, .detail-section .featured-category .detail').each(function() {
        var module = $(this);
        var h3 = module.find('h3');
        var h3html = h3.length ? h3[0].innerHTML : '';
        var h4 = module.find('h4');
        var h4html = h4.length ? h4[0].innerHTML : '';
        h4.insertAfter(h3);
        h3.html(h4html).addClass('h4');
        h4.html(h3html).addClass('h3')
    });
    $('.short-hero').each(function() {
        var hasDarkText = /color: ?#\d/.test($(this).html());
        if (hasDarkText) {
            $(this).addClass('has-dark-text')
        }
    });
    $('.washlet-latest-products-item').each(function() {
        var item = $(this);
        var content = item.find("> .module_content");
        var last_module = item.find(' > .module').last();
        content.insertAfter(last_module);
        content.find('strong').attr('aria-hidden', 'true')
    });
    $('.module[class*="apply-id-"]').each(function() {
        var id = $(this).attr('class').match(/apply-id-([^ ]+)/)[1];
        if (id) {
            $(this).attr('id', id)
        }
    });
    $('.washlet-buy-online-items-container').each(function() {
        var group = $(this);
        group.find('> .module, > ul > li > div').attr('role', 'group').attr('aria-label', 'product')
    });
    $('.module_content table:not(.compare-table):not([role]):not(.table)').attr('role', 'presentation');
    if ($('.product-v3 #product_pagecontent .compare table').length) {
        const compareTables = document.querySelectorAll('.product-v3 #product_pagecontent .compare table');
        compareTables.forEach(function(table) {
            const firstRow = table.querySelector('tbody.zatabody tr:first-child');
            firstRow.querySelectorAll('td').forEach(function(cell) {
                const thElement = document.createElement('th');
                Array.from(cell.attributes).forEach(attr => {
                    thElement.setAttribute(attr.name, attr.value)
                }
                )
                thElement.setAttribute('scope', 'col');
                thElement.innerHTML = cell.innerHTML;
                cell.parentNode.replaceChild(thElement, cell)
            });
            const allRows = table.querySelectorAll('tbody.zatabody tr:not(:first-child)');
            allRows.forEach(function(row) {
                const firstCell = row.querySelector('td:first-child');
                const thElement = document.createElement('th');
                Array.from(firstCell.attributes).forEach(attr => {
                    thElement.setAttribute(attr.name, attr.value)
                }
                );
                thElement.setAttribute('scope', 'row');
                thElement.innerHTML = firstCell.innerHTML;
                firstCell.parentNode.replaceChild(thElement, firstCell)
            })
        })
    }
    $('.arrow-link-btn, .arrow-link').each(function() {
        $(this).prepend('<i aria-hidden="true"></i>').append('<i aria-hidden="true"></i>')
    });
    setTimeout(checkS7Viewer, 3500);
    skipToElement();
    $('button.what-this:not([aria-controls])').each(function() {
        let btn = $(this);
        let tt = btn.next('.tooltip');
        let tid = tt.attr('id') || 'tooltip-' + (Math.round(Math.random() * 100000));
        tt.attr('id', tid);
        tt.attr('role', 'tooltip');
        btn.attr('aria-controls', tid)
    });
    $('.links-hover-blocks > .module').each(function() {
        var item = $(this);
        var bg = item.css('background-image').replace(/^url ?\(('|")/, '').replace(/('|")\)$/, '');
        if (bg && !['none', 'undefined'].includes(bg)) {
            item.css({
                backgroundImage: "none",
                backgroundColor: "#000"
            }).find('a').append('<div class="img-bg"><img src="' + bg + '" alt="" /></div>').find('.module_content').append('<span aria-hidden="true" class="icon"></span>')
        }
    });
    $('button:not([type])').each(function() {
        this.setAttribute('type', 'button')
    });
    $('.tab-content .module.image-content .module h3').each(function() {
        changeElementTag(this, 'h2')
    })
}
function setLastModalTrigger(e) {
    if (e)
        lastModalTriggerElement.push($(e.target));
}
function getLastModalTrigger() {
    var el = lastModalTriggerElement[lastModalTriggerElement.length - 1];
    if (el.attr('role') != 'button' && !['BUTTON', 'A'].includes(el[0].nodeName)) {
        var new_el = el.closest('[role="button"], a, button, [tabindex]');
        if (new_el.length)
            el = new_el
    }
    return el
}
function focusLastModalTrigger() {
    if (lastModalTriggerElement.length) {
        var el = lastModalTriggerElement.pop();
        if (el.attr('role') != 'button' && !['BUTTON', 'A'].includes(el[0].nodeName)) {
            var new_el = el.closest('[role="button"], a, button, [tabindex]');
            if (new_el.length)
                el = new_el
        }
        el.focus();
        el[0].focus()
    }
}

function skipToElement() {
    var focus_element = $('#main-content > .module.slideshow .first-slider, #main-content > .hero h1, #main-content > .short-hero h1, #main-content > .short-hero h2').filter(function() {
        return $(this).css('display') != 'none'
    });
    if (!focus_element.length) {
        focus_element = $('#main-content > *').not('script').not('noscript').not('stype').not('.sr-only').first()[0]
    } else
        focus_element = focus_element[0];
    if (focus_element) {
        if (focus_element.id)
            $('.skip-link').attr('href', '#' + focus_element.id);
        else {
            $('#start-element').attr('id', '');
            focus_element.id = 'start-element';
            $('.skip-link').attr('href', '#start-element')
        }
        if (!/^(?:a|select|input|button|textarea)$/i.test(focus_element.tagName)) {
            focus_element.tabIndex = -1
        }
    }
    return focus_element
}
function skipToMainContent() {
    var e = arguments[0];
    if (e)
        e.preventDefault();
    var focus_element = skipToElement();
    if (focus_element)
        go2(focus_element);
}
function loadVideosResults(el) {
    var init = arguments[1] || !1;
    var list = $('.videos', $(el));
    var page = Number(list.attr('data-page') || 1);
    var per_page = Number(list.attr('data-per_page') || 15);
    var total = Number(list.find('li').length);
    var curr_page = Math.ceil(Number(list.find('li:not(.not-in-result):not(.hidden)').length) / per_page);
    var curr_video = list.attr('data-current-video');
    var videos = list.find('li');
    var categories = [];
    $('li input:checked', $(el)).each(function() {
        categories.push(this.value)
    });
    if (!categories.length)
        videos.removeClass('not-in-result');
    else {
        videos.each(function() {
            var found = !1;
            var li = $(this);
            var attr = li.attr('data-categories');
            categories.forEach(function(c) {
                if ((new RegExp(c)).test(attr))
                    found = !0
            });
            if (!found)
                li.addClass('not-in-result');
            else
                li.removeClass('not-in-result')
        })
    }
    var found = videos.not('.not-in-result');
    var total_pages = Math.ceil(found.length / per_page);
    page = total_pages < page ? total_pages : page;
    var total_found = found.length;
    var to_show = page * per_page;
    if (to_show > total_found)
        to_show = total_found;
    if (!init)
        $(el).find('.videos-section h2').html(`Showing ${to_show} of ${total_found} Videos`);
    var focusElement = page > curr_page ? found[curr_page * per_page] : null;
    found.each(function(i) {
        if (i < to_show) {
            $(this).removeClass('hidden');
            let imgWrap = $(this).find('[data-lazy-img]');
            if (!imgWrap.find('img').length) {
                imgWrap.html(`<img src="${imgWrap.attr('data-lazy-img')}" alt="" />`)
            }
        } else
            $(this).addClass('hidden')
    });
    if (curr_video && init) {
        let a = list.find(`a[href$="${curr_video}"]`);
        if (a.length) {
            focusElement = a[0];
            go2(focusElement);
            a.click()
        }
    }
    if (focusElement && !init) {
        let a = focusElement.querySelector('a');
        if (a)
            focusElement = a;
        focusElement.focus();
        go2(focusElement)
    }
    if (total_pages == page) {
        $(el).find('.buttons-wrap').addClass('hidden')
    } else
        $(el).find('.buttons-wrap').removeClass('hidden')
}
function initVideosGallery() {
    $('.videos-gallery').each(function() {
        let vids = $(this).find('.videos');
        if (!vids.attr('data-page'))
            vids.attr('data-page', 1);
        loadVideosResults(this, !0)
    });
    $(document).on('change', '.videos-gallery .categories input', function(e) {
        var g = this.closest('.videos-gallery');
        var v = $(g).find('.videos');
        v.attr('data-page', 1);
        loadVideosResults(this.closest('.videos-gallery'))
    });
    $(document).on('click', '.videos-gallery .load-more-videos', function(e) {
        e.preventDefault();
        var g = this.closest('.videos-gallery');
        var v = $(g).find('.videos');
        var p = Number(v.attr('data-page') || 1);
        v.attr('data-page', p + 1);
        loadVideosResults(g)
    })
}
$(document).ready(function() {
    initTranscripts()
});
function initTranscripts() {
    $(document).on('click', '.video-wrap .transcript-toggle', function(e) {
        e.preventDefault();
        var toggle = $(this);
        var close = $(e.target).closest('.video-wrap').find('transcript .close');
        var tgt = $('#' + toggle.attr('aria-controls'));
        var open = toggle.attr('aria-expanded') == 'true';
        if (open) {
            tgt.attr('aria-expanded', 'false');
            toggle.attr('aria-expanded', 'false').focus();
            close.attr('tabindex', '-1')
        } else {
            tgt.attr('aria-expanded', 'true');
            toggle.attr('aria-expanded', 'true');
            close.removeAttr('tabindex')
        }
    });
    $(document).on('click', '.video-wrap transcript .close', function(e) {
        e.preventDefault();
        $(e.target).attr('tabindex', '-1');
        var toggle = $(e.target).closest('.video-wrap').find('.transcript-toggle');
        var tgt = $('#' + toggle.attr('aria-controls'));
        tgt.attr('aria-expanded', 'false');
        toggle.attr('aria-expanded', 'false').focus()
    })
}
function checkS7Viewer() {
    $('#s7basiczoom_div_zoomView canvas').attr('role', 'img').attr('aria-label', 'Zoomable main product image');
    $('#s7basiczoom_div_zoomView_hint').addClass('sr-only').show();
    var txt = $('#s7basiczoom_div_zoomView_hint').html() || "";
    $('#s7basiczoom_div_zoomView_hint').html(txt.replace(/\+/, 'plus').replace(/\-/, 'minus'))
}
function checkResponsiveAccordions() {
    var accordions = $('.Accordion.responsive');
    if (accordions.length) {
        if (is_mobile) {
            accordions.attr("role", "presentation");
            accordions.each(function() {
                var ac = $(this);
                var lis = ac.find('> li');
                lis.each(function() {
                    var li = $(this);
                    var cont = li.find('> .accordion-content');
                    var head = li.find('> .accordion-title');
                    if (!head.attr('aria-controls')) {
                        var content_id = cont.attr('id') || 'accordion-' + Math.round(Math.random() * 99999);
                        cont.attr('id', content_id);
                        head.attr('aria-controls', content_id).attr('aria-expanded', 'false')
                    }
                    if (head[0].nodeName != 'BUTTON') {
                        head.attr('data-node', head[0].nodeName);
                        changeElementTag(head[0], 'button')
                    }
                })
            })
        } else {
            accordions.removeAttr("role");
            accordions.each(function() {
                var ac = $(this);
                var lis = ac.find('> li');
                lis.each(function() {
                    var li = $(this);
                    var head = li.find('> .accordion-title');
                    if (head.attr('aria-controls')) {
                        head.removeAttr('aria-controls').removeAttr('aria-expanded')
                    }
                    if (head[0].nodeName == 'BUTTON') {
                        var node = head.attr('data-node') || 'h3';
                        changeElementTag(head[0], node)
                    }
                })
            })
        }
    }
}
function getResultsCountMessage(count) {
    count = count || 0;
    let ns = ["Zero", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten"];
    let res_count = typeof ns[count] != 'undefined' ? ns[count] : count;
    return res_count + ' result' + (count == 1 ? '' : 's') + ' found'
}
function Lazy() {
    this.observer = null;
    this.mutation_observer = null;
    this.hiddenQueue = [];
    this.observing_queue = !1;
    this.init()
}
Lazy.prototype = {
    init() {
        $(document).ready( () => {
            this.setEvents()
        }
        )
    },
    setEvents() {
        let elements = $("[data-lazy]");
        if (elements.length) {
            elements.each( (i, element) => {
                let alt = $.trim(element.getAttribute('alt'));
                if (alt && !element.innerText)
                    element.innerHTML = `<span class="sr-only">${alt}</span>`;
                this.observe(element)
            }
            )
        }
    },
    createObserver() {
        if (this.observer)
            return this.observer;
        let options = {
            root: null,
        };
        this.observer = new IntersectionObserver( (entries, observer) => {
            entries.forEach( (entry) => {
                this.onVisibilityChange(entry.target, entry.intersectionRatio > 0);
                if (!this.visible(entry.target)) {
                    this.addToHiddenQueue(entry.target)
                }
            }
            )
        }
        );
        return this.observer
    },
    getObserver() {
        return this.observer || this.createObserver()
    },
    visible(element) {
        let visible = !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length) && this.inViewport(element);
        return visible
    },
    inViewport(element) {
        let rect = element.getBoundingClientRect();
        let inViewport = (rect.bottom >= 0 && rect.right >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight) && rect.left <= (window.innerWidth || document.documentElement.clientWidth));
        return inViewport
    },
    createMutationObserver() {
        if (this.mutation_observer)
            return this.mutation_observer;
        let options = {
            attributes: !0,
            childList: !0,
            subtree: !0
        };
        this.mutation_observer = new MutationObserver(debounce(this.runHiddenElementsQueue.bind(this), !1, 1000, "observer"));
        this.mutation_observer.observe(document.querySelector("main"), options);
        return this.mutation_observer
    },
    getMutationObserver() {
        return this.mutation_observer || this.createMutationObserver()
    },
    observe(element) {
        if (Boolean(element.dataset.observing))
            return;
        element.dataset.observing = !0;
        this.getObserver().observe(element)
    },
    reObserve(element) {
        if (element.hasAttribute("data-observing")) {
            element.removeAttribute("data-observing");
            this.getObserver().unobserve(element)
        }
        this.observe(element)
    },
    unobserve(element) {
        element.removeAttribute("data-lazy");
        element.removeAttribute("data-observing");
        element.removeAttribute("data-src");
        element.removeAttribute("data-queue-id");
        this.getObserver().unobserve(element)
    },
    onVisibilityChange(element, visible) {
        if (visible || this.visible(element))
            this.loadElement(element);
    },
    addToHiddenQueue(element) {
        this.createMutationObserver();
        let qid = "queue-" + Math.round(Math.random() * 1000000);
        element.dataset.queueId = qid;
        this.hiddenQueue.push(qid)
    },
    removeFromQueue(id) {
        this.hiddenQueue.forEach( (_id, i) => {
            if (_id == id) {
                let idx = this.hiddenQueue.findIndex( (e) => e == id);
                this.hiddenQueue.splice(idx, 1)
            }
        }
        )
    },
    runHiddenElementsQueue() {
        if (this.observing_queue || !this.hiddenQueue.length)
            return;
        this.observing_queue = !0;
        (new Promise(resolve => {
            if (this.hiddenQueue.length) {
                var queue = JSON.parse(JSON.stringify(this.hiddenQueue));
                const runQueue = function() {
                    if (!queue.length) {
                        resolve();
                        return
                    }
                    let rm = !1;
                    let id = queue.shift();
                    let elements = document.querySelectorAll(`[data-queue-id="${id}"]`);
                    if (elements.length) {
                        elements.forEach(element => {
                            let visible = this.visible(element);
                            if (visible) {
                                this.removeFromQueue.call(this, id);
                                this.onVisibilityChange(element, visible)
                            }
                        }
                        )
                    } else
                        this.removeFromQueue.call(this, id);
                    runQueue.call(this)
                }
                runQueue.call(this)
            } else {
                this.mutation_observer.disconnect();
                resolve()
            }
        }
        )).finally( () => {
            this.checkUntracked().finally( () => {
                this.observing_queue = !1
            }
            )
        }
        )
    },
    checkUntracked() {
        return new Promise( (resolve) => {
            let not_queued = $("[data-lazy]:not([data-queue-id])");
            if (not_queued.length) {
                not_queued.each( (i, element) => {
                    let visible = this.visible(element);
                    if (visible)
                        this.onVisibilityChange(element, visible);
                    if (i == not_queued.length - 1)
                        resolve();
                }
                )
            } else
                resolve()
        }
        )
    },
    loadElement(element) {
        let type = element.dataset.lazy || "image";
        let tag = element.nodeName.toLowerCase();
        let image = element.src || element.dataset.src;
        if (image) {
            this.unobserve(element);
            switch (type) {
            case "image":
            case "img":
                if (tag == "img")
                    element.src = image;
                else {
                    let re = new RegExp(`^<${tag}`,"gi");
                    let ree = new RegExp(`< ?/?${tag}>$`,"gi");
                    let div = document.createElement("div");
                    div.innerHTML = element.outerHTML.replace(re, "<img").replace(ree, "");
                    let img = div.querySelector("img");
                    img.src = image;
                    element.replaceWith(img)
                }
                break;
            case "background":
            case "bg":
                element.style.backgroundImage = `url('${image}')`;
                break;
            default:
                console.log("unsupported lazy type. " + type);
                break
            }
        }
    }
}
var LazyInstance = new Lazy();
function downloadProductSpecs(sid) {
    if (!sid)
        return;
    let btns = $(`.download-all-specs[data-sid="${sid}"]`);
    btns.prop('disabled', !0).addClass('disabled');
    $.post('//' + __website + "ajax/fe_ajax.php?action=download_product_specifications", {
        sid: sid
    }, resp => {
        if (resp.success) {
            let link = resp.data.link;
            window.location = link
        } else {
            alert("Unable to download specifications!")
        }
    }
    , 'json').always( () => {
        btns.prop('disabled', !1).removeClass('disabled')
    }
    )
}
$('.scroll-wrapper, .scroll-carousel').each(function() {
    let carousel = this;
    if (!this.classList.contains('scroll-carousel') && !this.closest('.scroll-carousel')) {
        $(this).removeAttr('role').removeAttr('aria-label');
        $(this).wrap('<div class="scroll-carousel"></div>');
        carousel = this.closest('.scroll-carousel');
        $('.scroll-wrapper > * ', carousel).addClass('items')
    }
    $('.items', carousel).slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: !1,
        arrows: !0,
        gap: 10,
        infinite: !1,
        responsive: [{
            breakpoint: 860,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                gap: 10
            }
        }, {
            breakpoint: 420,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                gap: 10
            }
        }]
    })
});
function __positionImageHotspotArrow(btn, cont) {
    let arrow = $(cont).find('.arrow');
    let rect = btn.getBoundingClientRect();
    let cont_rect = cont.getBoundingClientRect();
    let arrow_left = Math.abs(cont_rect.x - rect.x) + 8;
    arrow.css({
        top: '-15px',
        left: arrow_left + 'px'
    })
}
function initImageHotspots() {
    let modules = $('.module.hotspots');
    if (!modules.length)
        return;
    positionImageHotspots();
    $(window).on('resize', debounce(positionImageHotspots, 1000, !1, 'positionhotspots'));
    function __close(btn) {
        btn.setAttribute('aria-expanded', 'false');
        let cont = document.getElementById(btn.getAttribute('aria-controls'));
        if (cont)
            cont.classList.add('hidden');
    }
    function __open(btn) {
        __closeAll();
        btn.setAttribute('aria-expanded', 'true');
        let cont = document.getElementById(btn.getAttribute('aria-controls'));
        if (cont) {
            cont.classList.remove('hidden');
            __positionImageHotspotArrow(btn, cont)
        }
    }
    function __closeAll() {
        let btns = $('.module.hotspots > .module_content button[aria-expanded=true]');
        if (btns.length)
            btns.each(function() {
                __close(this)
            })
    }
    $('body').on('click', function(e) {
        let btns = $('.module.hotspots > .module_content button[aria-expanded=true]');
        if (btns.length && !e.target.closest('.module.hotspots') || e.target.tagName != 'BUTTON') {
            __closeAll()
        }
    });
    $('.module.hotspots > .module_content button').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        let btn = e.currentTarget;
        let expanded = btn.getAttribute('aria-expanded') === 'true';
        if (expanded) {
            __close(btn)
        } else {
            __open(btn)
        }
    })
}
function positionImageHotspots() {
    let modules = $('.module.hotspots');
    if (!modules.length)
        return;
    let ww = $(window).width();
    modules.each(function() {
        let mod = $(this);
        let mod_rect = this.getBoundingClientRect();
        let buttons = $(this).find('.module_content button');
        let contents = $(this).find('.module');
        buttons.attr('aria-expanded', 'false');
        contents.removeAttr('style').removeClass('hidden');
        contents.css('opacity', '0');
        buttons.each(function(i) {
            let css = {
                top: 0,
                left: 'unset',
                right: 'unset'
            };
            let btn = $(this);
            let rect = this.getBoundingClientRect();
            let h = rect.height;
            let w = rect.width;
            let offset = 20;
            let top = (rect.y - mod_rect.y) + h + offset;
            let left = rect.x - mod_rect.x;
            let cont = $(contents[i]);
            if (!cont.length)
                return;
            if (!cont.hasClass('initialized')) {
                cont.addClass('initialized');
                cont.insertAfter(btn)
            }
            let cont_rect = cont[0].getBoundingClientRect();
            let cont_w = cont_rect.width || (mod.hasClass('small') ? 400 : mod_rect.width);
            let overflowing = (rect.x + cont_w) > ww;
            if (overflowing)
                css.right = '0';
            else
                css.left = left + 'px';
            css.top = top + 'px';
            let id = cont.attr('id') || 'cont-' + Math.round(Math.random() * 10000);
            cont.css(css).attr('id', id);
            this.setAttribute('aria-controls', id);
            let arrow = cont.find('.arrow');
            if (!arrow.length)
                arrow = $('<div class="arrow"></div>').appendTo(cont);
            __positionImageHotspotArrow(this, cont[0])
        });
        contents = $(this).find('.module');
        contents.addClass('hidden').css('opacity', '1')
    })
}
function initMikMak() {
    if (document.querySelector('[data-mm-wtbid]')) {
        (function(e, d) {
            try {
                var a = window.swnDataLayer = window.swnDataLayer || {};
                a.appId = e || a.appId,
                a.eventBuffer = a.eventBuffer || [],
                a.loadBuffer = a.loadBuffer || [],
                a.push = a.push || function(e) {
                    a.eventBuffer.push(e)
                }
                ,
                a.load = a.load || function(e) {
                    a.loadBuffer.push(e)
                }
                ,
                a.dnt = a.dnt != null ? a.dnt : d;
                var t = document.getElementsByTagName("script")[0]
                  , n = document.createElement("script");
                n.async = !0,
                n.src = "//wtb-tag.mikmak.ai/scripts/" + a.appId + "/tag.min.js",
                t.parentNode.insertBefore(n, t)
            } catch (e) {
                console.log(e)
            }
        }("669948563929500f0b228002", !1))
    }
}
function initBenefitsModule() {
    let modules = $('.benefit-list.tabular');
    if (!modules.length)
        return;
    modules.each(function() {
        let module = $(this);
        module.addClass('initialized');
        let items = module.find('.list-item');
        items.attr('role', 'tabpanel').wrapAll('<div class="panels"></div>');
        items.first().addClass('active');
        let heading = module.find('.module.heading');
        if (heading.length)
            heading.wrap('<div class="left"></div>');
        else
            module.prepend('<div class="left"></div>');
        let tablist = $('<div class="tablist"></div>');
        function __onClick(e) {
            let btn = $(e.currentTarget);
            if (btn.attr('aria-expanded') == 'true')
                return;
            let par = btn.closest('.benefit-list.tabular');
            par.find('[aria-expanded=true]').attr('aria-expanded', 'false');
            par.find('.list-item.active').removeClass('active');
            btn.attr('aria-expanded', 'true');
            let p = btn.attr('aria-controls');
            par.find(`.list-item#${p}`).addClass('active')
        }
        items.each(function(i) {
            let id = this.id || 'item-' + Math.round(Math.random() * 10000);
            this.id = id;
            let h = this.querySelector('.module_content + .module .module_content');
            if (h) {
                let x = i == 0 ? 'true' : 'false';
                let button = $(`<button type="button" aria-controls="${id}" aria-expanded="${x}">${h.innerHTML}</button>`);
                button.on('click', __onClick)
                tablist.append(button)
            }
        });
        module.find('.left').append(tablist)
    })
}
function initFourTilesContentModule() {
    let modules = $('.module.four-tiles-content');
    if (!modules.length)
        return;
    modules.each(function() {
        $(this).find('.tiles > .module').attr('tabindex', '0')
    })
}
function initCardsSliderContentModule() {
    let modules = $('.module.cards-slider-content');
    if (!modules.length)
        return;
    modules.each(function() {
        let module = $(this);
        let slide = module.find('> .module > .module > .module');
        slide.find('> .module_content').remove();
        slide.append('<div class="module filler"></div>');
        slide.slick({
            slidesToShow: 3,
            slidesToScroll: 2,
            infinite: !1,
            prevArrow: '<button class="slick-prev" type="button">' + '<i class="material-icons" aria-hidden="true">chevron_left</i>' + '<span class="slick-sr-only">Previous</span>' + '</button>',
            nextArrow: '<button class="slick-next" type="button">' + '<i class="material-icons" aria-hidden="true">chevron_right</i>' + '<span class="slick-sr-only">Next</span>' + '</button>',
            responsive: [{
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }]
        })
    })
}
function hereGeocode(addr, funcCall) {
    if (!herePlatform) {
        console.error('Error using here.com api. Scripts are not loaded. Make sure this page has Maps::addScripts().');
        return
    }
    if (!addr.country) {
        if (addr.zip.match(/^[0-9]{5}(\-([0-9]{1,})?)?$/i))
            addr.country = 'usa';
        else if (addr.zip.match(/^[0-9a-z\s]{6,}/i))
            addr.country = 'ca';
        else
            addr.country = 'usa'
    }
    var geocoder = herePlatform.getSearchService()
      , geocodingParameters = {
        qq: 'postalCode=' + addr.zip + ';country=' + addr.country,
    };
    geocoder.geocode(geocodingParameters, funcCall, funcCall)
}
;function hereReverseGeocode(cord, funcCall) {
    if (!herePlatform) {
        console.error('Error using here.com api. Scripts are not loaded. Make sure this page has Maps::addScripts().');
        return
    }
    var geocoder = herePlatform.getSearchService()
      , reverseGeocodingParameters = {
        at: cord.lat + ',' + cord.lng + ',75',
        limit: '1'
    };
    geocoder.reverseGeocode(reverseGeocodingParameters, funcCall, funcCall)
}
function observeHeaderPosition() {
    const body = document.querySelector("body");
    const observer = new MutationObserver( (mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.attributeName === "style") {
                positionHeader()
            }
        }
    }
    );
    observer.observe(body, {
        attributes: !0,
        attributeFilter: ["style"]
    })
}
function positionHeader() {
    const body = document.querySelector("body");
    const mt = body.style.marginTop || 0;
    const header = document.querySelector('header.main');
    if (header)
        header.style.top = mt;
    positionDropdowns();
    $(window).off('resize', positionDropdowns).on('resize', positionDropdowns)
}
function positionDropdowns() {
    const ww = window.innerWidth;
    const mt = document.body.style.marginTop || 0;
    const mt_n = parseFloat(mt);
    const dropdowns = document.querySelectorAll('header.main .menu-item .dropdown');
    dropdowns.forEach(dropdown => {
        dropdown.style.top = ((ww > 1650 ? 42 : 34) + mt_n) + 'px'
    }
    )
    const mobile_menu = document.querySelector('header.main .split .right');
    if (mobile_menu) {
        mobile_menu.style.top = ww <= 1200 ? (34 + mt_n) + "px" : ""
    }
}
function refreshGoogleTranslate() {
    const getNewURL = function(url) {
        if (url && !/^(http|\/\/|#|javascript)/.test(url)) {
            const base = location.protocol + '//' + location.hostname;
            let search = location.search;
            url = url.replace(/^\//, '');
            return base + '/' + url + (/\?/.test(url) && search ? search.replace(/^\?/, '&') : search)
        }
        return url
    }
    document.querySelectorAll('.material-icons:not(.notranslate)').forEach(i => i.classList.add('notranslate'));
    if (typeof google !== "undefined" && google.translate) {
        const anchors = document.querySelectorAll('[href]');
        anchors.forEach(a => {
            const href = a.getAttribute('href');
            const new_href = getNewURL(href);
            if (href !== new_href)
                a.setAttribute('href', new_href);
            if (a.classList.contains('prodcompare'))
                a.setAttribute("href", "#");
        }
        );
        const forms = document.querySelectorAll('form[method="get" i]');
        forms.forEach(form => {
            const action = form.getAttribute("action");
            const new_action = getNewURL(action);
            if (action !== new_action)
                form.setAttribute("action", new_action);
        }
        );
        if (!window.updating_lang) {
            window.updating_lang = !0
            const htmlTag = document.documentElement;
            const current_lang = htmlTag.lang;
            htmlTag.lang = "en";
            setTimeout( () => {
                htmlTag.lang = current_lang;
                window.updating_lang = !1
            }
            , 100)
        }
        $(document).off('click', '.retailers-list .retailer a, .retails-list .online-retailer a').on('click', '.retailers-list .retailer a, .retails-list .online-retailer a', function(e) {
            e.preventDefault();
            let a = $(e.target).closest('a');
            let href = a.data('url') || a.attr('href');
            let onclick = a.attr('onclick');
            if (onclick && /^ga\('send',[a-zA-Z0-9'",\s\.]+Link'\);$/.test(onclick))
                eval(onclick);
            if (href)
                window.open(href);
        })
    }
}
function fixUnsupportedModals() {
    $('[rel="modal:open"]:not(.bob)').each(function() {
        const href = this.getAttribute('href') || '';
        const modal = document.getElementById(href.substring(1));
        this.setAttribute('href', '#');
        this.removeAttribute('rel');
        if (modal) {
            const close = modal.querySelector('[rel="modal:close"]');
            if (close)
                close.remove();
            modal.removeAttribute('role');
            modal.removeAttribute('aria-modal');
            modal.removeAttribute('tabindex')
        }
        $(this).on('click', function(e) {
            e.preventDefault();
            $.featherlight($(modal), {
                variant: 'in-content-modal',
                persist: !0,
                afterContent() {
                    this.$content.find('.modal_contents').removeAttr('tabindex');
                    if (typeof $.featherlight.defaults.afterContent != 'undefined')
                        $.featherlight.defaults.afterContent.apply(this);
                },
                afterOpen() {
                    if (typeof $.featherlight.defaults.afterOpen != 'undefined')
                        $.featherlight.defaults.afterOpen.apply(this);
                    let slicks = this.$content.find('.slick-slider');
                    if (slicks.length) {
                        slicks.slick('refresh')
                    }
                }
            })
        })
    })
}


